"use client";
import { C as e, D as t, E as n, S as r, T as i, _ as a, a as o, b as s, c, d as l, f as u, g as d, h as f, i as p, l as m, m as h, n as g, o as _, p as v, r as y, s as b, t as x, u as S, v as C, w, x as T, y as E } from "./sfx-CKGwEQrr.js";
import { a as D, i as O, n as k, r as A } from "./registration-BkPgmtZ2.js";
import { Suspense as j, createContext as ee, memo as te, useCallback as M, useContext as N, useEffect as P, useId as F, useLayoutEffect as I, useMemo as L, useRef as R, useState as ne, useSyncExternalStore as re } from "react";
import { Fragment as z, jsx as B, jsxs as V } from "react/jsx-runtime";
import { animate as ie, motion as ae, useMotionValue as oe, useTransform as se } from "motion/react";
import { uniformInt as ce } from "pure-rand/distribution/uniformInt";
import { QueryClient as le, useMutation as ue, useQuery as de } from "@tanstack/react-query";
//#region ../../node_modules/zod/v4/core/core.js
var fe;
function H(e, t, n) {
	function r(n, r) {
		if (n._zod || Object.defineProperty(n, "_zod", {
			value: {
				def: r,
				constr: o,
				traits: /* @__PURE__ */ new Set()
			},
			enumerable: !1
		}), n._zod.traits.has(e)) return;
		n._zod.traits.add(e), t(n, r);
		let i = o.prototype, a = Object.keys(i);
		for (let e = 0; e < a.length; e++) {
			let t = a[e];
			t in n || (n[t] = i[t].bind(n));
		}
	}
	let i = n?.Parent ?? Object;
	class a extends i {}
	Object.defineProperty(a, "name", { value: e });
	function o(e) {
		var t;
		let i = n?.Parent ? new a() : this;
		r(i, e), (t = i._zod).deferred ?? (t.deferred = []);
		for (let e of i._zod.deferred) e();
		return i;
	}
	return Object.defineProperty(o, "init", { value: r }), Object.defineProperty(o, Symbol.hasInstance, { value: (t) => n?.Parent && t instanceof n.Parent ? !0 : t?._zod?.traits?.has(e) }), Object.defineProperty(o, "name", { value: e }), o;
}
var pe = class extends Error {
	constructor() {
		super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
	}
}, me = class extends Error {
	constructor(e) {
		super(`Encountered unidirectional transform during encode: ${e}`), this.name = "ZodEncodeError";
	}
};
(fe = globalThis).__zod_globalConfig ?? (fe.__zod_globalConfig = {});
var he = globalThis.__zod_globalConfig;
function ge(e) {
	return e && Object.assign(he, e), he;
}
//#endregion
//#region ../../node_modules/zod/v4/core/util.js
function _e(e) {
	let t = Object.values(e).filter((e) => typeof e == "number");
	return Object.entries(e).filter(([e, n]) => t.indexOf(+e) === -1).map(([e, t]) => t);
}
function ve(e, t) {
	return typeof t == "bigint" ? t.toString() : t;
}
function U(e) {
	return { get value() {
		{
			let t = e();
			return Object.defineProperty(this, "value", { value: t }), t;
		}
	} };
}
function ye(e) {
	return e == null;
}
function be(e) {
	let t = +!!e.startsWith("^"), n = e.endsWith("$") ? e.length - 1 : e.length;
	return e.slice(t, n);
}
function xe(e, t) {
	let n = e / t, r = Math.round(n), i = 2 ** -52 * Math.max(Math.abs(n), 1);
	return Math.abs(n - r) < i ? 0 : n - r;
}
var Se = /* @__PURE__*/ Symbol("evaluating");
function W(e, t, n) {
	let r;
	Object.defineProperty(e, t, {
		get() {
			if (r !== Se) return r === void 0 && (r = Se, r = n()), r;
		},
		set(n) {
			Object.defineProperty(e, t, { value: n });
		},
		configurable: !0
	});
}
function Ce(e, t, n) {
	Object.defineProperty(e, t, {
		value: n,
		writable: !0,
		enumerable: !0,
		configurable: !0
	});
}
function we(...e) {
	let t = {};
	for (let n of e) {
		let e = Object.getOwnPropertyDescriptors(n);
		Object.assign(t, e);
	}
	return Object.defineProperties({}, t);
}
function Te(e) {
	return JSON.stringify(e);
}
function Ee(e) {
	return e.toLowerCase().trim().replace(/[^\w\s-]/g, "").replace(/[\s_-]+/g, "-").replace(/^-+|-+$/g, "");
}
var De = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {};
function Oe(e) {
	return typeof e == "object" && !!e && !Array.isArray(e);
}
var ke = /* @__PURE__*/ U(() => {
	if (he.jitless || typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare")) return !1;
	try {
		return Function(""), !0;
	} catch {
		return !1;
	}
});
function Ae(e) {
	if (Oe(e) === !1) return !1;
	let t = e.constructor;
	if (t === void 0 || typeof t != "function") return !0;
	let n = t.prototype;
	return Oe(n) !== !1 && Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") !== !1;
}
function je(e) {
	return Ae(e) ? { ...e } : Array.isArray(e) ? [...e] : e instanceof Map ? new Map(e) : e instanceof Set ? new Set(e) : e;
}
var Me = /* @__PURE__*/ new Set([
	"string",
	"number",
	"symbol"
]);
function Ne(e) {
	return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Pe(e, t, n) {
	let r = new e._zod.constr(t ?? e._zod.def);
	return (!t || n?.parent) && (r._zod.parent = e), r;
}
function G(e) {
	let t = e;
	if (!t) return {};
	if (typeof t == "string") return { error: () => t };
	if (t?.message !== void 0) {
		if (t?.error !== void 0) throw Error("Cannot specify both `message` and `error` params");
		t.error = t.message;
	}
	return delete t.message, typeof t.error == "string" ? {
		...t,
		error: () => t.error
	} : t;
}
function Fe(e) {
	return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
var Ie = {
	safeint: [-(2 ** 53 - 1), 2 ** 53 - 1],
	int32: [-2147483648, 2147483647],
	uint32: [0, 4294967295],
	float32: [-34028234663852886e22, 34028234663852886e22],
	float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function Le(e, t) {
	let n = e._zod.def, r = n.checks;
	if (r && r.length > 0) throw Error(".pick() cannot be used on object schemas containing refinements");
	return Pe(e, we(e._zod.def, {
		get shape() {
			let e = {};
			for (let r in t) {
				if (!(r in n.shape)) throw Error(`Unrecognized key: "${r}"`);
				t[r] && (e[r] = n.shape[r]);
			}
			return Ce(this, "shape", e), e;
		},
		checks: []
	}));
}
function Re(e, t) {
	let n = e._zod.def, r = n.checks;
	if (r && r.length > 0) throw Error(".omit() cannot be used on object schemas containing refinements");
	return Pe(e, we(e._zod.def, {
		get shape() {
			let r = { ...e._zod.def.shape };
			for (let e in t) {
				if (!(e in n.shape)) throw Error(`Unrecognized key: "${e}"`);
				t[e] && delete r[e];
			}
			return Ce(this, "shape", r), r;
		},
		checks: []
	}));
}
function ze(e, t) {
	if (!Ae(t)) throw Error("Invalid input to extend: expected a plain object");
	let n = e._zod.def.checks;
	if (n && n.length > 0) {
		let n = e._zod.def.shape;
		for (let e in t) if (Object.getOwnPropertyDescriptor(n, e) !== void 0) throw Error("Cannot overwrite keys on object schemas containing refinements. Use `.safeExtend()` instead.");
	}
	return Pe(e, we(e._zod.def, { get shape() {
		let n = {
			...e._zod.def.shape,
			...t
		};
		return Ce(this, "shape", n), n;
	} }));
}
function Be(e, t) {
	if (!Ae(t)) throw Error("Invalid input to safeExtend: expected a plain object");
	return Pe(e, we(e._zod.def, { get shape() {
		let n = {
			...e._zod.def.shape,
			...t
		};
		return Ce(this, "shape", n), n;
	} }));
}
function Ve(e, t) {
	if (e._zod.def.checks?.length) throw Error(".merge() cannot be used on object schemas containing refinements. Use .safeExtend() instead.");
	return Pe(e, we(e._zod.def, {
		get shape() {
			let n = {
				...e._zod.def.shape,
				...t._zod.def.shape
			};
			return Ce(this, "shape", n), n;
		},
		get catchall() {
			return t._zod.def.catchall;
		},
		checks: t._zod.def.checks ?? []
	}));
}
function He(e, t, n) {
	let r = t._zod.def.checks;
	if (r && r.length > 0) throw Error(".partial() cannot be used on object schemas containing refinements");
	return Pe(t, we(t._zod.def, {
		get shape() {
			let r = t._zod.def.shape, i = { ...r };
			if (n) for (let t in n) {
				if (!(t in r)) throw Error(`Unrecognized key: "${t}"`);
				n[t] && (i[t] = e ? new e({
					type: "optional",
					innerType: r[t]
				}) : r[t]);
			}
			else for (let t in r) i[t] = e ? new e({
				type: "optional",
				innerType: r[t]
			}) : r[t];
			return Ce(this, "shape", i), i;
		},
		checks: []
	}));
}
function Ue(e, t, n) {
	return Pe(t, we(t._zod.def, { get shape() {
		let r = t._zod.def.shape, i = { ...r };
		if (n) for (let t in n) {
			if (!(t in i)) throw Error(`Unrecognized key: "${t}"`);
			n[t] && (i[t] = new e({
				type: "nonoptional",
				innerType: r[t]
			}));
		}
		else for (let t in r) i[t] = new e({
			type: "nonoptional",
			innerType: r[t]
		});
		return Ce(this, "shape", i), i;
	} }));
}
function We(e, t = 0) {
	if (e.aborted === !0) return !0;
	for (let n = t; n < e.issues.length; n++) if (e.issues[n]?.continue !== !0) return !0;
	return !1;
}
function Ge(e, t = 0) {
	if (e.aborted === !0) return !0;
	for (let n = t; n < e.issues.length; n++) if (e.issues[n]?.continue === !1) return !0;
	return !1;
}
function Ke(e, t) {
	return t.map((t) => {
		var n;
		return (n = t).path ?? (n.path = []), t.path.unshift(e), t;
	});
}
function qe(e) {
	return typeof e == "string" ? e : e?.message;
}
function Je(e, t, n) {
	let r = e.message ? e.message : qe(e.inst?._zod.def?.error?.(e)) ?? qe(t?.error?.(e)) ?? qe(n.customError?.(e)) ?? qe(n.localeError?.(e)) ?? "Invalid input", { inst: i, continue: a, input: o, ...s } = e;
	return s.path ??= [], s.message = r, t?.reportInput && (s.input = o), s;
}
function Ye(e) {
	return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Xe(...e) {
	let [t, n, r] = e;
	return typeof t == "string" ? {
		message: t,
		code: "custom",
		input: n,
		inst: r
	} : { ...t };
}
//#endregion
//#region ../../node_modules/zod/v4/core/errors.js
var Ze = (e, t) => {
	e.name = "$ZodError", Object.defineProperty(e, "_zod", {
		value: e._zod,
		enumerable: !1
	}), Object.defineProperty(e, "issues", {
		value: t,
		enumerable: !1
	}), e.message = JSON.stringify(t, ve, 2), Object.defineProperty(e, "toString", {
		value: () => e.message,
		enumerable: !1
	});
}, Qe = H("$ZodError", Ze), $e = H("$ZodError", Ze, { Parent: Error });
function et(e, t = (e) => e.message) {
	let n = {}, r = [];
	for (let i of e.issues) i.path.length > 0 ? (n[i.path[0]] = n[i.path[0]] || [], n[i.path[0]].push(t(i))) : r.push(t(i));
	return {
		formErrors: r,
		fieldErrors: n
	};
}
function tt(e, t = (e) => e.message) {
	let n = { _errors: [] }, r = (e, i = []) => {
		for (let a of e.issues) if (a.code === "invalid_union" && a.errors.length) a.errors.map((e) => r({ issues: e }, [...i, ...a.path]));
		else if (a.code === "invalid_key") r({ issues: a.issues }, [...i, ...a.path]);
		else if (a.code === "invalid_element") r({ issues: a.issues }, [...i, ...a.path]);
		else {
			let e = [...i, ...a.path];
			if (e.length === 0) n._errors.push(t(a));
			else {
				let r = n, i = 0;
				for (; i < e.length;) {
					let n = e[i];
					i === e.length - 1 ? (r[n] = r[n] || { _errors: [] }, r[n]._errors.push(t(a))) : r[n] = r[n] || { _errors: [] }, r = r[n], i++;
				}
			}
		}
	};
	return r(e), n;
}
//#endregion
//#region ../../node_modules/zod/v4/core/parse.js
var nt = (e) => (t, n, r, i) => {
	let a = r ? {
		...r,
		async: !1
	} : { async: !1 }, o = t._zod.run({
		value: n,
		issues: []
	}, a);
	if (o instanceof Promise) throw new pe();
	if (o.issues.length) {
		let t = new ((i?.Err) ?? e)(o.issues.map((e) => Je(e, a, ge())));
		throw De(t, i?.callee), t;
	}
	return o.value;
}, rt = (e) => async (t, n, r, i) => {
	let a = r ? {
		...r,
		async: !0
	} : { async: !0 }, o = t._zod.run({
		value: n,
		issues: []
	}, a);
	if (o instanceof Promise && (o = await o), o.issues.length) {
		let t = new ((i?.Err) ?? e)(o.issues.map((e) => Je(e, a, ge())));
		throw De(t, i?.callee), t;
	}
	return o.value;
}, it = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		async: !1
	} : { async: !1 }, a = t._zod.run({
		value: n,
		issues: []
	}, i);
	if (a instanceof Promise) throw new pe();
	return a.issues.length ? {
		success: !1,
		error: new (e ?? Qe)(a.issues.map((e) => Je(e, i, ge())))
	} : {
		success: !0,
		data: a.value
	};
}, at = /* @__PURE__*/ it($e), ot = (e) => async (t, n, r) => {
	let i = r ? {
		...r,
		async: !0
	} : { async: !0 }, a = t._zod.run({
		value: n,
		issues: []
	}, i);
	return a instanceof Promise && (a = await a), a.issues.length ? {
		success: !1,
		error: new e(a.issues.map((e) => Je(e, i, ge())))
	} : {
		success: !0,
		data: a.value
	};
}, st = /* @__PURE__*/ ot($e), ct = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return nt(e)(t, n, i);
}, lt = (e) => (t, n, r) => nt(e)(t, n, r), ut = (e) => async (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return rt(e)(t, n, i);
}, dt = (e) => async (t, n, r) => rt(e)(t, n, r), ft = (e) => (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return it(e)(t, n, i);
}, pt = (e) => (t, n, r) => it(e)(t, n, r), mt = (e) => async (t, n, r) => {
	let i = r ? {
		...r,
		direction: "backward"
	} : { direction: "backward" };
	return ot(e)(t, n, i);
}, ht = (e) => async (t, n, r) => ot(e)(t, n, r), gt = /^[cC][0-9a-z]{6,}$/, _t = /^[0-9a-z]+$/, vt = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, yt = /^[0-9a-vA-V]{20}$/, bt = /^[A-Za-z0-9]{27}$/, xt = /^[a-zA-Z0-9_-]{21}$/, St = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Ct = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, wt = (e) => e ? RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Tt = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Et = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Dt() {
	return new RegExp(Et, "u");
}
var Ot = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, kt = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, At = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, jt = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Mt = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Nt = /^[A-Za-z0-9_-]*$/, Pt = /^https?$/, Ft = /^\+[1-9]\d{6,14}$/, It = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", Lt = /*@__PURE__*/ RegExp(`^${It}$`);
function Rt(e) {
	let t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
	return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function zt(e) {
	return RegExp(`^${Rt(e)}$`);
}
function Bt(e) {
	let t = Rt({ precision: e.precision }), n = ["Z"];
	e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
	let r = `${t}(?:${n.join("|")})`;
	return RegExp(`^${It}T(?:${r})$`);
}
var Vt = (e) => {
	let t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
	return RegExp(`^${t}$`);
}, Ht = /^-?\d+$/, Ut = /^-?\d+(?:\.\d+)?$/, Wt = /^[^A-Z]*$/, Gt = /^[^a-z]*$/, Kt = /*@__PURE__*/ H("$ZodCheck", (e, t) => {
	var n;
	e._zod ??= {}, e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), qt = {
	number: "number",
	bigint: "bigint",
	object: "date"
}, Jt = /*@__PURE__*/ H("$ZodCheckLessThan", (e, t) => {
	Kt.init(e, t);
	let n = qt[typeof t.value];
	e._zod.onattach.push((e) => {
		let n = e._zod.bag, r = (t.inclusive ? n.maximum : n.exclusiveMaximum) ?? Infinity;
		t.value < r && (t.inclusive ? n.maximum = t.value : n.exclusiveMaximum = t.value);
	}), e._zod.check = (r) => {
		(t.inclusive ? r.value <= t.value : r.value < t.value) || r.issues.push({
			origin: n,
			code: "too_big",
			maximum: typeof t.value == "object" ? t.value.getTime() : t.value,
			input: r.value,
			inclusive: t.inclusive,
			inst: e,
			continue: !t.abort
		});
	};
}), Yt = /*@__PURE__*/ H("$ZodCheckGreaterThan", (e, t) => {
	Kt.init(e, t);
	let n = qt[typeof t.value];
	e._zod.onattach.push((e) => {
		let n = e._zod.bag, r = (t.inclusive ? n.minimum : n.exclusiveMinimum) ?? -Infinity;
		t.value > r && (t.inclusive ? n.minimum = t.value : n.exclusiveMinimum = t.value);
	}), e._zod.check = (r) => {
		(t.inclusive ? r.value >= t.value : r.value > t.value) || r.issues.push({
			origin: n,
			code: "too_small",
			minimum: typeof t.value == "object" ? t.value.getTime() : t.value,
			input: r.value,
			inclusive: t.inclusive,
			inst: e,
			continue: !t.abort
		});
	};
}), Xt = /*@__PURE__*/ H("$ZodCheckMultipleOf", (e, t) => {
	Kt.init(e, t), e._zod.onattach.push((e) => {
		var n;
		(n = e._zod.bag).multipleOf ?? (n.multipleOf = t.value);
	}), e._zod.check = (n) => {
		if (typeof n.value != typeof t.value) throw Error("Cannot mix number and bigint in multiple_of check.");
		(typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : xe(n.value, t.value) === 0) || n.issues.push({
			origin: typeof n.value,
			code: "not_multiple_of",
			divisor: t.value,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Zt = /*@__PURE__*/ H("$ZodCheckNumberFormat", (e, t) => {
	Kt.init(e, t), t.format = t.format || "float64";
	let n = t.format?.includes("int"), r = n ? "int" : "number", [i, a] = Ie[t.format];
	e._zod.onattach.push((e) => {
		let r = e._zod.bag;
		r.format = t.format, r.minimum = i, r.maximum = a, n && (r.pattern = Ht);
	}), e._zod.check = (o) => {
		let s = o.value;
		if (n) {
			if (!Number.isInteger(s)) {
				o.issues.push({
					expected: r,
					format: t.format,
					code: "invalid_type",
					continue: !1,
					input: s,
					inst: e
				});
				return;
			}
			if (!Number.isSafeInteger(s)) {
				s > 0 ? o.issues.push({
					input: s,
					code: "too_big",
					maximum: 2 ** 53 - 1,
					note: "Integers must be within the safe integer range.",
					inst: e,
					origin: r,
					inclusive: !0,
					continue: !t.abort
				}) : o.issues.push({
					input: s,
					code: "too_small",
					minimum: -(2 ** 53 - 1),
					note: "Integers must be within the safe integer range.",
					inst: e,
					origin: r,
					inclusive: !0,
					continue: !t.abort
				});
				return;
			}
		}
		s < i && o.issues.push({
			origin: "number",
			input: s,
			code: "too_small",
			minimum: i,
			inclusive: !0,
			inst: e,
			continue: !t.abort
		}), s > a && o.issues.push({
			origin: "number",
			input: s,
			code: "too_big",
			maximum: a,
			inclusive: !0,
			inst: e,
			continue: !t.abort
		});
	};
}), Qt = /*@__PURE__*/ H("$ZodCheckMaxLength", (e, t) => {
	var n;
	Kt.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !ye(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag.maximum ?? Infinity;
		t.maximum < n && (e._zod.bag.maximum = t.maximum);
	}), e._zod.check = (n) => {
		let r = n.value;
		if (r.length <= t.maximum) return;
		let i = Ye(r);
		n.issues.push({
			origin: i,
			code: "too_big",
			maximum: t.maximum,
			inclusive: !0,
			input: r,
			inst: e,
			continue: !t.abort
		});
	};
}), $t = /*@__PURE__*/ H("$ZodCheckMinLength", (e, t) => {
	var n;
	Kt.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !ye(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag.minimum ?? -Infinity;
		t.minimum > n && (e._zod.bag.minimum = t.minimum);
	}), e._zod.check = (n) => {
		let r = n.value;
		if (r.length >= t.minimum) return;
		let i = Ye(r);
		n.issues.push({
			origin: i,
			code: "too_small",
			minimum: t.minimum,
			inclusive: !0,
			input: r,
			inst: e,
			continue: !t.abort
		});
	};
}), en = /*@__PURE__*/ H("$ZodCheckLengthEquals", (e, t) => {
	var n;
	Kt.init(e, t), (n = e._zod.def).when ?? (n.when = (e) => {
		let t = e.value;
		return !ye(t) && t.length !== void 0;
	}), e._zod.onattach.push((e) => {
		let n = e._zod.bag;
		n.minimum = t.length, n.maximum = t.length, n.length = t.length;
	}), e._zod.check = (n) => {
		let r = n.value, i = r.length;
		if (i === t.length) return;
		let a = Ye(r), o = i > t.length;
		n.issues.push({
			origin: a,
			...o ? {
				code: "too_big",
				maximum: t.length
			} : {
				code: "too_small",
				minimum: t.length
			},
			inclusive: !0,
			exact: !0,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), tn = /*@__PURE__*/ H("$ZodCheckStringFormat", (e, t) => {
	var n, r;
	Kt.init(e, t), e._zod.onattach.push((e) => {
		let n = e._zod.bag;
		n.format = t.format, t.pattern && (n.patterns ??= /* @__PURE__ */ new Set(), n.patterns.add(t.pattern));
	}), t.pattern ? (n = e._zod).check ?? (n.check = (n) => {
		t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: t.format,
			input: n.value,
			...t.pattern ? { pattern: t.pattern.toString() } : {},
			inst: e,
			continue: !t.abort
		});
	}) : (r = e._zod).check ?? (r.check = () => {});
}), nn = /*@__PURE__*/ H("$ZodCheckRegex", (e, t) => {
	tn.init(e, t), e._zod.check = (n) => {
		t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "regex",
			input: n.value,
			pattern: t.pattern.toString(),
			inst: e,
			continue: !t.abort
		});
	};
}), rn = /*@__PURE__*/ H("$ZodCheckLowerCase", (e, t) => {
	t.pattern ??= Wt, tn.init(e, t);
}), an = /*@__PURE__*/ H("$ZodCheckUpperCase", (e, t) => {
	t.pattern ??= Gt, tn.init(e, t);
}), on = /*@__PURE__*/ H("$ZodCheckIncludes", (e, t) => {
	Kt.init(e, t);
	let n = Ne(t.includes), r = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
	t.pattern = r, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(r);
	}), e._zod.check = (n) => {
		n.value.includes(t.includes, t.position) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "includes",
			includes: t.includes,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), sn = /*@__PURE__*/ H("$ZodCheckStartsWith", (e, t) => {
	Kt.init(e, t);
	let n = RegExp(`^${Ne(t.prefix)}.*`);
	t.pattern ??= n, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(n);
	}), e._zod.check = (n) => {
		n.value.startsWith(t.prefix) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "starts_with",
			prefix: t.prefix,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), cn = /*@__PURE__*/ H("$ZodCheckEndsWith", (e, t) => {
	Kt.init(e, t);
	let n = RegExp(`.*${Ne(t.suffix)}$`);
	t.pattern ??= n, e._zod.onattach.push((e) => {
		let t = e._zod.bag;
		t.patterns ??= /* @__PURE__ */ new Set(), t.patterns.add(n);
	}), e._zod.check = (n) => {
		n.value.endsWith(t.suffix) || n.issues.push({
			origin: "string",
			code: "invalid_format",
			format: "ends_with",
			suffix: t.suffix,
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), ln = /*@__PURE__*/ H("$ZodCheckOverwrite", (e, t) => {
	Kt.init(e, t), e._zod.check = (e) => {
		e.value = t.tx(e.value);
	};
}), un = class {
	constructor(e = []) {
		this.content = [], this.indent = 0, this && (this.args = e);
	}
	indented(e) {
		this.indent += 1, e(this), --this.indent;
	}
	write(e) {
		if (typeof e == "function") {
			e(this, { execution: "sync" }), e(this, { execution: "async" });
			return;
		}
		let t = e.split("\n").filter((e) => e), n = Math.min(...t.map((e) => e.length - e.trimStart().length)), r = t.map((e) => e.slice(n)).map((e) => " ".repeat(this.indent * 2) + e);
		for (let e of r) this.content.push(e);
	}
	compile() {
		let e = Function, t = this?.args, n = [...(this?.content ?? [""]).map((e) => `  ${e}`)];
		return new e(...t, n.join("\n"));
	}
}, dn = {
	major: 4,
	minor: 4,
	patch: 3
}, fn = /*@__PURE__*/ H("$ZodType", (e, t) => {
	var n;
	e ??= {}, e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = dn;
	let r = [...e._zod.def.checks ?? []];
	e._zod.traits.has("$ZodCheck") && r.unshift(e);
	for (let t of r) for (let n of t._zod.onattach) n(e);
	if (r.length === 0) (n = e._zod).deferred ?? (n.deferred = []), e._zod.deferred?.push(() => {
		e._zod.run = e._zod.parse;
	});
	else {
		let t = (e, t, n) => {
			let r = We(e), i;
			for (let a of t) {
				if (a._zod.def.when) {
					if (Ge(e) || !a._zod.def.when(e)) continue;
				} else if (r) continue;
				let t = e.issues.length, o = a._zod.check(e);
				if (o instanceof Promise && n?.async === !1) throw new pe();
				if (i || o instanceof Promise) i = (i ?? Promise.resolve()).then(async () => {
					await o, e.issues.length !== t && (r ||= We(e, t));
				});
				else {
					if (e.issues.length === t) continue;
					r ||= We(e, t);
				}
			}
			return i ? i.then(() => e) : e;
		}, n = (n, i, a) => {
			if (We(n)) return n.aborted = !0, n;
			let o = t(i, r, a);
			if (o instanceof Promise) {
				if (a.async === !1) throw new pe();
				return o.then((t) => e._zod.parse(t, a));
			}
			return e._zod.parse(o, a);
		};
		e._zod.run = (i, a) => {
			if (a.skipChecks) return e._zod.parse(i, a);
			if (a.direction === "backward") {
				let t = e._zod.parse({
					value: i.value,
					issues: []
				}, {
					...a,
					skipChecks: !0
				});
				return t instanceof Promise ? t.then((e) => n(e, i, a)) : n(t, i, a);
			}
			let o = e._zod.parse(i, a);
			if (o instanceof Promise) {
				if (a.async === !1) throw new pe();
				return o.then((e) => t(e, r, a));
			}
			return t(o, r, a);
		};
	}
	W(e, "~standard", () => ({
		validate: (t) => {
			try {
				let n = at(e, t);
				return n.success ? { value: n.data } : { issues: n.error?.issues };
			} catch {
				return st(e, t).then((e) => e.success ? { value: e.data } : { issues: e.error?.issues });
			}
		},
		vendor: "zod",
		version: 1
	}));
}), pn = /*@__PURE__*/ H("$ZodString", (e, t) => {
	fn.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? Vt(e._zod.bag), e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = String(n.value);
		} catch {}
		return typeof n.value == "string" || n.issues.push({
			expected: "string",
			code: "invalid_type",
			input: n.value,
			inst: e
		}), n;
	};
}), K = /*@__PURE__*/ H("$ZodStringFormat", (e, t) => {
	tn.init(e, t), pn.init(e, t);
}), mn = /*@__PURE__*/ H("$ZodGUID", (e, t) => {
	t.pattern ??= Ct, K.init(e, t);
}), hn = /*@__PURE__*/ H("$ZodUUID", (e, t) => {
	if (t.version) {
		let e = {
			v1: 1,
			v2: 2,
			v3: 3,
			v4: 4,
			v5: 5,
			v6: 6,
			v7: 7,
			v8: 8
		}[t.version];
		if (e === void 0) throw Error(`Invalid UUID version: "${t.version}"`);
		t.pattern ??= wt(e);
	} else t.pattern ??= wt();
	K.init(e, t);
}), gn = /*@__PURE__*/ H("$ZodEmail", (e, t) => {
	t.pattern ??= Tt, K.init(e, t);
}), _n = /*@__PURE__*/ H("$ZodURL", (e, t) => {
	K.init(e, t), e._zod.check = (n) => {
		try {
			let r = n.value.trim();
			if (!t.normalize && t.protocol?.source === Pt.source && !/^https?:\/\//i.test(r)) {
				n.issues.push({
					code: "invalid_format",
					format: "url",
					note: "Invalid URL format",
					input: n.value,
					inst: e,
					continue: !t.abort
				});
				return;
			}
			let i = new URL(r);
			t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(i.hostname) || n.issues.push({
				code: "invalid_format",
				format: "url",
				note: "Invalid hostname",
				pattern: t.hostname.source,
				input: n.value,
				inst: e,
				continue: !t.abort
			})), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(i.protocol.endsWith(":") ? i.protocol.slice(0, -1) : i.protocol) || n.issues.push({
				code: "invalid_format",
				format: "url",
				note: "Invalid protocol",
				pattern: t.protocol.source,
				input: n.value,
				inst: e,
				continue: !t.abort
			})), n.value = t.normalize ? i.href : r;
			return;
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "url",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
}), vn = /*@__PURE__*/ H("$ZodEmoji", (e, t) => {
	t.pattern ??= Dt(), K.init(e, t);
}), yn = /*@__PURE__*/ H("$ZodNanoID", (e, t) => {
	t.pattern ??= xt, K.init(e, t);
}), bn = /*@__PURE__*/ H("$ZodCUID", (e, t) => {
	t.pattern ??= gt, K.init(e, t);
}), xn = /*@__PURE__*/ H("$ZodCUID2", (e, t) => {
	t.pattern ??= _t, K.init(e, t);
}), Sn = /*@__PURE__*/ H("$ZodULID", (e, t) => {
	t.pattern ??= vt, K.init(e, t);
}), Cn = /*@__PURE__*/ H("$ZodXID", (e, t) => {
	t.pattern ??= yt, K.init(e, t);
}), wn = /*@__PURE__*/ H("$ZodKSUID", (e, t) => {
	t.pattern ??= bt, K.init(e, t);
}), Tn = /*@__PURE__*/ H("$ZodISODateTime", (e, t) => {
	t.pattern ??= Bt(t), K.init(e, t);
}), En = /*@__PURE__*/ H("$ZodISODate", (e, t) => {
	t.pattern ??= Lt, K.init(e, t);
}), Dn = /*@__PURE__*/ H("$ZodISOTime", (e, t) => {
	t.pattern ??= zt(t), K.init(e, t);
}), On = /*@__PURE__*/ H("$ZodISODuration", (e, t) => {
	t.pattern ??= St, K.init(e, t);
}), kn = /*@__PURE__*/ H("$ZodIPv4", (e, t) => {
	t.pattern ??= Ot, K.init(e, t), e._zod.bag.format = "ipv4";
}), An = /*@__PURE__*/ H("$ZodIPv6", (e, t) => {
	t.pattern ??= kt, K.init(e, t), e._zod.bag.format = "ipv6", e._zod.check = (n) => {
		try {
			new URL(`http://[${n.value}]`);
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "ipv6",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
}), jn = /*@__PURE__*/ H("$ZodCIDRv4", (e, t) => {
	t.pattern ??= At, K.init(e, t);
}), Mn = /*@__PURE__*/ H("$ZodCIDRv6", (e, t) => {
	t.pattern ??= jt, K.init(e, t), e._zod.check = (n) => {
		let r = n.value.split("/");
		try {
			if (r.length !== 2) throw Error();
			let [e, t] = r;
			if (!t) throw Error();
			let n = Number(t);
			if (`${n}` !== t || n < 0 || n > 128) throw Error();
			new URL(`http://[${e}]`);
		} catch {
			n.issues.push({
				code: "invalid_format",
				format: "cidrv6",
				input: n.value,
				inst: e,
				continue: !t.abort
			});
		}
	};
});
function Nn(e) {
	if (e === "") return !0;
	if (/\s/.test(e) || e.length % 4 != 0) return !1;
	try {
		return atob(e), !0;
	} catch {
		return !1;
	}
}
var Pn = /*@__PURE__*/ H("$ZodBase64", (e, t) => {
	t.pattern ??= Mt, K.init(e, t), e._zod.bag.contentEncoding = "base64", e._zod.check = (n) => {
		Nn(n.value) || n.issues.push({
			code: "invalid_format",
			format: "base64",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
});
function Fn(e) {
	if (!Nt.test(e)) return !1;
	let t = e.replace(/[-_]/g, (e) => e === "-" ? "+" : "/");
	return Nn(t.padEnd(Math.ceil(t.length / 4) * 4, "="));
}
var In = /*@__PURE__*/ H("$ZodBase64URL", (e, t) => {
	t.pattern ??= Nt, K.init(e, t), e._zod.bag.contentEncoding = "base64url", e._zod.check = (n) => {
		Fn(n.value) || n.issues.push({
			code: "invalid_format",
			format: "base64url",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Ln = /*@__PURE__*/ H("$ZodE164", (e, t) => {
	t.pattern ??= Ft, K.init(e, t);
});
function Rn(e, t = null) {
	try {
		let n = e.split(".");
		if (n.length !== 3) return !1;
		let [r] = n;
		if (!r) return !1;
		let i = JSON.parse(atob(r));
		return !("typ" in i && i?.typ !== "JWT" || !i.alg || t && (!("alg" in i) || i.alg !== t));
	} catch {
		return !1;
	}
}
var zn = /*@__PURE__*/ H("$ZodJWT", (e, t) => {
	K.init(e, t), e._zod.check = (n) => {
		Rn(n.value, t.alg) || n.issues.push({
			code: "invalid_format",
			format: "jwt",
			input: n.value,
			inst: e,
			continue: !t.abort
		});
	};
}), Bn = /*@__PURE__*/ H("$ZodNumber", (e, t) => {
	fn.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? Ut, e._zod.parse = (n, r) => {
		if (t.coerce) try {
			n.value = Number(n.value);
		} catch {}
		let i = n.value;
		if (typeof i == "number" && !Number.isNaN(i) && Number.isFinite(i)) return n;
		let a = typeof i == "number" ? Number.isNaN(i) ? "NaN" : Number.isFinite(i) ? void 0 : "Infinity" : void 0;
		return n.issues.push({
			expected: "number",
			code: "invalid_type",
			input: i,
			inst: e,
			...a ? { received: a } : {}
		}), n;
	};
}), Vn = /*@__PURE__*/ H("$ZodNumberFormat", (e, t) => {
	Zt.init(e, t), Bn.init(e, t);
}), Hn = /*@__PURE__*/ H("$ZodUnknown", (e, t) => {
	fn.init(e, t), e._zod.parse = (e) => e;
}), Un = /*@__PURE__*/ H("$ZodNever", (e, t) => {
	fn.init(e, t), e._zod.parse = (t, n) => (t.issues.push({
		expected: "never",
		code: "invalid_type",
		input: t.value,
		inst: e
	}), t);
});
function Wn(e, t, n) {
	e.issues.length && t.issues.push(...Ke(n, e.issues)), t.value[n] = e.value;
}
var Gn = /*@__PURE__*/ H("$ZodArray", (e, t) => {
	fn.init(e, t), e._zod.parse = (n, r) => {
		let i = n.value;
		if (!Array.isArray(i)) return n.issues.push({
			expected: "array",
			code: "invalid_type",
			input: i,
			inst: e
		}), n;
		n.value = Array(i.length);
		let a = [];
		for (let e = 0; e < i.length; e++) {
			let o = i[e], s = t.element._zod.run({
				value: o,
				issues: []
			}, r);
			s instanceof Promise ? a.push(s.then((t) => Wn(t, n, e))) : Wn(s, n, e);
		}
		return a.length ? Promise.all(a).then(() => n) : n;
	};
});
function Kn(e, t, n, r, i, a) {
	let o = n in r;
	if (e.issues.length) {
		if (i && a && !o) return;
		t.issues.push(...Ke(n, e.issues));
	}
	if (!o && !i) {
		e.issues.length || t.issues.push({
			code: "invalid_type",
			expected: "nonoptional",
			input: void 0,
			path: [n]
		});
		return;
	}
	e.value === void 0 ? o && (t.value[n] = void 0) : t.value[n] = e.value;
}
function qn(e) {
	let t = Object.keys(e.shape);
	for (let n of t) if (!e.shape?.[n]?._zod?.traits?.has("$ZodType")) throw Error(`Invalid element at key "${n}": expected a Zod schema`);
	let n = Fe(e.shape);
	return {
		...e,
		keys: t,
		keySet: new Set(t),
		numKeys: t.length,
		optionalKeys: new Set(n)
	};
}
function Jn(e, t, n, r, i, a) {
	let o = [], s = i.keySet, c = i.catchall._zod, l = c.def.type, u = c.optin === "optional", d = c.optout === "optional";
	for (let i in t) {
		if (i === "__proto__" || s.has(i)) continue;
		if (l === "never") {
			o.push(i);
			continue;
		}
		let a = c.run({
			value: t[i],
			issues: []
		}, r);
		a instanceof Promise ? e.push(a.then((e) => Kn(e, n, i, t, u, d))) : Kn(a, n, i, t, u, d);
	}
	return o.length && n.issues.push({
		code: "unrecognized_keys",
		keys: o,
		input: t,
		inst: a
	}), e.length ? Promise.all(e).then(() => n) : n;
}
var Yn = /*@__PURE__*/ H("$ZodObject", (e, t) => {
	if (fn.init(e, t), !Object.getOwnPropertyDescriptor(t, "shape")?.get) {
		let e = t.shape;
		Object.defineProperty(t, "shape", { get: () => {
			let n = { ...e };
			return Object.defineProperty(t, "shape", { value: n }), n;
		} });
	}
	let n = U(() => qn(t));
	W(e._zod, "propValues", () => {
		let e = t.shape, n = {};
		for (let t in e) {
			let r = e[t]._zod;
			if (r.values) {
				n[t] ?? (n[t] = /* @__PURE__ */ new Set());
				for (let e of r.values) n[t].add(e);
			}
		}
		return n;
	});
	let r = Oe, i = t.catchall, a;
	e._zod.parse = (t, o) => {
		a ??= n.value;
		let s = t.value;
		if (!r(s)) return t.issues.push({
			expected: "object",
			code: "invalid_type",
			input: s,
			inst: e
		}), t;
		t.value = {};
		let c = [], l = a.shape;
		for (let e of a.keys) {
			let n = l[e], r = n._zod.optin === "optional", i = n._zod.optout === "optional", a = n._zod.run({
				value: s[e],
				issues: []
			}, o);
			a instanceof Promise ? c.push(a.then((n) => Kn(n, t, e, s, r, i))) : Kn(a, t, e, s, r, i);
		}
		return i ? Jn(c, s, t, o, n.value, e) : c.length ? Promise.all(c).then(() => t) : t;
	};
}), Xn = /*@__PURE__*/ H("$ZodObjectJIT", (e, t) => {
	Yn.init(e, t);
	let n = e._zod.parse, r = U(() => qn(t)), i = (e) => {
		let t = new un([
			"shape",
			"payload",
			"ctx"
		]), n = r.value, i = (e) => {
			let t = Te(e);
			return `shape[${t}]._zod.run({ value: input[${t}], issues: [] }, ctx)`;
		};
		t.write("const input = payload.value;");
		let a = Object.create(null), o = 0;
		for (let e of n.keys) a[e] = `key_${o++}`;
		t.write("const newResult = {};");
		for (let r of n.keys) {
			let n = a[r], o = Te(r), s = e[r], c = s?._zod?.optin === "optional", l = s?._zod?.optout === "optional";
			t.write(`const ${n} = ${i(r)};`), c && l ? t.write(`
        if (${n}.issues.length) {
          if (${o} in input) {
            payload.issues = payload.issues.concat(${n}.issues.map(iss => ({
              ...iss,
              path: iss.path ? [${o}, ...iss.path] : [${o}]
            })));
          }
        }
        
        if (${n}.value === undefined) {
          if (${o} in input) {
            newResult[${o}] = undefined;
          }
        } else {
          newResult[${o}] = ${n}.value;
        }
        
      `) : c ? t.write(`
        if (${n}.issues.length) {
          payload.issues = payload.issues.concat(${n}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${o}, ...iss.path] : [${o}]
          })));
        }
        
        if (${n}.value === undefined) {
          if (${o} in input) {
            newResult[${o}] = undefined;
          }
        } else {
          newResult[${o}] = ${n}.value;
        }
        
      `) : t.write(`
        const ${n}_present = ${o} in input;
        if (${n}.issues.length) {
          payload.issues = payload.issues.concat(${n}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${o}, ...iss.path] : [${o}]
          })));
        }
        if (!${n}_present && !${n}.issues.length) {
          payload.issues.push({
            code: "invalid_type",
            expected: "nonoptional",
            input: undefined,
            path: [${o}]
          });
        }

        if (${n}_present) {
          if (${n}.value === undefined) {
            newResult[${o}] = undefined;
          } else {
            newResult[${o}] = ${n}.value;
          }
        }

      `);
		}
		t.write("payload.value = newResult;"), t.write("return payload;");
		let s = t.compile();
		return (t, n) => s(e, t, n);
	}, a, o = Oe, s = !he.jitless, c = s && ke.value, l = t.catchall, u;
	e._zod.parse = (d, f) => {
		u ??= r.value;
		let p = d.value;
		return o(p) ? s && c && f?.async === !1 && f.jitless !== !0 ? (a ||= i(t.shape), d = a(d, f), l ? Jn([], p, d, f, u, e) : d) : n(d, f) : (d.issues.push({
			expected: "object",
			code: "invalid_type",
			input: p,
			inst: e
		}), d);
	};
});
function Zn(e, t, n, r) {
	for (let n of e) if (n.issues.length === 0) return t.value = n.value, t;
	let i = e.filter((e) => !We(e));
	return i.length === 1 ? (t.value = i[0].value, i[0]) : (t.issues.push({
		code: "invalid_union",
		input: t.value,
		inst: n,
		errors: e.map((e) => e.issues.map((e) => Je(e, r, ge())))
	}), t);
}
var Qn = /*@__PURE__*/ H("$ZodUnion", (e, t) => {
	fn.init(e, t), W(e._zod, "optin", () => t.options.some((e) => e._zod.optin === "optional") ? "optional" : void 0), W(e._zod, "optout", () => t.options.some((e) => e._zod.optout === "optional") ? "optional" : void 0), W(e._zod, "values", () => {
		if (t.options.every((e) => e._zod.values)) return new Set(t.options.flatMap((e) => Array.from(e._zod.values)));
	}), W(e._zod, "pattern", () => {
		if (t.options.every((e) => e._zod.pattern)) {
			let e = t.options.map((e) => e._zod.pattern);
			return RegExp(`^(${e.map((e) => be(e.source)).join("|")})$`);
		}
	});
	let n = t.options.length === 1 ? t.options[0]._zod.run : null;
	e._zod.parse = (r, i) => {
		if (n) return n(r, i);
		let a = !1, o = [];
		for (let e of t.options) {
			let t = e._zod.run({
				value: r.value,
				issues: []
			}, i);
			if (t instanceof Promise) o.push(t), a = !0;
			else {
				if (t.issues.length === 0) return t;
				o.push(t);
			}
		}
		return a ? Promise.all(o).then((t) => Zn(t, r, e, i)) : Zn(o, r, e, i);
	};
}), $n = /*@__PURE__*/ H("$ZodIntersection", (e, t) => {
	fn.init(e, t), e._zod.parse = (e, n) => {
		let r = e.value, i = t.left._zod.run({
			value: r,
			issues: []
		}, n), a = t.right._zod.run({
			value: r,
			issues: []
		}, n);
		return i instanceof Promise || a instanceof Promise ? Promise.all([i, a]).then(([t, n]) => tr(e, t, n)) : tr(e, i, a);
	};
});
function er(e, t) {
	if (e === t || e instanceof Date && t instanceof Date && +e == +t) return {
		valid: !0,
		data: e
	};
	if (Ae(e) && Ae(t)) {
		let n = Object.keys(t), r = Object.keys(e).filter((e) => n.indexOf(e) !== -1), i = {
			...e,
			...t
		};
		for (let n of r) {
			let r = er(e[n], t[n]);
			if (!r.valid) return {
				valid: !1,
				mergeErrorPath: [n, ...r.mergeErrorPath]
			};
			i[n] = r.data;
		}
		return {
			valid: !0,
			data: i
		};
	}
	if (Array.isArray(e) && Array.isArray(t)) {
		if (e.length !== t.length) return {
			valid: !1,
			mergeErrorPath: []
		};
		let n = [];
		for (let r = 0; r < e.length; r++) {
			let i = e[r], a = t[r], o = er(i, a);
			if (!o.valid) return {
				valid: !1,
				mergeErrorPath: [r, ...o.mergeErrorPath]
			};
			n.push(o.data);
		}
		return {
			valid: !0,
			data: n
		};
	}
	return {
		valid: !1,
		mergeErrorPath: []
	};
}
function tr(e, t, n) {
	let r = /* @__PURE__ */ new Map(), i;
	for (let n of t.issues) if (n.code === "unrecognized_keys") {
		i ??= n;
		for (let e of n.keys) r.has(e) || r.set(e, {}), r.get(e).l = !0;
	} else e.issues.push(n);
	for (let t of n.issues) if (t.code === "unrecognized_keys") for (let e of t.keys) r.has(e) || r.set(e, {}), r.get(e).r = !0;
	else e.issues.push(t);
	let a = [...r].filter(([, e]) => e.l && e.r).map(([e]) => e);
	if (a.length && i && e.issues.push({
		...i,
		keys: a
	}), We(e)) return e;
	let o = er(t.value, n.value);
	if (!o.valid) throw Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
	return e.value = o.data, e;
}
var nr = /*@__PURE__*/ H("$ZodRecord", (e, t) => {
	fn.init(e, t), e._zod.parse = (n, r) => {
		let i = n.value;
		if (!Ae(i)) return n.issues.push({
			expected: "record",
			code: "invalid_type",
			input: i,
			inst: e
		}), n;
		let a = [], o = t.keyType._zod.values;
		if (o) {
			n.value = {};
			let s = /* @__PURE__ */ new Set();
			for (let c of o) if (typeof c == "string" || typeof c == "number" || typeof c == "symbol") {
				s.add(typeof c == "number" ? c.toString() : c);
				let o = t.keyType._zod.run({
					value: c,
					issues: []
				}, r);
				if (o instanceof Promise) throw Error("Async schemas not supported in object keys currently");
				if (o.issues.length) {
					n.issues.push({
						code: "invalid_key",
						origin: "record",
						issues: o.issues.map((e) => Je(e, r, ge())),
						input: c,
						path: [c],
						inst: e
					});
					continue;
				}
				let l = o.value, u = t.valueType._zod.run({
					value: i[c],
					issues: []
				}, r);
				u instanceof Promise ? a.push(u.then((e) => {
					e.issues.length && n.issues.push(...Ke(c, e.issues)), n.value[l] = e.value;
				})) : (u.issues.length && n.issues.push(...Ke(c, u.issues)), n.value[l] = u.value);
			}
			let c;
			for (let e in i) s.has(e) || (c ??= [], c.push(e));
			c && c.length > 0 && n.issues.push({
				code: "unrecognized_keys",
				input: i,
				inst: e,
				keys: c
			});
		} else {
			n.value = {};
			for (let o of Reflect.ownKeys(i)) {
				if (o === "__proto__" || !Object.prototype.propertyIsEnumerable.call(i, o)) continue;
				let s = t.keyType._zod.run({
					value: o,
					issues: []
				}, r);
				if (s instanceof Promise) throw Error("Async schemas not supported in object keys currently");
				if (typeof o == "string" && Ut.test(o) && s.issues.length) {
					let e = t.keyType._zod.run({
						value: Number(o),
						issues: []
					}, r);
					if (e instanceof Promise) throw Error("Async schemas not supported in object keys currently");
					e.issues.length === 0 && (s = e);
				}
				if (s.issues.length) {
					t.mode === "loose" ? n.value[o] = i[o] : n.issues.push({
						code: "invalid_key",
						origin: "record",
						issues: s.issues.map((e) => Je(e, r, ge())),
						input: o,
						path: [o],
						inst: e
					});
					continue;
				}
				let c = t.valueType._zod.run({
					value: i[o],
					issues: []
				}, r);
				c instanceof Promise ? a.push(c.then((e) => {
					e.issues.length && n.issues.push(...Ke(o, e.issues)), n.value[s.value] = e.value;
				})) : (c.issues.length && n.issues.push(...Ke(o, c.issues)), n.value[s.value] = c.value);
			}
		}
		return a.length ? Promise.all(a).then(() => n) : n;
	};
}), rr = /*@__PURE__*/ H("$ZodEnum", (e, t) => {
	fn.init(e, t);
	let n = _e(t.entries), r = new Set(n);
	e._zod.values = r, e._zod.pattern = RegExp(`^(${n.filter((e) => Me.has(typeof e)).map((e) => typeof e == "string" ? Ne(e) : e.toString()).join("|")})$`), e._zod.parse = (t, i) => {
		let a = t.value;
		return r.has(a) || t.issues.push({
			code: "invalid_value",
			values: n,
			input: a,
			inst: e
		}), t;
	};
}), ir = /*@__PURE__*/ H("$ZodLiteral", (e, t) => {
	if (fn.init(e, t), t.values.length === 0) throw Error("Cannot create literal schema with no valid values");
	let n = new Set(t.values);
	e._zod.values = n, e._zod.pattern = RegExp(`^(${t.values.map((e) => typeof e == "string" ? Ne(e) : e ? Ne(e.toString()) : String(e)).join("|")})$`), e._zod.parse = (r, i) => {
		let a = r.value;
		return n.has(a) || r.issues.push({
			code: "invalid_value",
			values: t.values,
			input: a,
			inst: e
		}), r;
	};
}), ar = /*@__PURE__*/ H("$ZodTransform", (e, t) => {
	fn.init(e, t), e._zod.optin = "optional", e._zod.parse = (n, r) => {
		if (r.direction === "backward") throw new me(e.constructor.name);
		let i = t.transform(n.value, n);
		if (r.async) return (i instanceof Promise ? i : Promise.resolve(i)).then((e) => (n.value = e, n.fallback = !0, n));
		if (i instanceof Promise) throw new pe();
		return n.value = i, n.fallback = !0, n;
	};
});
function or(e, t) {
	return t === void 0 && (e.issues.length || e.fallback) ? {
		issues: [],
		value: void 0
	} : e;
}
var sr = /*@__PURE__*/ H("$ZodOptional", (e, t) => {
	fn.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", W(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), W(e._zod, "pattern", () => {
		let e = t.innerType._zod.pattern;
		return e ? RegExp(`^(${be(e.source)})?$`) : void 0;
	}), e._zod.parse = (e, n) => {
		if (t.innerType._zod.optin === "optional") {
			let r = e.value, i = t.innerType._zod.run(e, n);
			return i instanceof Promise ? i.then((e) => or(e, r)) : or(i, r);
		}
		return e.value === void 0 ? e : t.innerType._zod.run(e, n);
	};
}), cr = /*@__PURE__*/ H("$ZodExactOptional", (e, t) => {
	sr.init(e, t), W(e._zod, "values", () => t.innerType._zod.values), W(e._zod, "pattern", () => t.innerType._zod.pattern), e._zod.parse = (e, n) => t.innerType._zod.run(e, n);
}), lr = /*@__PURE__*/ H("$ZodNullable", (e, t) => {
	fn.init(e, t), W(e._zod, "optin", () => t.innerType._zod.optin), W(e._zod, "optout", () => t.innerType._zod.optout), W(e._zod, "pattern", () => {
		let e = t.innerType._zod.pattern;
		return e ? RegExp(`^(${be(e.source)}|null)$`) : void 0;
	}), W(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (e, n) => e.value === null ? e : t.innerType._zod.run(e, n);
}), ur = /*@__PURE__*/ H("$ZodDefault", (e, t) => {
	fn.init(e, t), e._zod.optin = "optional", W(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		if (e.value === void 0) return e.value = t.defaultValue, e;
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then((e) => dr(e, t)) : dr(r, t);
	};
});
function dr(e, t) {
	return e.value === void 0 && (e.value = t.defaultValue), e;
}
var fr = /*@__PURE__*/ H("$ZodPrefault", (e, t) => {
	fn.init(e, t), e._zod.optin = "optional", W(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => (n.direction === "backward" || e.value === void 0 && (e.value = t.defaultValue), t.innerType._zod.run(e, n));
}), pr = /*@__PURE__*/ H("$ZodNonOptional", (e, t) => {
	fn.init(e, t), W(e._zod, "values", () => {
		let e = t.innerType._zod.values;
		return e ? new Set([...e].filter((e) => e !== void 0)) : void 0;
	}), e._zod.parse = (n, r) => {
		let i = t.innerType._zod.run(n, r);
		return i instanceof Promise ? i.then((t) => mr(t, e)) : mr(i, e);
	};
});
function mr(e, t) {
	return !e.issues.length && e.value === void 0 && e.issues.push({
		code: "invalid_type",
		expected: "nonoptional",
		input: e.value,
		inst: t
	}), e;
}
var hr = /*@__PURE__*/ H("$ZodCatch", (e, t) => {
	fn.init(e, t), e._zod.optin = "optional", W(e._zod, "optout", () => t.innerType._zod.optout), W(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then((r) => (e.value = r.value, r.issues.length && (e.value = t.catchValue({
			...e,
			error: { issues: r.issues.map((e) => Je(e, n, ge())) },
			input: e.value
		}), e.issues = [], e.fallback = !0), e)) : (e.value = r.value, r.issues.length && (e.value = t.catchValue({
			...e,
			error: { issues: r.issues.map((e) => Je(e, n, ge())) },
			input: e.value
		}), e.issues = [], e.fallback = !0), e);
	};
}), gr = /*@__PURE__*/ H("$ZodPipe", (e, t) => {
	fn.init(e, t), W(e._zod, "values", () => t.in._zod.values), W(e._zod, "optin", () => t.in._zod.optin), W(e._zod, "optout", () => t.out._zod.optout), W(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (e, n) => {
		if (n.direction === "backward") {
			let r = t.out._zod.run(e, n);
			return r instanceof Promise ? r.then((e) => _r(e, t.in, n)) : _r(r, t.in, n);
		}
		let r = t.in._zod.run(e, n);
		return r instanceof Promise ? r.then((e) => _r(e, t.out, n)) : _r(r, t.out, n);
	};
});
function _r(e, t, n) {
	return e.issues.length ? (e.aborted = !0, e) : t._zod.run({
		value: e.value,
		issues: e.issues,
		fallback: e.fallback
	}, n);
}
var vr = /*@__PURE__*/ H("$ZodReadonly", (e, t) => {
	fn.init(e, t), W(e._zod, "propValues", () => t.innerType._zod.propValues), W(e._zod, "values", () => t.innerType._zod.values), W(e._zod, "optin", () => t.innerType?._zod?.optin), W(e._zod, "optout", () => t.innerType?._zod?.optout), e._zod.parse = (e, n) => {
		if (n.direction === "backward") return t.innerType._zod.run(e, n);
		let r = t.innerType._zod.run(e, n);
		return r instanceof Promise ? r.then(yr) : yr(r);
	};
});
function yr(e) {
	return e.value = Object.freeze(e.value), e;
}
var br = /*@__PURE__*/ H("$ZodCustom", (e, t) => {
	Kt.init(e, t), fn.init(e, t), e._zod.parse = (e, t) => e, e._zod.check = (n) => {
		let r = n.value, i = t.fn(r);
		if (i instanceof Promise) return i.then((t) => xr(t, n, r, e));
		xr(i, n, r, e);
	};
});
function xr(e, t, n, r) {
	if (!e) {
		let e = {
			code: "custom",
			input: n,
			inst: r,
			path: [...r._zod.def.path ?? []],
			continue: !r._zod.def.abort
		};
		r._zod.def.params && (e.params = r._zod.def.params), t.issues.push(Xe(e));
	}
}
//#endregion
//#region ../../node_modules/zod/v4/core/registries.js
var Sr, Cr = class {
	constructor() {
		this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
	}
	add(e, ...t) {
		let n = t[0];
		return this._map.set(e, n), n && typeof n == "object" && "id" in n && this._idmap.set(n.id, e), this;
	}
	clear() {
		return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
	}
	remove(e) {
		let t = this._map.get(e);
		return t && typeof t == "object" && "id" in t && this._idmap.delete(t.id), this._map.delete(e), this;
	}
	get(e) {
		let t = e._zod.parent;
		if (t) {
			let n = { ...this.get(t) ?? {} };
			delete n.id;
			let r = {
				...n,
				...this._map.get(e)
			};
			return Object.keys(r).length ? r : void 0;
		}
		return this._map.get(e);
	}
	has(e) {
		return this._map.has(e);
	}
};
function wr() {
	return new Cr();
}
(Sr = globalThis).__zod_globalRegistry ?? (Sr.__zod_globalRegistry = wr());
var Tr = globalThis.__zod_globalRegistry;
//#endregion
//#region ../../node_modules/zod/v4/core/api.js
// @__NO_SIDE_EFFECTS__
function Er(e, t) {
	return new e({
		type: "string",
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Dr(e, t) {
	return new e({
		type: "string",
		format: "email",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Or(e, t) {
	return new e({
		type: "string",
		format: "guid",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function kr(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Ar(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v4",
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function jr(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v6",
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Mr(e, t) {
	return new e({
		type: "string",
		format: "uuid",
		check: "string_format",
		abort: !1,
		version: "v7",
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Nr(e, t) {
	return new e({
		type: "string",
		format: "url",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Pr(e, t) {
	return new e({
		type: "string",
		format: "emoji",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Fr(e, t) {
	return new e({
		type: "string",
		format: "nanoid",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Ir(e, t) {
	return new e({
		type: "string",
		format: "cuid",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Lr(e, t) {
	return new e({
		type: "string",
		format: "cuid2",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Rr(e, t) {
	return new e({
		type: "string",
		format: "ulid",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function zr(e, t) {
	return new e({
		type: "string",
		format: "xid",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Br(e, t) {
	return new e({
		type: "string",
		format: "ksuid",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Vr(e, t) {
	return new e({
		type: "string",
		format: "ipv4",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Hr(e, t) {
	return new e({
		type: "string",
		format: "ipv6",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Ur(e, t) {
	return new e({
		type: "string",
		format: "cidrv4",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Wr(e, t) {
	return new e({
		type: "string",
		format: "cidrv6",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Gr(e, t) {
	return new e({
		type: "string",
		format: "base64",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Kr(e, t) {
	return new e({
		type: "string",
		format: "base64url",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function qr(e, t) {
	return new e({
		type: "string",
		format: "e164",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Jr(e, t) {
	return new e({
		type: "string",
		format: "jwt",
		check: "string_format",
		abort: !1,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Yr(e, t) {
	return new e({
		type: "string",
		format: "datetime",
		check: "string_format",
		offset: !1,
		local: !1,
		precision: null,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Xr(e, t) {
	return new e({
		type: "string",
		format: "date",
		check: "string_format",
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Zr(e, t) {
	return new e({
		type: "string",
		format: "time",
		check: "string_format",
		precision: null,
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function Qr(e, t) {
	return new e({
		type: "string",
		format: "duration",
		check: "string_format",
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function $r(e, t) {
	return new e({
		type: "number",
		checks: [],
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function ei(e, t) {
	return new e({
		type: "number",
		check: "number_format",
		abort: !1,
		format: "safeint",
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function ti(e) {
	return new e({ type: "unknown" });
}
// @__NO_SIDE_EFFECTS__
function ni(e, t) {
	return new e({
		type: "never",
		...G(t)
	});
}
// @__NO_SIDE_EFFECTS__
function ri(e, t) {
	return new Jt({
		check: "less_than",
		...G(t),
		value: e,
		inclusive: !1
	});
}
// @__NO_SIDE_EFFECTS__
function ii(e, t) {
	return new Jt({
		check: "less_than",
		...G(t),
		value: e,
		inclusive: !0
	});
}
// @__NO_SIDE_EFFECTS__
function ai(e, t) {
	return new Yt({
		check: "greater_than",
		...G(t),
		value: e,
		inclusive: !1
	});
}
// @__NO_SIDE_EFFECTS__
function oi(e, t) {
	return new Yt({
		check: "greater_than",
		...G(t),
		value: e,
		inclusive: !0
	});
}
// @__NO_SIDE_EFFECTS__
function si(e, t) {
	return new Xt({
		check: "multiple_of",
		...G(t),
		value: e
	});
}
// @__NO_SIDE_EFFECTS__
function ci(e, t) {
	return new Qt({
		check: "max_length",
		...G(t),
		maximum: e
	});
}
// @__NO_SIDE_EFFECTS__
function li(e, t) {
	return new $t({
		check: "min_length",
		...G(t),
		minimum: e
	});
}
// @__NO_SIDE_EFFECTS__
function ui(e, t) {
	return new en({
		check: "length_equals",
		...G(t),
		length: e
	});
}
// @__NO_SIDE_EFFECTS__
function di(e, t) {
	return new nn({
		check: "string_format",
		format: "regex",
		...G(t),
		pattern: e
	});
}
// @__NO_SIDE_EFFECTS__
function fi(e) {
	return new rn({
		check: "string_format",
		format: "lowercase",
		...G(e)
	});
}
// @__NO_SIDE_EFFECTS__
function pi(e) {
	return new an({
		check: "string_format",
		format: "uppercase",
		...G(e)
	});
}
// @__NO_SIDE_EFFECTS__
function mi(e, t) {
	return new on({
		check: "string_format",
		format: "includes",
		...G(t),
		includes: e
	});
}
// @__NO_SIDE_EFFECTS__
function hi(e, t) {
	return new sn({
		check: "string_format",
		format: "starts_with",
		...G(t),
		prefix: e
	});
}
// @__NO_SIDE_EFFECTS__
function gi(e, t) {
	return new cn({
		check: "string_format",
		format: "ends_with",
		...G(t),
		suffix: e
	});
}
// @__NO_SIDE_EFFECTS__
function _i(e) {
	return new ln({
		check: "overwrite",
		tx: e
	});
}
// @__NO_SIDE_EFFECTS__
function vi(e) {
	return /* @__PURE__ */ _i((t) => t.normalize(e));
}
// @__NO_SIDE_EFFECTS__
function yi() {
	return /* @__PURE__ */ _i((e) => e.trim());
}
// @__NO_SIDE_EFFECTS__
function bi() {
	return /* @__PURE__ */ _i((e) => e.toLowerCase());
}
// @__NO_SIDE_EFFECTS__
function xi() {
	return /* @__PURE__ */ _i((e) => e.toUpperCase());
}
// @__NO_SIDE_EFFECTS__
function Si() {
	return /* @__PURE__ */ _i((e) => Ee(e));
}
// @__NO_SIDE_EFFECTS__
function Ci(e, t, n) {
	return new e({
		type: "array",
		element: t,
		...G(n)
	});
}
// @__NO_SIDE_EFFECTS__
function wi(e, t, n) {
	return new e({
		type: "custom",
		check: "custom",
		fn: t,
		...G(n)
	});
}
// @__NO_SIDE_EFFECTS__
function Ti(e, t) {
	let n = /* @__PURE__ */ Ei((t) => (t.addIssue = (e) => {
		if (typeof e == "string") t.issues.push(Xe(e, t.value, n._zod.def));
		else {
			let r = e;
			r.fatal && (r.continue = !1), r.code ??= "custom", r.input ??= t.value, r.inst ??= n, r.continue ??= !n._zod.def.abort, t.issues.push(Xe(r));
		}
	}, e(t.value, t)), t);
	return n;
}
// @__NO_SIDE_EFFECTS__
function Ei(e, t) {
	let n = new Kt({
		check: "custom",
		...G(t)
	});
	return n._zod.check = e, n;
}
//#endregion
//#region ../../node_modules/zod/v4/core/to-json-schema.js
function Di(e) {
	let t = e?.target ?? "draft-2020-12";
	return t === "draft-4" && (t = "draft-04"), t === "draft-7" && (t = "draft-07"), {
		processors: e.processors ?? {},
		metadataRegistry: e?.metadata ?? Tr,
		target: t,
		unrepresentable: e?.unrepresentable ?? "throw",
		override: e?.override ?? (() => {}),
		io: e?.io ?? "output",
		counter: 0,
		seen: /* @__PURE__ */ new Map(),
		cycles: e?.cycles ?? "ref",
		reused: e?.reused ?? "inline",
		external: e?.external ?? void 0
	};
}
function Oi(e, t, n = {
	path: [],
	schemaPath: []
}) {
	var r;
	let i = e._zod.def, a = t.seen.get(e);
	if (a) return a.count++, n.schemaPath.includes(e) && (a.cycle = n.path), a.schema;
	let o = {
		schema: {},
		count: 1,
		cycle: void 0,
		path: n.path
	};
	t.seen.set(e, o);
	let s = e._zod.toJSONSchema?.();
	if (s) o.schema = s;
	else {
		let r = {
			...n,
			schemaPath: [...n.schemaPath, e],
			path: n.path
		};
		if (e._zod.processJSONSchema) e._zod.processJSONSchema(t, o.schema, r);
		else {
			let n = o.schema, a = t.processors[i.type];
			if (!a) throw Error(`[toJSONSchema]: Non-representable type encountered: ${i.type}`);
			a(e, t, n, r);
		}
		let a = e._zod.parent;
		a && (o.ref ||= a, Oi(a, t, r), t.seen.get(a).isParent = !0);
	}
	let c = t.metadataRegistry.get(e);
	return c && Object.assign(o.schema, c), t.io === "input" && ji(e) && (delete o.schema.examples, delete o.schema.default), t.io === "input" && "_prefault" in o.schema && ((r = o.schema).default ?? (r.default = o.schema._prefault)), delete o.schema._prefault, t.seen.get(e).schema;
}
function ki(e, t) {
	let n = e.seen.get(t);
	if (!n) throw Error("Unprocessed schema. This is a bug in Zod.");
	let r = /* @__PURE__ */ new Map();
	for (let t of e.seen.entries()) {
		let n = e.metadataRegistry.get(t[0])?.id;
		if (n) {
			let e = r.get(n);
			if (e && e !== t[0]) throw Error(`Duplicate schema id "${n}" detected during JSON Schema conversion. Two different schemas cannot share the same id when converted together.`);
			r.set(n, t[0]);
		}
	}
	let i = (t) => {
		let r = e.target === "draft-2020-12" ? "$defs" : "definitions";
		if (e.external) {
			let n = e.external.registry.get(t[0])?.id, i = e.external.uri ?? ((e) => e);
			if (n) return { ref: i(n) };
			let a = t[1].defId ?? t[1].schema.id ?? `schema${e.counter++}`;
			return t[1].defId = a, {
				defId: a,
				ref: `${i("__shared")}#/${r}/${a}`
			};
		}
		if (t[1] === n) return { ref: "#" };
		let i = `#/${r}/`, a = t[1].schema.id ?? `__schema${e.counter++}`;
		return {
			defId: a,
			ref: i + a
		};
	}, a = (e) => {
		if (e[1].schema.$ref) return;
		let t = e[1], { ref: n, defId: r } = i(e);
		t.def = { ...t.schema }, r && (t.defId = r);
		let a = t.schema;
		for (let e in a) delete a[e];
		a.$ref = n;
	};
	if (e.cycles === "throw") for (let t of e.seen.entries()) {
		let e = t[1];
		if (e.cycle) throw Error(`Cycle detected: #/${e.cycle?.join("/")}/<root>

Set the \`cycles\` parameter to \`"ref"\` to resolve cyclical schemas with defs.`);
	}
	for (let n of e.seen.entries()) {
		let r = n[1];
		if (t === n[0]) {
			a(n);
			continue;
		}
		if (e.external) {
			let r = e.external.registry.get(n[0])?.id;
			if (t !== n[0] && r) {
				a(n);
				continue;
			}
		}
		if (e.metadataRegistry.get(n[0])?.id) {
			a(n);
			continue;
		}
		if (r.cycle) {
			a(n);
			continue;
		}
		if (r.count > 1 && e.reused === "ref") {
			a(n);
			continue;
		}
	}
}
function Ai(e, t) {
	let n = e.seen.get(t);
	if (!n) throw Error("Unprocessed schema. This is a bug in Zod.");
	let r = (t) => {
		let n = e.seen.get(t);
		if (n.ref === null) return;
		let i = n.def ?? n.schema, a = { ...i }, o = n.ref;
		if (n.ref = null, o) {
			r(o);
			let n = e.seen.get(o), s = n.schema;
			if (s.$ref && (e.target === "draft-07" || e.target === "draft-04" || e.target === "openapi-3.0") ? (i.allOf = i.allOf ?? [], i.allOf.push(s)) : Object.assign(i, s), Object.assign(i, a), t._zod.parent === o) for (let e in i) e !== "$ref" && e !== "allOf" && (e in a || delete i[e]);
			if (s.$ref && n.def) for (let e in i) e !== "$ref" && e !== "allOf" && e in n.def && JSON.stringify(i[e]) === JSON.stringify(n.def[e]) && delete i[e];
		}
		let s = t._zod.parent;
		if (s && s !== o) {
			r(s);
			let t = e.seen.get(s);
			if (t?.schema.$ref && (i.$ref = t.schema.$ref, t.def)) for (let e in i) e !== "$ref" && e !== "allOf" && e in t.def && JSON.stringify(i[e]) === JSON.stringify(t.def[e]) && delete i[e];
		}
		e.override({
			zodSchema: t,
			jsonSchema: i,
			path: n.path ?? []
		});
	};
	for (let t of [...e.seen.entries()].reverse()) r(t[0]);
	let i = {};
	if (e.target === "draft-2020-12" ? i.$schema = "https://json-schema.org/draft/2020-12/schema" : e.target === "draft-07" ? i.$schema = "http://json-schema.org/draft-07/schema#" : e.target === "draft-04" ? i.$schema = "http://json-schema.org/draft-04/schema#" : e.target, e.external?.uri) {
		let n = e.external.registry.get(t)?.id;
		if (!n) throw Error("Schema is missing an `id` property");
		i.$id = e.external.uri(n);
	}
	Object.assign(i, n.def ?? n.schema);
	let a = e.metadataRegistry.get(t)?.id;
	a !== void 0 && i.id === a && delete i.id;
	let o = e.external?.defs ?? {};
	for (let t of e.seen.entries()) {
		let e = t[1];
		e.def && e.defId && (e.def.id === e.defId && delete e.def.id, o[e.defId] = e.def);
	}
	e.external || Object.keys(o).length > 0 && (e.target === "draft-2020-12" ? i.$defs = o : i.definitions = o);
	try {
		let n = JSON.parse(JSON.stringify(i));
		return Object.defineProperty(n, "~standard", {
			value: {
				...t["~standard"],
				jsonSchema: {
					input: Ni(t, "input", e.processors),
					output: Ni(t, "output", e.processors)
				}
			},
			enumerable: !1,
			writable: !1
		}), n;
	} catch {
		throw Error("Error converting schema to JSON.");
	}
}
function ji(e, t) {
	let n = t ?? { seen: /* @__PURE__ */ new Set() };
	if (n.seen.has(e)) return !1;
	n.seen.add(e);
	let r = e._zod.def;
	if (r.type === "transform") return !0;
	if (r.type === "array") return ji(r.element, n);
	if (r.type === "set") return ji(r.valueType, n);
	if (r.type === "lazy") return ji(r.getter(), n);
	if (r.type === "promise" || r.type === "optional" || r.type === "nonoptional" || r.type === "nullable" || r.type === "readonly" || r.type === "default" || r.type === "prefault") return ji(r.innerType, n);
	if (r.type === "intersection") return ji(r.left, n) || ji(r.right, n);
	if (r.type === "record" || r.type === "map") return ji(r.keyType, n) || ji(r.valueType, n);
	if (r.type === "pipe") return e._zod.traits.has("$ZodCodec") ? !0 : ji(r.in, n) || ji(r.out, n);
	if (r.type === "object") {
		for (let e in r.shape) if (ji(r.shape[e], n)) return !0;
		return !1;
	}
	if (r.type === "union") {
		for (let e of r.options) if (ji(e, n)) return !0;
		return !1;
	}
	if (r.type === "tuple") {
		for (let e of r.items) if (ji(e, n)) return !0;
		return !!(r.rest && ji(r.rest, n));
	}
	return !1;
}
var Mi = (e, t = {}) => (n) => {
	let r = Di({
		...n,
		processors: t
	});
	return Oi(e, r), ki(r, e), Ai(r, e);
}, Ni = (e, t, n = {}) => (r) => {
	let { libraryOptions: i, target: a } = r ?? {}, o = Di({
		...i ?? {},
		target: a,
		io: t,
		processors: n
	});
	return Oi(e, o), ki(o, e), Ai(o, e);
}, Pi = {
	guid: "uuid",
	url: "uri",
	datetime: "date-time",
	json_string: "json-string",
	regex: ""
}, Fi = (e, t, n, r) => {
	let i = n;
	i.type = "string";
	let { minimum: a, maximum: o, format: s, patterns: c, contentEncoding: l } = e._zod.bag;
	if (typeof a == "number" && (i.minLength = a), typeof o == "number" && (i.maxLength = o), s && (i.format = Pi[s] ?? s, i.format === "" && delete i.format, s === "time" && delete i.format), l && (i.contentEncoding = l), c && c.size > 0) {
		let e = [...c];
		e.length === 1 ? i.pattern = e[0].source : e.length > 1 && (i.allOf = [...e.map((e) => ({
			...t.target === "draft-07" || t.target === "draft-04" || t.target === "openapi-3.0" ? { type: "string" } : {},
			pattern: e.source
		}))]);
	}
}, Ii = (e, t, n, r) => {
	let i = n, { minimum: a, maximum: o, format: s, multipleOf: c, exclusiveMaximum: l, exclusiveMinimum: u } = e._zod.bag;
	i.type = typeof s == "string" && s.includes("int") ? "integer" : "number";
	let d = typeof u == "number" && u >= (a ?? -Infinity), f = typeof l == "number" && l <= (o ?? Infinity), p = t.target === "draft-04" || t.target === "openapi-3.0";
	d ? p ? (i.minimum = u, i.exclusiveMinimum = !0) : i.exclusiveMinimum = u : typeof a == "number" && (i.minimum = a), f ? p ? (i.maximum = l, i.exclusiveMaximum = !0) : i.exclusiveMaximum = l : typeof o == "number" && (i.maximum = o), typeof c == "number" && (i.multipleOf = c);
}, Li = (e, t, n, r) => {
	n.not = {};
}, Ri = (e, t, n, r) => {
	let i = e._zod.def, a = _e(i.entries);
	a.every((e) => typeof e == "number") && (n.type = "number"), a.every((e) => typeof e == "string") && (n.type = "string"), n.enum = a;
}, zi = (e, t, n, r) => {
	let i = e._zod.def, a = [];
	for (let e of i.values) if (e === void 0) {
		if (t.unrepresentable === "throw") throw Error("Literal `undefined` cannot be represented in JSON Schema");
	} else if (typeof e == "bigint") {
		if (t.unrepresentable === "throw") throw Error("BigInt literals cannot be represented in JSON Schema");
		a.push(Number(e));
	} else a.push(e);
	if (a.length !== 0) {
		if (a.length === 1) {
			let e = a[0];
			n.type = e === null ? "null" : typeof e, t.target === "draft-04" || t.target === "openapi-3.0" ? n.enum = [e] : n.const = e;
		} else a.every((e) => typeof e == "number") && (n.type = "number"), a.every((e) => typeof e == "string") && (n.type = "string"), a.every((e) => typeof e == "boolean") && (n.type = "boolean"), a.every((e) => e === null) && (n.type = "null"), n.enum = a;
	}
}, Bi = (e, t, n, r) => {
	if (t.unrepresentable === "throw") throw Error("Custom types cannot be represented in JSON Schema");
}, Vi = (e, t, n, r) => {
	if (t.unrepresentable === "throw") throw Error("Transforms cannot be represented in JSON Schema");
}, Hi = (e, t, n, r) => {
	let i = n, a = e._zod.def, { minimum: o, maximum: s } = e._zod.bag;
	typeof o == "number" && (i.minItems = o), typeof s == "number" && (i.maxItems = s), i.type = "array", i.items = Oi(a.element, t, {
		...r,
		path: [...r.path, "items"]
	});
}, Ui = (e, t, n, r) => {
	let i = n, a = e._zod.def;
	i.type = "object", i.properties = {};
	let o = a.shape;
	for (let e in o) i.properties[e] = Oi(o[e], t, {
		...r,
		path: [
			...r.path,
			"properties",
			e
		]
	});
	let s = new Set(Object.keys(o)), c = new Set([...s].filter((e) => {
		let n = a.shape[e]._zod;
		return t.io === "input" ? n.optin === void 0 : n.optout === void 0;
	}));
	c.size > 0 && (i.required = Array.from(c)), a.catchall?._zod.def.type === "never" ? i.additionalProperties = !1 : a.catchall ? a.catchall && (i.additionalProperties = Oi(a.catchall, t, {
		...r,
		path: [...r.path, "additionalProperties"]
	})) : t.io === "output" && (i.additionalProperties = !1);
}, Wi = (e, t, n, r) => {
	let i = e._zod.def, a = i.inclusive === !1, o = i.options.map((e, n) => Oi(e, t, {
		...r,
		path: [
			...r.path,
			a ? "oneOf" : "anyOf",
			n
		]
	}));
	a ? n.oneOf = o : n.anyOf = o;
}, Gi = (e, t, n, r) => {
	let i = e._zod.def, a = Oi(i.left, t, {
		...r,
		path: [
			...r.path,
			"allOf",
			0
		]
	}), o = Oi(i.right, t, {
		...r,
		path: [
			...r.path,
			"allOf",
			1
		]
	}), s = (e) => "allOf" in e && Object.keys(e).length === 1;
	n.allOf = [...s(a) ? a.allOf : [a], ...s(o) ? o.allOf : [o]];
}, Ki = (e, t, n, r) => {
	let i = n, a = e._zod.def;
	i.type = "object";
	let o = a.keyType, s = o._zod.bag?.patterns;
	if (a.mode === "loose" && s && s.size > 0) {
		let e = Oi(a.valueType, t, {
			...r,
			path: [
				...r.path,
				"patternProperties",
				"*"
			]
		});
		i.patternProperties = {};
		for (let t of s) i.patternProperties[t.source] = e;
	} else (t.target === "draft-07" || t.target === "draft-2020-12") && (i.propertyNames = Oi(a.keyType, t, {
		...r,
		path: [...r.path, "propertyNames"]
	})), i.additionalProperties = Oi(a.valueType, t, {
		...r,
		path: [...r.path, "additionalProperties"]
	});
	let c = o._zod.values;
	if (c) {
		let e = [...c].filter((e) => typeof e == "string" || typeof e == "number");
		e.length > 0 && (i.required = e);
	}
}, qi = (e, t, n, r) => {
	let i = e._zod.def, a = Oi(i.innerType, t, r), o = t.seen.get(e);
	t.target === "openapi-3.0" ? (o.ref = i.innerType, n.nullable = !0) : n.anyOf = [a, { type: "null" }];
}, Ji = (e, t, n, r) => {
	let i = e._zod.def;
	Oi(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
}, Yi = (e, t, n, r) => {
	let i = e._zod.def;
	Oi(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType, n.default = JSON.parse(JSON.stringify(i.defaultValue));
}, Xi = (e, t, n, r) => {
	let i = e._zod.def;
	Oi(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType, t.io === "input" && (n._prefault = JSON.parse(JSON.stringify(i.defaultValue)));
}, Zi = (e, t, n, r) => {
	let i = e._zod.def;
	Oi(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
	let o;
	try {
		o = i.catchValue(void 0);
	} catch {
		throw Error("Dynamic catch values are not supported in JSON Schema");
	}
	n.default = o;
}, Qi = (e, t, n, r) => {
	let i = e._zod.def, a = i.in._zod.traits.has("$ZodTransform"), o = t.io === "input" ? a ? i.out : i.in : i.out;
	Oi(o, t, r);
	let s = t.seen.get(e);
	s.ref = o;
}, $i = (e, t, n, r) => {
	let i = e._zod.def;
	Oi(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType, n.readOnly = !0;
}, ea = (e, t, n, r) => {
	let i = e._zod.def;
	Oi(i.innerType, t, r);
	let a = t.seen.get(e);
	a.ref = i.innerType;
}, ta = /*@__PURE__*/ H("ZodISODateTime", (e, t) => {
	Tn.init(e, t), q.init(e, t);
});
function na(e) {
	return /* @__PURE__ */ Yr(ta, e);
}
var ra = /*@__PURE__*/ H("ZodISODate", (e, t) => {
	En.init(e, t), q.init(e, t);
});
function ia(e) {
	return /* @__PURE__ */ Xr(ra, e);
}
var aa = /*@__PURE__*/ H("ZodISOTime", (e, t) => {
	Dn.init(e, t), q.init(e, t);
});
function oa(e) {
	return /* @__PURE__ */ Zr(aa, e);
}
var sa = /*@__PURE__*/ H("ZodISODuration", (e, t) => {
	On.init(e, t), q.init(e, t);
});
function ca(e) {
	return /* @__PURE__ */ Qr(sa, e);
}
var la = /*@__PURE__*/ H("ZodError", (e, t) => {
	Qe.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
		format: { value: (t) => tt(e, t) },
		flatten: { value: (t) => et(e, t) },
		addIssue: { value: (t) => {
			e.issues.push(t), e.message = JSON.stringify(e.issues, ve, 2);
		} },
		addIssues: { value: (t) => {
			e.issues.push(...t), e.message = JSON.stringify(e.issues, ve, 2);
		} },
		isEmpty: { get() {
			return e.issues.length === 0;
		} }
	});
}, { Parent: Error }), ua = /* @__PURE__ */ nt(la), da = /* @__PURE__ */ rt(la), fa = /* @__PURE__ */ it(la), pa = /* @__PURE__ */ ot(la), ma = /* @__PURE__ */ ct(la), ha = /* @__PURE__ */ lt(la), ga = /* @__PURE__ */ ut(la), _a = /* @__PURE__ */ dt(la), va = /* @__PURE__ */ ft(la), ya = /* @__PURE__ */ pt(la), ba = /* @__PURE__ */ mt(la), xa = /* @__PURE__ */ ht(la), Sa = /* @__PURE__ */ new WeakMap();
function Ca(e, t, n) {
	let r = Object.getPrototypeOf(e), i = Sa.get(r);
	if (i || (i = /* @__PURE__ */ new Set(), Sa.set(r, i)), !i.has(t)) {
		i.add(t);
		for (let e in n) {
			let t = n[e];
			Object.defineProperty(r, e, {
				configurable: !0,
				enumerable: !1,
				get() {
					let n = t.bind(this);
					return Object.defineProperty(this, e, {
						configurable: !0,
						writable: !0,
						enumerable: !0,
						value: n
					}), n;
				},
				set(t) {
					Object.defineProperty(this, e, {
						configurable: !0,
						writable: !0,
						enumerable: !0,
						value: t
					});
				}
			});
		}
	}
}
var wa = /*@__PURE__*/ H("ZodType", (e, t) => (fn.init(e, t), Object.assign(e["~standard"], { jsonSchema: {
	input: Ni(e, "input"),
	output: Ni(e, "output")
} }), e.toJSONSchema = Mi(e, {}), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.parse = (t, n) => ua(e, t, n, { callee: e.parse }), e.safeParse = (t, n) => fa(e, t, n), e.parseAsync = async (t, n) => da(e, t, n, { callee: e.parseAsync }), e.safeParseAsync = async (t, n) => pa(e, t, n), e.spa = e.safeParseAsync, e.encode = (t, n) => ma(e, t, n), e.decode = (t, n) => ha(e, t, n), e.encodeAsync = async (t, n) => ga(e, t, n), e.decodeAsync = async (t, n) => _a(e, t, n), e.safeEncode = (t, n) => va(e, t, n), e.safeDecode = (t, n) => ya(e, t, n), e.safeEncodeAsync = async (t, n) => ba(e, t, n), e.safeDecodeAsync = async (t, n) => xa(e, t, n), Ca(e, "ZodType", {
	check(...e) {
		let t = this.def;
		return this.clone(we(t, { checks: [...t.checks ?? [], ...e.map((e) => typeof e == "function" ? { _zod: {
			check: e,
			def: { check: "custom" },
			onattach: []
		} } : e)] }), { parent: !0 });
	},
	with(...e) {
		return this.check(...e);
	},
	clone(e, t) {
		return Pe(this, e, t);
	},
	brand() {
		return this;
	},
	register(e, t) {
		return e.add(this, t), this;
	},
	refine(e, t) {
		return this.check(zo(e, t));
	},
	superRefine(e, t) {
		return this.check(Bo(e, t));
	},
	overwrite(e) {
		return this.check(/* @__PURE__ */ _i(e));
	},
	optional() {
		return xo(this);
	},
	exactOptional() {
		return Co(this);
	},
	nullable() {
		return To(this);
	},
	nullish() {
		return xo(To(this));
	},
	nonoptional(e) {
		return jo(this, e);
	},
	array() {
		return ro(this);
	},
	or(e) {
		return co([this, e]);
	},
	and(e) {
		return uo(this, e);
	},
	transform(e) {
		return Fo(this, yo(e));
	},
	default(e) {
		return Do(this, e);
	},
	prefault(e) {
		return ko(this, e);
	},
	catch(e) {
		return No(this, e);
	},
	pipe(e) {
		return Fo(this, e);
	},
	readonly() {
		return Lo(this);
	},
	describe(e) {
		let t = this.clone();
		return Tr.add(t, { description: e }), t;
	},
	meta(...e) {
		if (e.length === 0) return Tr.get(this);
		let t = this.clone();
		return Tr.add(t, e[0]), t;
	},
	isOptional() {
		return this.safeParse(void 0).success;
	},
	isNullable() {
		return this.safeParse(null).success;
	},
	apply(e) {
		return e(this);
	}
}), Object.defineProperty(e, "description", {
	get() {
		return Tr.get(e)?.description;
	},
	configurable: !0
}), e)), Ta = /*@__PURE__*/ H("_ZodString", (e, t) => {
	pn.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Fi(e, t, n, r);
	let n = e._zod.bag;
	e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, Ca(e, "_ZodString", {
		regex(...e) {
			return this.check(/* @__PURE__ */ di(...e));
		},
		includes(...e) {
			return this.check(/* @__PURE__ */ mi(...e));
		},
		startsWith(...e) {
			return this.check(/* @__PURE__ */ hi(...e));
		},
		endsWith(...e) {
			return this.check(/* @__PURE__ */ gi(...e));
		},
		min(...e) {
			return this.check(/* @__PURE__ */ li(...e));
		},
		max(...e) {
			return this.check(/* @__PURE__ */ ci(...e));
		},
		length(...e) {
			return this.check(/* @__PURE__ */ ui(...e));
		},
		nonempty(...e) {
			return this.check(/* @__PURE__ */ li(1, ...e));
		},
		lowercase(e) {
			return this.check(/* @__PURE__ */ fi(e));
		},
		uppercase(e) {
			return this.check(/* @__PURE__ */ pi(e));
		},
		trim() {
			return this.check(/* @__PURE__ */ yi());
		},
		normalize(...e) {
			return this.check(/* @__PURE__ */ vi(...e));
		},
		toLowerCase() {
			return this.check(/* @__PURE__ */ bi());
		},
		toUpperCase() {
			return this.check(/* @__PURE__ */ xi());
		},
		slugify() {
			return this.check(/* @__PURE__ */ Si());
		}
	});
}), Ea = /*@__PURE__*/ H("ZodString", (e, t) => {
	pn.init(e, t), Ta.init(e, t), e.email = (t) => e.check(/* @__PURE__ */ Dr(Oa, t)), e.url = (t) => e.check(/* @__PURE__ */ Nr(ja, t)), e.jwt = (t) => e.check(/* @__PURE__ */ Jr(qa, t)), e.emoji = (t) => e.check(/* @__PURE__ */ Pr(Na, t)), e.guid = (t) => e.check(/* @__PURE__ */ Or(ka, t)), e.uuid = (t) => e.check(/* @__PURE__ */ kr(Aa, t)), e.uuidv4 = (t) => e.check(/* @__PURE__ */ Ar(Aa, t)), e.uuidv6 = (t) => e.check(/* @__PURE__ */ jr(Aa, t)), e.uuidv7 = (t) => e.check(/* @__PURE__ */ Mr(Aa, t)), e.nanoid = (t) => e.check(/* @__PURE__ */ Fr(Pa, t)), e.guid = (t) => e.check(/* @__PURE__ */ Or(ka, t)), e.cuid = (t) => e.check(/* @__PURE__ */ Ir(Fa, t)), e.cuid2 = (t) => e.check(/* @__PURE__ */ Lr(Ia, t)), e.ulid = (t) => e.check(/* @__PURE__ */ Rr(La, t)), e.base64 = (t) => e.check(/* @__PURE__ */ Gr(Wa, t)), e.base64url = (t) => e.check(/* @__PURE__ */ Kr(Ga, t)), e.xid = (t) => e.check(/* @__PURE__ */ zr(Ra, t)), e.ksuid = (t) => e.check(/* @__PURE__ */ Br(za, t)), e.ipv4 = (t) => e.check(/* @__PURE__ */ Vr(Ba, t)), e.ipv6 = (t) => e.check(/* @__PURE__ */ Hr(Va, t)), e.cidrv4 = (t) => e.check(/* @__PURE__ */ Ur(Ha, t)), e.cidrv6 = (t) => e.check(/* @__PURE__ */ Wr(Ua, t)), e.e164 = (t) => e.check(/* @__PURE__ */ qr(Ka, t)), e.datetime = (t) => e.check(na(t)), e.date = (t) => e.check(ia(t)), e.time = (t) => e.check(oa(t)), e.duration = (t) => e.check(ca(t));
});
function Da(e) {
	return /* @__PURE__ */ Er(Ea, e);
}
var q = /*@__PURE__*/ H("ZodStringFormat", (e, t) => {
	K.init(e, t), Ta.init(e, t);
}), Oa = /*@__PURE__*/ H("ZodEmail", (e, t) => {
	gn.init(e, t), q.init(e, t);
}), ka = /*@__PURE__*/ H("ZodGUID", (e, t) => {
	mn.init(e, t), q.init(e, t);
}), Aa = /*@__PURE__*/ H("ZodUUID", (e, t) => {
	hn.init(e, t), q.init(e, t);
}), ja = /*@__PURE__*/ H("ZodURL", (e, t) => {
	_n.init(e, t), q.init(e, t);
});
function Ma(e) {
	return /* @__PURE__ */ Nr(ja, e);
}
var Na = /*@__PURE__*/ H("ZodEmoji", (e, t) => {
	vn.init(e, t), q.init(e, t);
}), Pa = /*@__PURE__*/ H("ZodNanoID", (e, t) => {
	yn.init(e, t), q.init(e, t);
}), Fa = /*@__PURE__*/ H("ZodCUID", (e, t) => {
	bn.init(e, t), q.init(e, t);
}), Ia = /*@__PURE__*/ H("ZodCUID2", (e, t) => {
	xn.init(e, t), q.init(e, t);
}), La = /*@__PURE__*/ H("ZodULID", (e, t) => {
	Sn.init(e, t), q.init(e, t);
}), Ra = /*@__PURE__*/ H("ZodXID", (e, t) => {
	Cn.init(e, t), q.init(e, t);
}), za = /*@__PURE__*/ H("ZodKSUID", (e, t) => {
	wn.init(e, t), q.init(e, t);
}), Ba = /*@__PURE__*/ H("ZodIPv4", (e, t) => {
	kn.init(e, t), q.init(e, t);
}), Va = /*@__PURE__*/ H("ZodIPv6", (e, t) => {
	An.init(e, t), q.init(e, t);
}), Ha = /*@__PURE__*/ H("ZodCIDRv4", (e, t) => {
	jn.init(e, t), q.init(e, t);
}), Ua = /*@__PURE__*/ H("ZodCIDRv6", (e, t) => {
	Mn.init(e, t), q.init(e, t);
}), Wa = /*@__PURE__*/ H("ZodBase64", (e, t) => {
	Pn.init(e, t), q.init(e, t);
}), Ga = /*@__PURE__*/ H("ZodBase64URL", (e, t) => {
	In.init(e, t), q.init(e, t);
}), Ka = /*@__PURE__*/ H("ZodE164", (e, t) => {
	Ln.init(e, t), q.init(e, t);
}), qa = /*@__PURE__*/ H("ZodJWT", (e, t) => {
	zn.init(e, t), q.init(e, t);
}), Ja = /*@__PURE__*/ H("ZodNumber", (e, t) => {
	Bn.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ii(e, t, n, r), Ca(e, "ZodNumber", {
		gt(e, t) {
			return this.check(/* @__PURE__ */ ai(e, t));
		},
		gte(e, t) {
			return this.check(/* @__PURE__ */ oi(e, t));
		},
		min(e, t) {
			return this.check(/* @__PURE__ */ oi(e, t));
		},
		lt(e, t) {
			return this.check(/* @__PURE__ */ ri(e, t));
		},
		lte(e, t) {
			return this.check(/* @__PURE__ */ ii(e, t));
		},
		max(e, t) {
			return this.check(/* @__PURE__ */ ii(e, t));
		},
		int(e) {
			return this.check(Za(e));
		},
		safe(e) {
			return this.check(Za(e));
		},
		positive(e) {
			return this.check(/* @__PURE__ */ ai(0, e));
		},
		nonnegative(e) {
			return this.check(/* @__PURE__ */ oi(0, e));
		},
		negative(e) {
			return this.check(/* @__PURE__ */ ri(0, e));
		},
		nonpositive(e) {
			return this.check(/* @__PURE__ */ ii(0, e));
		},
		multipleOf(e, t) {
			return this.check(/* @__PURE__ */ si(e, t));
		},
		step(e, t) {
			return this.check(/* @__PURE__ */ si(e, t));
		},
		finite() {
			return this;
		}
	});
	let n = e._zod.bag;
	e.minValue = Math.max(n.minimum ?? -Infinity, n.exclusiveMinimum ?? -Infinity) ?? null, e.maxValue = Math.min(n.maximum ?? Infinity, n.exclusiveMaximum ?? Infinity) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? .5), e.isFinite = !0, e.format = n.format ?? null;
});
function Ya(e) {
	return /* @__PURE__ */ $r(Ja, e);
}
var Xa = /*@__PURE__*/ H("ZodNumberFormat", (e, t) => {
	Vn.init(e, t), Ja.init(e, t);
});
function Za(e) {
	return /* @__PURE__ */ ei(Xa, e);
}
var Qa = /*@__PURE__*/ H("ZodUnknown", (e, t) => {
	Hn.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (e, t, n) => void 0;
});
function $a() {
	return /* @__PURE__ */ ti(Qa);
}
var eo = /*@__PURE__*/ H("ZodNever", (e, t) => {
	Un.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Li(e, t, n, r);
});
function to(e) {
	return /* @__PURE__ */ ni(eo, e);
}
var no = /*@__PURE__*/ H("ZodArray", (e, t) => {
	Gn.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Hi(e, t, n, r), e.element = t.element, Ca(e, "ZodArray", {
		min(e, t) {
			return this.check(/* @__PURE__ */ li(e, t));
		},
		nonempty(e) {
			return this.check(/* @__PURE__ */ li(1, e));
		},
		max(e, t) {
			return this.check(/* @__PURE__ */ ci(e, t));
		},
		length(e, t) {
			return this.check(/* @__PURE__ */ ui(e, t));
		},
		unwrap() {
			return this.element;
		}
	});
});
function ro(e, t) {
	return /* @__PURE__ */ Ci(no, e, t);
}
var io = /*@__PURE__*/ H("ZodObject", (e, t) => {
	Xn.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ui(e, t, n, r), W(e, "shape", () => t.shape), Ca(e, "ZodObject", {
		keyof() {
			return ho(Object.keys(this._zod.def.shape));
		},
		catchall(e) {
			return this.clone({
				...this._zod.def,
				catchall: e
			});
		},
		passthrough() {
			return this.clone({
				...this._zod.def,
				catchall: $a()
			});
		},
		loose() {
			return this.clone({
				...this._zod.def,
				catchall: $a()
			});
		},
		strict() {
			return this.clone({
				...this._zod.def,
				catchall: to()
			});
		},
		strip() {
			return this.clone({
				...this._zod.def,
				catchall: void 0
			});
		},
		extend(e) {
			return ze(this, e);
		},
		safeExtend(e) {
			return Be(this, e);
		},
		merge(e) {
			return Ve(this, e);
		},
		pick(e) {
			return Le(this, e);
		},
		omit(e) {
			return Re(this, e);
		},
		partial(...e) {
			return He(bo, this, e[0]);
		},
		required(...e) {
			return Ue(Ao, this, e[0]);
		}
	});
});
function ao(e, t) {
	return new io({
		type: "object",
		shape: e ?? {},
		...G(t)
	});
}
function oo(e, t) {
	return new io({
		type: "object",
		shape: e,
		catchall: to(),
		...G(t)
	});
}
var so = /*@__PURE__*/ H("ZodUnion", (e, t) => {
	Qn.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Wi(e, t, n, r), e.options = t.options;
});
function co(e, t) {
	return new so({
		type: "union",
		options: e,
		...G(t)
	});
}
var lo = /*@__PURE__*/ H("ZodIntersection", (e, t) => {
	$n.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Gi(e, t, n, r);
});
function uo(e, t) {
	return new lo({
		type: "intersection",
		left: e,
		right: t
	});
}
var fo = /*@__PURE__*/ H("ZodRecord", (e, t) => {
	nr.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ki(e, t, n, r), e.keyType = t.keyType, e.valueType = t.valueType;
});
function po(e, t, n) {
	let r = Pe(e);
	return r._zod.values = void 0, new fo({
		type: "record",
		keyType: r,
		valueType: t,
		...G(n)
	});
}
var mo = /*@__PURE__*/ H("ZodEnum", (e, t) => {
	rr.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ri(e, t, n, r), e.enum = t.entries, e.options = Object.values(t.entries);
	let n = new Set(Object.keys(t.entries));
	e.extract = (e, r) => {
		let i = {};
		for (let r of e) if (n.has(r)) i[r] = t.entries[r];
		else throw Error(`Key ${r} not found in enum`);
		return new mo({
			...t,
			checks: [],
			...G(r),
			entries: i
		});
	}, e.exclude = (e, r) => {
		let i = { ...t.entries };
		for (let t of e) if (n.has(t)) delete i[t];
		else throw Error(`Key ${t} not found in enum`);
		return new mo({
			...t,
			checks: [],
			...G(r),
			entries: i
		});
	};
});
function ho(e, t) {
	return new mo({
		type: "enum",
		entries: Array.isArray(e) ? Object.fromEntries(e.map((e) => [e, e])) : e,
		...G(t)
	});
}
var go = /*@__PURE__*/ H("ZodLiteral", (e, t) => {
	ir.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => zi(e, t, n, r), e.values = new Set(t.values), Object.defineProperty(e, "value", { get() {
		if (t.values.length > 1) throw Error("This schema contains multiple valid literal values. Use `.values` instead.");
		return t.values[0];
	} });
});
function _o(e, t) {
	return new go({
		type: "literal",
		values: Array.isArray(e) ? e : [e],
		...G(t)
	});
}
var vo = /*@__PURE__*/ H("ZodTransform", (e, t) => {
	ar.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Vi(e, t, n, r), e._zod.parse = (n, r) => {
		if (r.direction === "backward") throw new me(e.constructor.name);
		n.addIssue = (r) => {
			if (typeof r == "string") n.issues.push(Xe(r, n.value, t));
			else {
				let t = r;
				t.fatal && (t.continue = !1), t.code ??= "custom", t.input ??= n.value, t.inst ??= e, n.issues.push(Xe(t));
			}
		};
		let i = t.transform(n.value, n);
		return i instanceof Promise ? i.then((e) => (n.value = e, n.fallback = !0, n)) : (n.value = i, n.fallback = !0, n);
	};
});
function yo(e) {
	return new vo({
		type: "transform",
		transform: e
	});
}
var bo = /*@__PURE__*/ H("ZodOptional", (e, t) => {
	sr.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => ea(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function xo(e) {
	return new bo({
		type: "optional",
		innerType: e
	});
}
var So = /*@__PURE__*/ H("ZodExactOptional", (e, t) => {
	cr.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => ea(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Co(e) {
	return new So({
		type: "optional",
		innerType: e
	});
}
var wo = /*@__PURE__*/ H("ZodNullable", (e, t) => {
	lr.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => qi(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function To(e) {
	return new wo({
		type: "nullable",
		innerType: e
	});
}
var Eo = /*@__PURE__*/ H("ZodDefault", (e, t) => {
	ur.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Yi(e, t, n, r), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Do(e, t) {
	return new Eo({
		type: "default",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : je(t);
		}
	});
}
var Oo = /*@__PURE__*/ H("ZodPrefault", (e, t) => {
	fr.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Xi(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function ko(e, t) {
	return new Oo({
		type: "prefault",
		innerType: e,
		get defaultValue() {
			return typeof t == "function" ? t() : je(t);
		}
	});
}
var Ao = /*@__PURE__*/ H("ZodNonOptional", (e, t) => {
	pr.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Ji(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function jo(e, t) {
	return new Ao({
		type: "nonoptional",
		innerType: e,
		...G(t)
	});
}
var Mo = /*@__PURE__*/ H("ZodCatch", (e, t) => {
	hr.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Zi(e, t, n, r), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function No(e, t) {
	return new Mo({
		type: "catch",
		innerType: e,
		catchValue: typeof t == "function" ? t : () => t
	});
}
var Po = /*@__PURE__*/ H("ZodPipe", (e, t) => {
	gr.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Qi(e, t, n, r), e.in = t.in, e.out = t.out;
});
function Fo(e, t) {
	return new Po({
		type: "pipe",
		in: e,
		out: t
	});
}
var Io = /*@__PURE__*/ H("ZodReadonly", (e, t) => {
	vr.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => $i(e, t, n, r), e.unwrap = () => e._zod.def.innerType;
});
function Lo(e) {
	return new Io({
		type: "readonly",
		innerType: e
	});
}
var Ro = /*@__PURE__*/ H("ZodCustom", (e, t) => {
	br.init(e, t), wa.init(e, t), e._zod.processJSONSchema = (t, n, r) => Bi(e, t, n, r);
});
function zo(e, t = {}) {
	return /* @__PURE__ */ wi(Ro, e, t);
}
function Bo(e, t) {
	return /* @__PURE__ */ Ti(e, t);
}
var Vo = ho([
	"opener.spinner.tick",
	"opener.reveal.bad",
	"opener.reveal.rare",
	"opener.reveal.mega",
	"battle.spinner.tick",
	"battle.reveal.bad",
	"battle.reveal.rare",
	"battle.reveal.mega"
]), Ho = [
	{
		key: "opener.spinner.tick",
		label: "Reel tick",
		description: "A reel item passes the pointer",
		group: "Box opening"
	},
	{
		key: "opener.reveal.bad",
		label: "Low pull",
		description: "A low-value pull settles",
		group: "Box opening"
	},
	{
		key: "opener.reveal.rare",
		label: "Good pull",
		description: "A good pull settles",
		group: "Box opening"
	},
	{
		key: "opener.reveal.mega",
		label: "Big win",
		description: "A top-tier pull settles",
		group: "Box opening"
	},
	{
		key: "battle.spinner.tick",
		label: "Reel tick",
		description: "A battle reel item passes the pointer",
		group: "Battles",
		fallback: "opener.spinner.tick"
	},
	{
		key: "battle.reveal.bad",
		label: "Low pull",
		description: "A low-value battle pull settles",
		group: "Battles",
		fallback: "opener.reveal.bad"
	},
	{
		key: "battle.reveal.rare",
		label: "Good pull",
		description: "A good battle pull settles",
		group: "Battles",
		fallback: "opener.reveal.rare"
	},
	{
		key: "battle.reveal.mega",
		label: "Big win",
		description: "A top-tier battle pull settles",
		group: "Battles",
		fallback: "opener.reveal.mega"
	}
];
function Uo(e) {
	let { protocol: t, hostname: n } = new URL(e);
	return t === "https:" || t === "http:" && (n === "localhost" || n === "127.0.0.1");
}
po(Vo, co([oo({
	url: Ma({ protocol: /^https?$/ }).max(2048).refine(Uo, "the sound URL must be https"),
	gainDb: Ya().min(-24).max(6).optional()
}), oo({ off: _o(!0) })])), po(Vo, co([ao({
	url: Da(),
	gainDb: Ya()
}), ao({ off: _o(!0) })]));
function Wo(e) {
	return (Math.min(100, Math.max(0, e)) / 100) ** 2;
}
//#endregion
//#region src/utils/cx.ts
function J(...e) {
	return e.filter(Boolean).join(" ");
}
//#endregion
//#region src/battle/BattlesIcon.tsx
function Go({ size: e = 16, className: t }) {
	return /* @__PURE__ */ B("svg", {
		"aria-hidden": "true",
		className: t,
		width: e,
		height: e,
		viewBox: "0 0 40 40",
		fill: "currentColor",
		xmlns: "http://www.w3.org/2000/svg",
		children: /* @__PURE__ */ B("path", { d: "M25.156 2.703c-.083.11-.902 1.18-1.829 2.382-.923 1.197-1.972 2.564-2.334 3.03-.356.466-.757.98-.883 1.14l-.235.297-3.361.008-3.361.013.849.431c.465.236 1.245.632 1.728.88l.875.457-.235.553c-.13.305-.266.61-.296.684-.035.07-.222.513-.418.979s-.588 1.389-.87 2.046c-.284.658-.615 1.441-.74 1.742-.127.3-.275.64-.327.762a45 45 0 0 0-.275.63c-.418.99-1.058 2.504-1.532 3.614-.279.658-.523 1.237-.54 1.28-.013.044-.04.07-.052.061-.013-.013 0-1.119.022-2.455.143-7.532.165-9.495.113-9.548a8 8 0 0 0-.675-.322c-.348-.157-1.102-.492-1.676-.749-2.094-.936-2.386-1.066-2.408-1.066-.026 0 .035 12.782.074 15.412l.026 1.806h7.662l.144-.283c.079-.156.388-.831.693-1.502.635-1.415 1.558-3.46 1.785-3.962.087-.191.23-.509.326-.71.092-.2.166-.37.166-.378s.056-.14.126-.292.187-.413.265-.579c.079-.17.214-.47.305-.674.274-.619 1.602-3.57 1.842-4.093.126-.274.614-1.367.857-1.915.179-.405.388-.867.871-1.938.174-.383.4-.884.5-1.11s.414-.923.697-1.546l.793-1.763c.157-.348.33-.74.392-.87.06-.131.274-.614.479-1.067.204-.457.448-.993.54-1.193.19-.414.186-.396.117-.392-.03 0-.122.092-.2.2M24.32 13.187c-.832.091-1.472.257-1.981.51-.41.208-.958.787-1.206 1.275-.257.505-.296.631-.557 1.828-.122.549-.266 1.206-.327 1.459-.257 1.106-.305 1.754-.161 2.268.213.762.71 1.11 3.644 2.564 2.277 1.124 2.808 1.463 2.808 1.79 0 .178-.344 1.693-.418 1.833-.135.26-.213.274-1.628.274-1.389 0-1.454-.009-1.506-.226-.022-.075.047-.475.191-1.12.122-.548.213-1.01.2-1.023-.008-.012-1.132.2-2.49.475-1.358.27-2.512.505-2.56.514-.1.017-.157.13-.714 1.38-.052.117-.257.579-.457 1.023s-.492 1.097-.653 1.459c-.161.357-.34.761-.4.892-.061.13-.236.514-.384.849-.152.335-.413.923-.587 1.306-.31.692-1.324 2.956-1.49 3.33-.047.11-.165.358-.256.558-.096.2-.17.37-.17.383 0 .009-.07.165-.157.348-.16.331-.17.453-.021.296.047-.043.444-.553.883-1.127a1251 1251 0 0 1 2.295-2.983c.823-1.066 1.75-2.277 2.068-2.686.409-.544.587-.744.635-.723.214.088.823.244 1.198.31.383.065.831.074 3.722.074 2.93 0 3.335-.01 3.744-.079.744-.122 1.171-.244 1.602-.448.67-.322 1.145-.866 1.476-1.694.135-.348.196-.583.557-2.242.083-.37.187-.853.24-1.066.048-.218.1-.619.117-.893.04-.77-.109-1.219-.535-1.61-.462-.427-.989-.715-4.154-2.256-.97-.474-1.462-.77-1.763-1.075-.235-.235-.24-.275-.082-1.002.26-1.236.317-1.375.622-1.458.087-.022.684-.044 1.323-.044 1.29 0 1.437.022 1.494.244.026.105-.083.68-.335 1.755-.048.2-.079.374-.066.387.022.022.24-.022 2.268-.457 1.746-.374 2.473-.536 2.49-.549.014-.017.249-1.031.41-1.793.109-.527.109-1.145-.004-1.507a1.68 1.68 0 0 0-.601-.835c-.361-.244-1.05-.427-1.903-.51-.696-.065-5.781-.048-6.421.022" })
	});
}
var Y = {
	root: "_root_1opuf_5",
	grid: "_grid_1opuf_20",
	column: "_column_1opuf_32",
	columnLastInRow: "_columnLastInRow_1opuf_42",
	columnLastRow: "_columnLastRow_1opuf_46",
	columnGrid: "_columnGrid_1opuf_50",
	columnInner: "_columnInner_1opuf_54",
	columnInnerCompact: "_columnInnerCompact_1opuf_70",
	columnInnerGrid: "_columnInnerGrid_1opuf_74",
	columnInnerBare: "_columnInnerBare_1opuf_78",
	header: "_header_1opuf_85",
	headerRight: "_headerRight_1opuf_97",
	headerCompact: "_headerCompact_1opuf_108",
	viewport: "_viewport_1opuf_117",
	viewportVertical: "_viewportVertical_1opuf_127",
	viewportHorizontal: "_viewportHorizontal_1opuf_131",
	viewportAbsoluteTop: "_viewportAbsoluteTop_1opuf_135",
	viewportAbsoluteCenter: "_viewportAbsoluteCenter_1opuf_140",
	fade: "_fade_1opuf_147",
	fadeLeft: "_fadeLeft_1opuf_152",
	fadeRight: "_fadeRight_1opuf_163",
	fadeTop: "_fadeTop_1opuf_174",
	fadeBottom: "_fadeBottom_1opuf_188",
	frame: "_frame_1opuf_204",
	rail: "_rail_1opuf_212",
	railStartHorizontal: "_railStartHorizontal_1opuf_216",
	railStartHorizontalFlipped: "_railStartHorizontalFlipped_1opuf_222",
	railEndHorizontal: "_railEndHorizontal_1opuf_228",
	railEndHorizontalFlipped: "_railEndHorizontalFlipped_1opuf_234",
	railStartVertical: "_railStartVertical_1opuf_240",
	railEndVertical: "_railEndVertical_1opuf_246",
	reelViewport: "_reelViewport_1opuf_254",
	reelClip: "_reelClip_1opuf_261",
	reelClipHorizontal: "_reelClipHorizontal_1opuf_266",
	reel: "_reel_1opuf_254",
	reelVertical: "_reelVertical_1opuf_281",
	slotAnchor: "_slotAnchor_1opuf_285",
	slot: "_slot_1opuf_285",
	slotCard: "_slotCard_1opuf_299",
	slotImageFrame: "_slotImageFrame_1opuf_309",
	slotImage: "_slotImage_1opuf_309",
	slotImageRevealed: "_slotImageRevealed_1opuf_327",
	slotImageMissing: "_slotImageMissing_1opuf_332",
	slotValue: "_slotValue_1opuf_340",
	slotValueCompact: "_slotValueCompact_1opuf_352",
	slotValueCompactTarget: "_slotValueCompactTarget_1opuf_357",
	glow: "_glow_1opuf_362",
	glowSmall: "_glowSmall_1opuf_371",
	glowVertical: "_glowVertical_1opuf_375",
	emptyReel: "_emptyReel_1opuf_381",
	emptyReelVertical: "_emptyReelVertical_1opuf_391",
	emptyCard: "_emptyCard_1opuf_395",
	emptyIcon: "_emptyIcon_1opuf_406",
	vsChip: "_vsChip_1opuf_412",
	vsChipBox: "_vsChipBox_1opuf_419",
	starting: "_starting_1opuf_433",
	startingLabel: "_startingLabel_1opuf_450",
	startingLuck: "_startingLuck_1opuf_458",
	startingCount: "_startingCount_1opuf_462",
	startingDigit: "_startingDigit_1opuf_471",
	startingGo: "_startingGo_1opuf_481",
	startingSeats: "_startingSeats_1opuf_486",
	results: "_results_1opuf_494",
	resultsSeat: "_resultsSeat_1opuf_500",
	resultsHeader: "_resultsHeader_1opuf_506",
	resultsTotal: "_resultsTotal_1opuf_517",
	resultsCards: "_resultsCards_1opuf_533",
	resultCard: "_resultCard_1opuf_543",
	resultCardImage: "_resultCardImage_1opuf_557",
	resultCardImageMissing: "_resultCardImageMissing_1opuf_565",
	resultCardName: "_resultCardName_1opuf_571",
	resultCardValue: "_resultCardValue_1opuf_584",
	resultPlaceholder: "_resultPlaceholder_1opuf_591",
	resultPlaceholderLabel: "_resultPlaceholderLabel_1opuf_600",
	resultPlaceholderNumber: "_resultPlaceholderNumber_1opuf_606",
	resultsMobile: "_resultsMobile_1opuf_612",
	resultsMobileSeat: "_resultsMobileSeat_1opuf_619",
	resultsMobileHeader: "_resultsMobileHeader_1opuf_626",
	resultsMobileTotal: "_resultsMobileTotal_1opuf_634",
	resultsMobileStrip: "_resultsMobileStrip_1opuf_641",
	laneReel: "_laneReel_1opuf_655",
	laneViewport: "_laneViewport_1opuf_662",
	viewportBareHorizontal: "_viewportBareHorizontal_1opuf_667",
	viewportBareVertical: "_viewportBareVertical_1opuf_668"
}, Ko = .68, qo = .25, Jo = 1, Yo = 1, Xo = 107 / 128, Zo = 96 / 128, Qo = .5, $o = .3, es = 68, ts = 108, ns = 81, rs = 52, is = 44, as = 70, os = 51, ss = 37, cs = 6, ls = 22, us = 79, ds = 126, fs = 42, ps = 54, ms = 162, hs = 64, gs = -95, _s = 1, vs = 8, ys = 6, bs = 32, xs = 16, Ss = 111, Cs = 100, ws = 83, Ts = 81, Es = 51, Ds = 24, Os = 65 / 80, ks = 60 / 71, As = .25, js = 8, Ms = 6;
function Ns(e, t) {
	let n = [], r = 0;
	for (let i of e) n.push(r), r += i + t;
	return n;
}
function Ps({ index: e, endingItemIdx: t, isHorizontal: n, itemHeight: r, itemWidth: i }) {
	return n ? i <= 60 ? e === t ? Ts : Es : e === t ? i : i <= 100 ? ws : Math.abs(e - t) === 1 ? Ss : Cs : e === t ? ms : e === t - 1 ? ps : e === t + 1 ? hs : r;
}
function Fs({ isHorizontal: e, itemWidth: t }) {
	return e ? t <= 60 ? Ds : t <= 100 ? xs : bs : fs;
}
function Is({ index: e, endingItemIdx: t, isHorizontal: n, itemWidth: r }) {
	return n ? e === t && r <= 60 ? -3 : e === t && r >= 120 ? 6 : 0 : e === t ? -28 : e === t - 1 ? gs : e === t + 1 ? _s : 0;
}
function Ls({ offset: e, index: t, endingItemIdx: n, isHorizontal: r, itemHeight: i, itemWidth: a, slotMainSize: o }) {
	return r ? e + o / 2 : e + Is({
		index: t,
		endingItemIdx: n,
		isHorizontal: r,
		itemWidth: a
	}) + i / 2;
}
function Rs(e) {
	return 68 + e / 2;
}
function zs(e) {
	return Ko + .31999999999999995 * e;
}
function Bs(e) {
	return qo + .75 * e;
}
function Vs({ distance: e, itemWidth: t }) {
	let n = Us(t);
	return Ws({
		distance: e,
		nearDistance: n.nearDistance,
		farDistance: n.farDistance,
		centerValue: Jo,
		nearValue: n.nearScale,
		farValue: n.farScale,
		baseValue: Ko
	});
}
function Hs({ distance: e, itemWidth: t }) {
	let n = Us(t);
	return Ws({
		distance: e,
		nearDistance: n.nearDistance,
		farDistance: n.farDistance,
		centerValue: Yo,
		nearValue: n.nearOpacity,
		farValue: n.farOpacity,
		baseValue: qo
	});
}
function Us(e) {
	let t = e <= 100, n = e <= 60, r = Fs({
		isHorizontal: !0,
		itemWidth: e
	}), i = n ? Es : t ? ws : Ss, a = n ? Es : t ? ws : Cs, o = n ? Os : e === 71 ? ks : Xo, s = n ? Os : e === 71 ? ks : t ? Xo : Zo, c = n ? As : Qo, l = n ? As : t ? Qo : $o, u = e / 2 + r + i / 2;
	return {
		nearDistance: u,
		farDistance: u + i / 2 + r + a / 2,
		nearScale: o,
		farScale: s,
		nearOpacity: c,
		farOpacity: l
	};
}
function Ws({ distance: e, nearDistance: t, farDistance: n, centerValue: r, nearValue: i, farValue: a, baseValue: o }) {
	return Gs(e <= t ? {
		progress: e / t,
		from: r,
		to: i
	} : e <= n ? {
		progress: (e - t) / (n - t),
		from: i,
		to: a
	} : {
		progress: Math.min(1, (e - n) / t),
		from: a,
		to: o
	});
}
function Gs({ progress: e, from: t, to: n }) {
	return t + (n - t) * e;
}
function Ks({ isHorizontal: e, itemWidth: t }) {
	return e ? t <= 60 ? {
		width: os,
		height: ss
	} : t === 71 ? {
		width: is,
		height: as
	} : t <= 100 ? {
		width: ns,
		height: rs
	} : {
		width: es,
		height: ts
	} : {
		width: us,
		height: ds
	};
}
function qs(e) {
	return e === 71 ? cs : e <= 60 ? ls : 40;
}
function Js({ index: e, endingItemIdx: t, isHorizontal: n, itemWidth: r }) {
	return n ? r === 71 ? e === t ? js : Ms : e === t && r <= 60 ? 9 : 4 : e === t ? vs : ys;
}
//#endregion
//#region src/battle/BattleEmptyReel.tsx
var Ys = [
	.12,
	.2,
	.36,
	.58,
	.36,
	.2,
	.12
];
function Xs({ orientation: e, item: t }) {
	return /* @__PURE__ */ B("div", {
		"aria-hidden": !0,
		className: J(Y.emptyReel, e === "vertical" && Y.emptyReelVertical),
		style: { gap: 12 },
		"data-los-battle-empty-reel": !0,
		children: Ys.map((e, n) => /* @__PURE__ */ B("div", {
			className: Y.emptyCard,
			style: {
				height: t.itemHeight,
				width: t.itemWidth,
				opacity: e
			},
			children: /* @__PURE__ */ B(Go, {
				size: Math.min(52, t.itemWidth - 12),
				className: Y.emptyIcon
			})
		}, n))
	});
}
//#endregion
//#region src/spinner/timings.ts
var Zs = 300, Qs = 2500, $s = 1500, ec = 250, tc = 150, nc = 3, rc = 35, ic = {
	normal: 1500,
	quick: 1e3
};
//#endregion
//#region src/spinner/wheel.ts
function ac(e, t, n) {
	let r = [];
	for (let i = 0; i < t; i++) {
		let t;
		t = n ? ce(n, 1, _) : Math.round(Math.random() * _);
		let i = e[m(e, t) ?? 0];
		i && r.push(i);
	}
	return r;
}
function oc(e, t, n, r) {
	let i = ac(e.dropTable, t + 5, r).map((t) => ({
		...t,
		rarity: c(t.value, e.priceCents ?? 0),
		chance: b(t.weight ?? 0)
	}));
	return n && i.splice(t, 0, {
		...n,
		rarity: c(n.value, e.priceCents ?? 0),
		chance: i.find((e) => e.itemId === n.itemId)?.chance || b(n.weight ?? 0)
	}), i;
}
//#endregion
//#region src/battle/BattleSpinnerSlot.tsx
var sc = .45, cc = te(function({ item: e, isTarget: t, revealed: r, itemHeight: i, itemWidth: a, isHorizontal: o, slotMainSize: s, slotVisualOffset: c, labelGap: u, itemCenter: d, centerProgressDistance: f, containerCenter: p, reelOffset: m, lockDurationSec: h, isAnimating: g }) {
	let { theme: _, currency: v } = l(), y = t && r, b = oe(+!!y), x = (e) => Math.max(0, Math.min(1, 1 - e / f)), S = se(m, (e) => {
		let n = Math.abs(e + d - p);
		if (o) return `translate3d(0, ${c}px, 0) scale(${Vs({
			distance: n,
			itemWidth: a
		})})`;
		let r = zs(x(n));
		return `translate3d(0, ${t ? c + i / 2 * (1 - r) : c}px, 0) scale(${r})`;
	}), C = se([m, b], (e) => {
		let n = e[0] ?? 0, r = e[1] ?? 0, i = Math.abs(n + d - p), s = o ? Hs({
			distance: i,
			itemWidth: a
		}) : Bs(x(i)), c = Math.min(s, .65);
		return t ? c + (1 - c) * r : c;
	}), w = se(m, (e) => Math.round(x(Math.abs(e + d - p)) * 10));
	P(() => {
		if (!t) {
			b.set(0);
			return;
		}
		let e = ie(b, +!!y, {
			type: "tween",
			duration: Math.min(h, sc),
			ease: "easeOut"
		});
		return () => e.stop();
	}, [
		t,
		b,
		h,
		y
	]);
	let T = a <= 60;
	return /* @__PURE__ */ V(ae.div, {
		className: Y.slot,
		"data-los-target": t ? "true" : void 0,
		style: {
			width: o ? s : "100%",
			height: o ? i : s,
			zIndex: y ? 15 : o ? void 0 : w,
			willChange: g ? "transform, opacity" : void 0
		},
		children: [t && !o ? /* @__PURE__ */ B(lc, {
			color: E(_.railHex, e.rarity),
			itemWidth: a,
			lockProgress: b
		}) : null, /* @__PURE__ */ V(ae.div, {
			className: Y.slotCard,
			style: {
				width: a,
				gap: u,
				transform: S,
				transformOrigin: o ? "center center" : "center top",
				willChange: g ? "transform" : void 0
			},
			children: [/* @__PURE__ */ B(ae.div, {
				className: Y.slotImageFrame,
				style: {
					width: a,
					height: i,
					opacity: C,
					willChange: y || g ? "opacity" : void 0
				},
				children: e.imageUrl ? /* @__PURE__ */ B("img", {
					"data-los-battle-card": !0,
					src: e.imageUrl,
					alt: e.name,
					loading: "eager",
					decoding: "async",
					width: a,
					height: i,
					className: J(Y.slotImage, y && Y.slotImageRevealed),
					style: { borderRadius: a < 90 ? 4 : 8 }
				}) : /* @__PURE__ */ B("span", {
					"data-los-battle-card": !0,
					"aria-hidden": !0,
					className: Y.slotImageMissing,
					style: { borderRadius: a < 90 ? 4 : 8 }
				})
			}), /* @__PURE__ */ B(ae.div, {
				style: { opacity: C },
				children: /* @__PURE__ */ B("span", {
					className: J(Y.slotValue, T && (t ? Y.slotValueCompactTarget : Y.slotValueCompact)),
					children: n(e.value, v, { compact: !0 })
				})
			})]
		})]
	});
});
function lc({ color: e, itemWidth: t, lockProgress: n }) {
	let r = se(n, (e) => e * .8), i = Ks({
		isHorizontal: !1,
		itemWidth: t
	});
	return /* @__PURE__ */ B(ae.div, {
		"aria-hidden": !0,
		className: J(Y.glow, Y.glowVertical),
		style: {
			backgroundColor: e,
			height: i.height,
			width: i.width,
			opacity: r
		}
	});
}
function uc({ slotOffsets: e, slotMainSizes: t, viewportStart: n, viewportEnd: r, bufferPx: i, bufferStartPx: a = i, bufferEndPx: o = i }) {
	let s = Math.min(e.length, t.length);
	if (s <= 0) return null;
	let c = n - a, l = r + o, u = dc({
		slotOffsets: e,
		slotMainSizes: t,
		slotCount: s,
		startBoundary: c
	}), d = fc({
		slotOffsets: e,
		slotCount: s,
		endBoundary: l
	});
	if (u < 0 || d < 0 || u > d) {
		let n = e[0] ?? 0, r = s - 1, i = (e[r] ?? 0) + (t[r] ?? 0);
		return l < n ? {
			startIndex: 0,
			endIndex: 0
		} : c > i ? {
			startIndex: r,
			endIndex: r
		} : null;
	}
	return {
		startIndex: u,
		endIndex: d
	};
}
function dc({ slotOffsets: e, slotMainSizes: t, slotCount: n, startBoundary: r }) {
	let i = 0, a = n - 1, o = -1;
	for (; i <= a;) {
		let n = Math.floor((i + a) / 2);
		(e[n] ?? 0) + (t[n] ?? 0) < r ? i = n + 1 : (o = n, a = n - 1);
	}
	return o;
}
function fc({ slotOffsets: e, slotCount: t, endBoundary: n }) {
	let r = 0, i = t - 1, a = -1;
	for (; r <= i;) {
		let t = Math.floor((r + i) / 2);
		(e[t] ?? 0) > n ? i = t - 1 : (a = t, r = t + 1);
	}
	return a;
}
function pc({ visibleRange: e, targetIndex: t, slotCount: n, targetOverscanSlots: r = 1 }) {
	if (n <= 0) return [];
	let i = n - 1, a = vc(t - r, t + r, i);
	return yc([e ? vc(e.startIndex, e.endIndex, i) : a, a]);
}
function mc({ visibleRange: e, slotCount: t, stepSlots: n }) {
	if (!e || t <= 0 || n <= 1) return e;
	let r = t - 1;
	return vc(Math.floor(e.startIndex / n) * n, Math.ceil(e.endIndex / n) * n, r);
}
function hc({ targetIndex: e, slotCount: t, overscanSlots: n = 6 }) {
	return t <= 0 ? null : vc(3 - n, e + n, t - 1);
}
function gc(e) {
	let t = [], n = /* @__PURE__ */ new Set();
	for (let r of e) for (let e = r.startIndex; e <= r.endIndex; e += 1) n.has(e) || (n.add(e), t.push(e));
	return t;
}
function _c(e, t) {
	let n = e[0];
	if (n === void 0) return -1;
	if (t <= n) return 0;
	let r = e.length - 1, i = e[r];
	if (i !== void 0 && t >= i) return r;
	let a = 0, o = r;
	for (; a < o;) {
		let n = Math.floor((a + o) / 2);
		(e[n] ?? Infinity) < t ? a = n + 1 : o = n;
	}
	let s = a, c = Math.max(0, s - 1), l = e[c] ?? 0, u = e[s] ?? l;
	return t - l <= u - t ? c : s;
}
function vc(e, t, n) {
	return {
		startIndex: Math.max(0, Math.min(e, n)),
		endIndex: Math.max(0, Math.min(t, n))
	};
}
function yc(e) {
	let t = e.filter((e) => e.startIndex <= e.endIndex).sort((e, t) => e.startIndex - t.startIndex), n = [];
	for (let e of t) {
		let t = n[n.length - 1];
		if (!t || e.startIndex > t.endIndex + 1) {
			n.push({ ...e });
			continue;
		}
		t.endIndex = Math.max(t.endIndex, e.endIndex);
	}
	return n;
}
//#endregion
//#region src/battle/useBattleSpinnerMeasurement.ts
function bc(e, t, n) {
	let [r, i] = ne(n);
	return I(() => {
		let n = e.current;
		if (!n) return;
		let r = () => {
			let e = n.getBoundingClientRect(), r = t === "horizontal" ? e.width : e.height;
			r > 0 && i(r);
		};
		if (r(), typeof ResizeObserver > "u") return;
		let a = new ResizeObserver(r);
		return a.observe(n), () => a.disconnect();
	}, [e, t]), r || n;
}
//#endregion
//#region src/battle/BattleSpinner.tsx
var xc = [
	.25,
	.8,
	.5,
	1
], Sc = 160;
function Cc({ box: e, revealedItem: t, prandGenerator: n, running: r, onRevealComplete: i, laneIndex: a, invertSound: o, orientation: s, containerSizeFallback: c, item: u, revealed: d, spinDelayMs: f, spinMs: p, showMs: m, spinItems: h, staggerMs: g, startOffsetMs: _ = 0, renderBufferSlots: v, renderBufferEndSlots: y, renderWindowStepSlots: b, glow: x = !0 }) {
	let { sounds: S, theme: C } = l(), w = s === "horizontal", T = R(null), D = R(null), O = bc(T, s, c), { itemHeight: k, itemWidth: A } = u, j = 3 + h, ee = (p + a * g) / 1e3, te = m / 1e3, [N] = ne(() => e.dropTable.length ? oc(e, j, t, n) : null), F = N?.length ?? j + 2, I = Fs({
		isHorizontal: w,
		itemWidth: A
	}), re = L(() => Array.from({ length: F }, (e, t) => Ps({
		index: t,
		endingItemIdx: j,
		isHorizontal: w,
		itemHeight: k,
		itemWidth: A
	})), [
		F,
		j,
		w,
		k,
		A
	]), z = L(() => Ns(re, I), [re, I]), ce = L(() => z.map((e, t) => Ls({
		offset: e,
		index: t,
		endingItemIdx: j,
		isHorizontal: w,
		itemHeight: k,
		itemWidth: A,
		slotMainSize: re[t] ?? k
	})), [
		z,
		j,
		w,
		k,
		A,
		re
	]), le = w ? O / 2 : 68 + k / 2, ue = le - (ce[j] ?? 0), de = le - (ce[3] ?? z[3] ?? 0), fe = w ? A + I : Rs(k), H = L(() => {
		let e = F - 1;
		return (z[e] ?? 0) + (re[e] ?? 0);
	}, [
		F,
		z,
		re
	]), pe = (L(() => re.reduce((e, t) => Math.max(e, t), 0), [re]) || (w ? A : k)) + I, me = pe * v, he = pe * y, ge = M((e) => mc({
		visibleRange: uc({
			slotOffsets: z,
			slotMainSizes: re,
			viewportStart: -e,
			viewportEnd: O - e,
			bufferPx: me,
			bufferEndPx: he
		}),
		slotCount: F,
		stepSlots: b
	}), [
		O,
		he,
		me,
		b,
		z,
		re,
		F
	]), [_e, ve] = ne(() => ge(d ? ue : de)), U = R(_e), ye = M((e) => {
		let t = ge(e), n = U.current;
		(n?.startIndex !== t?.startIndex || n?.endIndex !== t?.endIndex) && (U.current = t, ve(t));
	}, [ge]), be = L(() => N ? gc(pc({
		visibleRange: _e,
		targetIndex: j,
		slotCount: F
	})).flatMap((e) => {
		let t = N[e];
		return t ? [{
			card: t,
			index: e
		}] : [];
	}) : [], [
		N,
		_e,
		j,
		F
	]);
	P(() => {
		if (!N || typeof Image > "u") return;
		let e = hc({
			targetIndex: j,
			slotCount: F
		});
		if (!e) return;
		let t = /* @__PURE__ */ new Set();
		for (let n = e.startIndex; n <= e.endIndex; n += 1) {
			let e = N[n]?.imageUrl;
			!e || t.has(e) || (t.add(e), new Image().src = e);
		}
	}, [
		N,
		j,
		F
	]);
	let [xe, Se] = ne(!1);
	P(() => {
		if (!N || xe) return;
		let e = !1, t = () => {
			e || Se(!0);
		};
		return Ec().then(() => {
			if (e) return;
			let n = D.current;
			if (!n) return t();
			let r = Array.from(n.querySelectorAll("img[data-los-battle-card]"));
			Promise.race([Promise.all(r.map(Tc)).catch(() => void 0), Dc(Sc)]).then(Ec).then(Ec).then(t);
		}), () => {
			e = !0;
		};
	}, [N, xe]);
	let [W, Ce] = ne("idle"), we = R(!1), Te = R(null), Ee = R(null);
	P(() => {
		r && (we.current = !1, Te.current = performance.now(), Ee.current &&= (clearTimeout(Ee.current), null), Ce("spinning"));
	}, [r]), P(() => () => {
		Ee.current && clearTimeout(Ee.current);
	}, []);
	let De = oe(de), Oe = se(De, (e) => w ? `translate3d(${e}px, 0, 0)` : `translate3d(0, ${e}px, 0)`), ke = R(_);
	ke.current = _;
	let Ae = R(0), je = R(null), Me = M((e) => {
		if (!N) return;
		let t = Date.now();
		if (t - Ae.current < 16) return;
		let n = _c(ce, le - e);
		n === je.current || n < 0 || n >= N.length || (je.current = n, Ae.current = t, S.playTickSound());
	}, [
		N,
		ce,
		le,
		S
	]), Ne = ({ silent: e = !1 } = {}) => {
		if (we.current) return;
		we.current = !0;
		let t = N?.[j]?.rarity ?? 0;
		e || S.playRaritySound(o ? wc(t) : t), i(t);
	}, Pe = R(Ne);
	Pe.current = Ne, P(() => {
		if (W !== "spinning") {
			De.set(de), ye(de);
			return;
		}
		let e = Math.max(0, ke.current), t = Math.max(0, e - f);
		if (t >= p + a * g) {
			De.set(ue), ye(ue), Pe.current({ silent: !0 });
			return;
		}
		let n = f + p + a * g - 50 - e, r = ie(De.get(), ue, {
			type: "tween",
			duration: ee,
			delay: Math.max(0, f - e) / 1e3,
			ease: xc,
			onUpdate: (e) => {
				De.set(e), ye(e), a === 0 && Me(e);
			},
			onComplete: () => {
				if (we.current) return;
				let e = Te.current, t = e === null ? n : performance.now() - e;
				if (t < n) {
					Ee.current = setTimeout(() => Pe.current(), n - t);
					return;
				}
				Pe.current();
			}
		});
		return t > 0 && (r.time = t / 1e3), () => r.stop();
	}, [
		W,
		De,
		de,
		ue,
		ee,
		f,
		p,
		g,
		a,
		Me,
		ye
	]), P(() => {
		d && ye(ue);
	}, [
		d,
		ue,
		ye
	]);
	let G = oe(+!!d), Fe = se(G, (e) => e * .8);
	if (P(() => {
		let e = ie(G, +!!d, {
			type: "tween",
			duration: Math.min(te, .45),
			ease: "easeOut"
		});
		return () => e.stop();
	}, [
		G,
		te,
		d
	]), !N) return null;
	let Ie = N[j], Le = Ks({
		isHorizontal: !0,
		itemWidth: A
	});
	return /* @__PURE__ */ V("div", {
		ref: T,
		className: Y.reelViewport,
		children: [
			x && w && d && Ie ? /* @__PURE__ */ B(ae.div, {
				"aria-hidden": !0,
				className: J(Y.glow, A <= 80 && Y.glowSmall),
				style: {
					backgroundColor: E(C.railHex, Ie.rarity),
					height: Le.height,
					width: Le.width,
					top: qs(A),
					opacity: Fe
				}
			}) : null,
			xe ? null : /* @__PURE__ */ B(Xs, {
				orientation: s,
				item: u
			}),
			/* @__PURE__ */ B("div", {
				className: J(Y.reelClip, w && Y.reelClipHorizontal),
				children: /* @__PURE__ */ B(ae.div, {
					ref: D,
					"data-los-battle-reel": !0,
					"data-los-lane": a,
					className: J(Y.reel, !w && Y.reelVertical),
					style: {
						...w ? {
							height: k,
							width: H
						} : { height: H },
						transform: Oe,
						willChange: W === "spinning" ? "transform" : void 0,
						opacity: xe ? 1 : .001
					},
					children: be.map(({ card: e, index: t }) => /* @__PURE__ */ B("div", {
						"data-los-slot-index": t,
						className: Y.slotAnchor,
						style: w ? {
							left: z[t] ?? 0,
							top: 0
						} : {
							left: 0,
							top: z[t] ?? 0,
							width: "100%"
						},
						children: /* @__PURE__ */ B(cc, {
							item: e,
							isTarget: t === j,
							revealed: t === j && d,
							itemHeight: k,
							itemWidth: A,
							isHorizontal: w,
							slotMainSize: re[t] ?? k,
							slotVisualOffset: Is({
								index: t,
								endingItemIdx: j,
								isHorizontal: w,
								itemWidth: A
							}),
							labelGap: Js({
								index: t,
								endingItemIdx: j,
								isHorizontal: w,
								itemWidth: A
							}),
							itemCenter: ce[t] ?? 0,
							centerProgressDistance: fe,
							containerCenter: le,
							reelOffset: De,
							lockDurationSec: te,
							isAnimating: W === "spinning" || d
						})
					}, `${t}-${e.itemId}`))
				})
			})
		]
	});
}
function wc(e) {
	return e >= 4 ? 0 : e <= 1 ? 4 : e;
}
function Tc(e) {
	return e.complete && e.naturalWidth > 0 ? Promise.resolve() : typeof e.decode == "function" ? e.decode().catch(() => void 0) : new Promise((t) => {
		let n = () => {
			e.removeEventListener("load", n), e.removeEventListener("error", n), t();
		};
		e.addEventListener("load", n, { once: !0 }), e.addEventListener("error", n, { once: !0 });
	});
}
function Ec() {
	return new Promise((e) => {
		if (typeof requestAnimationFrame > "u") {
			setTimeout(e, 0);
			return;
		}
		requestAnimationFrame(() => e());
	});
}
function Dc(e) {
	return new Promise((t) => {
		setTimeout(t, e);
	});
}
//#endregion
//#region src/battle/BattleSpinnerChrome.tsx
var Oc = {
	default: {
		left: {
			top: 25,
			bottom: 25,
			width: 18
		},
		right: {
			top: 25,
			bottom: 25,
			width: 18
		}
	},
	"desktop-compact": {
		left: {
			top: 0,
			bottom: 0,
			width: 37
		},
		right: {
			top: 0,
			bottom: 0,
			width: 37
		}
	},
	"mobile-2p": {
		left: {
			top: 0,
			height: 190,
			width: 37
		},
		right: {
			top: 0,
			height: 190,
			width: 37
		}
	},
	"mobile-3p": {
		left: {
			top: 5,
			height: 95,
			width: 12
		},
		right: {
			top: 0,
			height: 100,
			width: 12
		}
	},
	"mobile-grid": {
		left: {
			top: 0,
			height: 137,
			width: 12
		},
		right: {
			top: 0,
			height: 137,
			width: 12
		}
	}
};
function kc({ orientation: e, variant: t }) {
	if (e === "vertical") return /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B("div", {
		"aria-hidden": !0,
		className: J(Y.fade, Y.fadeTop)
	}), /* @__PURE__ */ B("div", {
		"aria-hidden": !0,
		className: J(Y.fade, Y.fadeBottom)
	})] });
	let n = Oc[t];
	return /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B("div", {
		"aria-hidden": !0,
		className: J(Y.fade, Y.fadeLeft),
		style: n.left
	}), /* @__PURE__ */ B("div", {
		"aria-hidden": !0,
		className: J(Y.fade, Y.fadeRight),
		style: n.right
	})] });
}
//#endregion
//#region src/battle/battleRoundContext.ts
var Ac = ee(null);
function jc() {
	let e = N(Ac);
	if (!e) throw Error("A battle lane needs a BattleRound around it");
	return e;
}
function Mc(e) {
	let t = jc(), n = t.landed.get(e) ?? null;
	return {
		landed: n !== null,
		rarity: n,
		item: t.laneItems[e] ?? null
	};
}
//#endregion
//#region src/battle/BattleLaneViewport.tsx
function Nc({ lane: e, orientation: t, item: n, bare: r = !1, className: i, style: a }) {
	let o = jc(), { spinner: s } = o.layout, c = t ?? s.orientation, l = n ?? s.item, u = c === "horizontal", d = o.box, f = o.laneItems[e] ?? null, m = d !== null && f !== null && d.dropTable.length > 0, { laneLanded: h } = o, g = M((t) => h(e, t), [h, e]), { timings: _ } = o;
	return /* @__PURE__ */ V("div", {
		className: J(Y.viewport, u ? Y.viewportHorizontal : Y.viewportVertical, r && (u ? Y.viewportBareHorizontal : Y.viewportBareVertical), i),
		style: a,
		children: [r ? null : /* @__PURE__ */ B(kc, {
			orientation: c,
			variant: s.chrome
		}), m ? /* @__PURE__ */ B(Cc, {
			box: d,
			revealedItem: f,
			prandGenerator: o.generators[e] ?? p(o.seed, e),
			running: o.running,
			onRevealComplete: g,
			laneIndex: e,
			invertSound: o.invertSound,
			orientation: c,
			containerSizeFallback: u ? 190 : s.viewport.height,
			item: l,
			revealed: o.landed.has(e),
			spinDelayMs: _.spinDelayMs,
			spinMs: _.spinMs,
			showMs: _.showMs,
			spinItems: _.spinItems,
			staggerMs: _.staggerMs,
			startOffsetMs: o.startOffsetMs,
			renderBufferSlots: s.renderBufferSlots,
			renderBufferEndSlots: s.renderBufferEndSlots,
			renderWindowStepSlots: s.renderWindowStepSlots,
			glow: !r
		}, `${o.roundKey}:${e}`) : /* @__PURE__ */ B(Xs, {
			orientation: c,
			item: l
		})]
	});
}
//#endregion
//#region src/battle/BattleLaneReel.tsx
function Pc({ lane: e, orientation: t, item: n, framed: r = !1, className: i, style: a }) {
	let { theme: o } = l(), { layout: s } = jc(), c = (t ?? s.spinner.orientation) === "horizontal";
	return /* @__PURE__ */ B("div", {
		className: J(Y.root, Y.laneReel, i),
		style: {
			...o.cssVars,
			...a
		},
		"data-los-battle-lane": e,
		children: /* @__PURE__ */ B(Nc, {
			lane: e,
			orientation: t,
			item: n,
			bare: !r,
			className: Y.laneViewport,
			style: c ? { height: s.spinner.viewport.height } : void 0
		})
	});
}
//#endregion
//#region src/battle/BattleOpenerDividers.tsx
function Fc({ layout: e }) {
	return e.playerCount <= 1 || e.dividerMode === "none" ? null : e.dividerMode === "center" ? /* @__PURE__ */ B(Ic, {
		leftPct: 50,
		topPct: 50
	}) : e.dividerMode === "two-column-rows" ? /* @__PURE__ */ B(z, { children: Array.from({ length: e.rows }, (t, n) => /* @__PURE__ */ B(Ic, {
		leftPct: 50,
		topPct: (n + .5) / e.rows * 100
	}, n)) }) : /* @__PURE__ */ B(z, { children: Array.from({ length: e.columns - 1 }, (t, n) => /* @__PURE__ */ B(Ic, {
		leftPct: (n + 1) / e.columns * 100,
		topPct: 50
	}, n)) });
}
function Ic({ leftPct: e, topPct: t }) {
	return /* @__PURE__ */ B("div", {
		"aria-hidden": !0,
		className: Y.vsChip,
		style: {
			left: `${e}%`,
			top: `${t}%`
		},
		children: /* @__PURE__ */ B("div", {
			className: Y.vsChipBox,
			children: /* @__PURE__ */ B(Go, { size: 16 })
		})
	});
}
//#endregion
//#region src/react/LootConfigContext.ts
var Lc = ee({});
function Rc() {
	return N(Lc);
}
//#endregion
//#region ../sound/dist/index.js
var zc = [
	"ui",
	"sfx",
	"music",
	"ambience"
], Bc = [
	"random",
	"shuffle",
	"sequence"
], Vc = (e) => typeof e == "object" && !!e && !Array.isArray(e);
function Hc(e, t, n) {
	return Object.keys(e).filter((e) => e !== "__proto__" || (n(`${t}: skipped a "__proto__" key`), !1));
}
function Uc(e, t, n, r, i, a = () => !0) {
	if (!(n in e) || e[n] === void 0) return;
	let o = e[n];
	if (typeof o == "number" && Number.isFinite(o) && a(o)) {
		t[n] = o;
		return;
	}
	i(`${r}.${n}: dropped ${JSON.stringify(o) ?? String(o)}`);
}
var Wc = (e) => e >= 0;
function Gc(e) {
	return !Vc(e) || typeof e.url != "string" || typeof e.type != "string" ? null : {
		url: e.url,
		type: e.type
	};
}
function Kc(e, t, n) {
	if (!Vc(e) || !Array.isArray(e.sources)) return n(`${t}: dropped, not an asset with a list of sources`), null;
	let r = e.sources.map(Gc).filter((e) => e !== null);
	if (r.length < e.sources.length && n(`${t}: dropped a malformed source`), r.length === 0) return n(`${t}: dropped, no usable source`), null;
	let i = { sources: r };
	if (Uc(e, i, "durationMs", t, n, Wc), Uc(e, i, "lufs", t, n), Vc(e.cues)) {
		let r = {};
		for (let i of Hc(e.cues, `${t}.cues`, n)) Uc(e.cues, r, i, `${t}.cues`, n, Wc);
		i.cues = r;
	}
	return i;
}
function qc(e, t, n) {
	if (!Vc(e) || typeof e.asset != "string") return n(`${t}: dropped, no asset name`), null;
	let r = { asset: e.asset };
	return Uc(e, r, "weight", t, n, Wc), Uc(e, r, "gainDb", t, n), Uc(e, r, "startMs", t, n, Wc), Uc(e, r, "endMs", t, n, Wc), r;
}
function Jc(e, t, n) {
	if (!Vc(e) || !Array.isArray(e.variations)) return n(`${t}: dropped, no list of variations`), null;
	let r = { variations: e.variations.map((e, r) => qc(e, `${t}.variations[${r}]`, n)).filter((e) => e !== null) };
	if (e.select !== void 0 && (Bc.includes(e.select) ? r.select = e.select : n(`${t}.select: dropped ${JSON.stringify(e.select)}`)), e.bus !== void 0 && (zc.includes(e.bus) ? r.bus = e.bus : n(`${t}.bus: dropped ${JSON.stringify(e.bus)}`)), Uc(e, r, "gainDb", t, n), Uc(e, r, "pitchJitterCents", t, n, Wc), Uc(e, r, "gainJitterDb", t, n, Wc), Uc(e, r, "maxVoices", t, n, (e) => Number.isInteger(e) && e >= 1), Uc(e, r, "cooldownMs", t, n, Wc), Uc(e, r, "delayMs", t, n, Wc), Uc(e, r, "fadeInMs", t, n, Wc), Uc(e, r, "fadeOutMs", t, n, Wc), typeof e.loop == "boolean") r.loop = e.loop;
	else if (e.loop !== void 0) {
		let { startMs: i, endMs: a } = Vc(e.loop) ? e.loop : {};
		typeof i == "number" && typeof a == "number" && Number.isFinite(i) && Number.isFinite(a) && i >= 0 && a > i ? r.loop = {
			startMs: i,
			endMs: a
		} : n(`${t}.loop: dropped ${JSON.stringify(e.loop)}`);
	}
	return r;
}
function Yc(e, t) {
	let n = {
		schema: 1,
		assets: {},
		events: {}
	};
	if (!Vc(e)) return t("manifest: not an object, read as empty"), n;
	if (Vc(e.assets)) for (let r of Hc(e.assets, "assets", t)) {
		let i = Kc(e.assets[r], `assets.${r}`, t);
		i && (n.assets[r] = i);
	}
	if (Vc(e.events)) for (let r of Hc(e.events, "events", t)) {
		let i = Jc(e.events[r], `events.${r}`, t);
		i && (n.events[r] = i);
	}
	return n;
}
function Xc() {
	return {
		last: -1,
		queue: [],
		cursor: 0
	};
}
var Zc = (e) => Math.max(0, e.weight ?? 1);
function Qc(e, t, n) {
	let r = e.map((e, t) => ({
		index: t,
		weight: Zc(e)
	})).filter((e) => e.index !== t && e.weight > 0), i = r.reduce((e, t) => e + t.weight, 0);
	if (i === 0) {
		let n = e[t];
		return n && Zc(n) > 0 ? t : Math.max(0, e.findIndex((e) => Zc(e) > 0));
	}
	let a = n() * i;
	for (let e of r) if (a -= e.weight, a < 0) return e.index;
	return r.at(-1)?.index ?? 0;
}
function $c(e, t, n) {
	let r = e[t], i = e[n];
	r !== void 0 && i !== void 0 && (e[t] = i, e[n] = r);
}
function el(e, t, n) {
	let r = Array.from({ length: e }, (e, t) => t);
	for (let t = e - 1; t > 0; t--) {
		let e = Math.floor(n() * (t + 1));
		$c(r, t, e);
	}
	return e > 1 && r[0] === t && $c(r, 0, 1), r;
}
function tl(e, t, n, r) {
	let i = e.length, a;
	return i <= 1 ? a = 0 : t === "sequence" ? a = (n.last + 1) % i : t === "shuffle" ? ((n.cursor >= n.queue.length || n.queue.length !== i) && (n.queue = el(i, n.last, r), n.cursor = 0), a = n.queue[n.cursor++] ?? 0) : a = Qc(e, n.last, r), n.last = a, a;
}
function nl(e, t, n) {
	return e.cooldownMs !== void 0 && t.lastStartMs !== void 0 && n - t.lastStartMs < e.cooldownMs ? { admit: !1 } : e.maxVoices !== void 0 && t.voices.length >= e.maxVoices ? t.voices.length === 0 ? { admit: !1 } : {
		admit: !0,
		steal: t.voices.reduce((e, t) => t.startedMs < e.startedMs ? t : e).id
	} : { admit: !0 };
}
function rl(e, t) {
	return Object.hasOwn(e, t) ? e[t] : void 0;
}
function il(e, t, n) {
	let r = /* @__PURE__ */ new Set(), i = e;
	for (; i && !r.has(i);) {
		r.add(i);
		for (let e of t) {
			let t = rl(e.manifest.events, i);
			if (!t) continue;
			let { assets: n } = e.manifest, r = t.variations.filter((e) => rl(n, e.asset) != null);
			if (!(t.variations.length > 0 && r.length === 0)) return {
				id: i,
				layer: e.name,
				mapping: {
					...t,
					variations: r
				},
				assets: n
			};
		}
		i = rl(n, i)?.fallback;
	}
	return null;
}
function al(e, t) {
	let n = rl(e.assets, t.asset);
	if (!n) throw Error(`Sound asset "${t.asset}" is missing from layer "${e.layer}"`);
	return n;
}
var ol = 150, sl = 2e4, cl = 3e4, ll = 12, ul = [
	"ui",
	"sfx",
	"music",
	"ambience"
], dl = (e) => 10 ** (e / 20), fl = () => {
	if (typeof window > "u") return null;
	let e = window.AudioContext ?? window.webkitAudioContext;
	return e ? new e({ latencyHint: "interactive" }) : null;
}, pl = async (e) => {
	let t = new AbortController(), n = setTimeout(() => t.abort(), sl), r = () => {
		clearTimeout(n), n = setTimeout(() => t.abort(), sl);
	};
	try {
		let n = await fetch(e, { signal: t.signal });
		if (!n.ok) throw Error(`Sound ${e} answered ${n.status}`);
		if (!n.body) return await n.arrayBuffer();
		r();
		let i = n.body.getReader(), a = [], o = 0;
		for (;;) {
			let { done: e, value: t } = await i.read();
			if (e) break;
			r(), a.push(t), o += t.byteLength;
		}
		let s = new Uint8Array(o), c = 0;
		for (let e of a) s.set(e, c), c += e.byteLength;
		return s.buffer;
	} finally {
		clearTimeout(n);
	}
}, ml = (e) => Number.isFinite(e) ? Math.min(1, Math.max(0, e)) : null;
function hl(e, t = 0) {
	return /iPad|iPhone|iPod/.test(e) || /Macintosh/.test(e) && t > 1 ? !0 : /Safari/.test(e) && !/Chrome|Chromium|Edg|OPR|Firefox/.test(e);
}
function gl(e) {
	let { catalog: t, createContext: n = fl, fetchAudio: r = pl, nowMs: i = () => performance.now(), random: a = Math.random, onError: o = () => {} } = e, s = e.preferM4a ?? (typeof navigator < "u" && hl(navigator.userAgent, navigator.maxTouchPoints)), c = [], l = null, u = !1, d = null, f = /* @__PURE__ */ new Map(), p = !1, m = 1, h = /* @__PURE__ */ new Map(), g = /* @__PURE__ */ new Set(), _ = /* @__PURE__ */ new Map(), v = /* @__PURE__ */ new Map(), y = /* @__PURE__ */ new Map(), b = /* @__PURE__ */ new Map(), x = /* @__PURE__ */ new Set(), S = 1, C = !1, w = !1;
	function T(e, t) {
		try {
			o(e, t);
		} catch {}
	}
	let E = (e) => (t) => T(t, e);
	function D(e, t, n) {
		try {
			return n();
		} catch (n) {
			return T(n, e), t;
		}
	}
	let O = /* @__PURE__ */ new WeakMap();
	function k(e) {
		let t = e.manifest, n = typeof t == "object" && t ? O.get(t) : void 0;
		if (n) return {
			name: e.name,
			manifest: n
		};
		let r = Yc(t, (t) => T(Error(t), `manifest ${e.name}`));
		return typeof t == "object" && t && O.set(t, r), {
			name: e.name,
			manifest: r
		};
	}
	function A() {
		if (l || u) return l;
		try {
			let e = n();
			if (!e) return u = !0, null;
			let t = e.createGain();
			t.gain.value = p ? 0 : m;
			let r = e.createDynamicsCompressor();
			r.threshold.value = -2, r.knee.value = 0, r.ratio.value = 20, r.attack.value = .002, r.release.value = .15, t.connect(r), r.connect(e.destination);
			for (let n of ul) {
				let r = e.createGain();
				r.gain.value = h.get(n) ?? 1, r.connect(t), f.set(n, r);
			}
			return e.addEventListener("statechange", () => {
				if (l?.state === "running") for (let e of [...x]) e();
			}), d = t, l = e, l;
		} catch (e) {
			return T(e, "create"), f.clear(), u = !0, null;
		}
	}
	let j = () => l?.state === "running";
	function ee(e, t) {
		let n = e.gain, r = l?.currentTime ?? 0, i = n.value;
		n.cancelScheduledValues(r), n.setValueAtTime(i, r), n.setTargetAtTime(t, r, .03);
	}
	function te(e) {
		let t = b.get(e);
		return t || (t = {
			pick: Xc(),
			lastStartMs: void 0,
			voices: []
		}, b.set(e, t)), t;
	}
	let M = (e) => e.sources[0]?.url ?? "";
	function N(e) {
		if (!s) return e.sources;
		let t = (e) => e.includes("mp4");
		return [...e.sources].sort((e, n) => Number(t(n.type)) - Number(t(e.type)));
	}
	function P(e, t = !1) {
		let n = M(e), a = _.get(n);
		if (a) return a;
		let o = v.get(n);
		if (!t && o !== void 0 && i() - o < cl) return Promise.resolve(null);
		let s = (async () => {
			for (let t of N(e)) {
				let e = A();
				if (!e) return null;
				try {
					let i = await r(t.url), a = await e.decodeAudioData(i);
					return y.set(n, a), a;
				} catch (e) {
					T(e, `load ${t.url}`);
				}
			}
			return null;
		})();
		return _.set(n, s), s.then((e) => {
			if (e) {
				v.delete(n);
				return;
			}
			v.set(n, i()), _.get(n) === s && _.delete(n);
		}), s;
	}
	function F(e, t, n, r, o, s, c, u, d) {
		let p = l;
		if (!p) return null;
		let m = p.currentTime, h = d + (u.atMs ?? 0) / 1e3 + (t.delayMs ?? 0) / 1e3, g = 0;
		if (u.align) {
			let e = o.cues?.[u.align.cue] ?? 0;
			h = d + (u.align.atMs - e + (t.delayMs ?? 0)) / 1e3, h < d && (g = d - h, h = d);
		}
		if (h < m) {
			if (!c && m - h > ol / 1e3) return null;
			h = m;
		}
		let _ = p.createBufferSource();
		_.buffer = s, _.playbackRate.value = u.rate ?? 1, t.pitchJitterCents && (_.detune.value = (a() * 2 - 1) * t.pitchJitterCents);
		let v = t.gainJitterDb ? (a() * 2 - 1) * t.gainJitterDb : 0, y = dl(Math.min(ll, (r.gainDb ?? 0) + (t.gainDb ?? 0) + (u.gainDb ?? 0) + v)), b = y * (ml(u.level ?? 1) ?? 1), x = p.createGain();
		try {
			let e = u.fadeInMs ?? t.fadeInMs ?? 0;
			e > 0 ? (x.gain.setValueAtTime(0, h), x.gain.linearRampToValueAtTime(b, h + e / 1e3)) : x.gain.value = b, _.connect(x);
			let i = f.get(n);
			i && x.connect(i);
			let a = ((r.startMs ?? 0) + (u.offsetMs ?? 0)) / 1e3 + g;
			if (c) _.loop = !0, typeof t.loop == "object" && (_.loopStart = t.loop.startMs / 1e3, _.loopEnd = t.loop.endMs / 1e3), _.start(h, a);
			else if (r.endMs !== void 0) {
				let e = (r.endMs - (r.startMs ?? 0) - (u.offsetMs ?? 0)) / 1e3 - g;
				_.start(h, a, Math.max(0, e));
			} else _.start(h, a);
		} catch (e) {
			throw _.disconnect(), x.disconnect(), e;
		}
		let C = {
			id: S++,
			startedMs: i(),
			source: _,
			gain: x,
			baseLevel: y,
			startAt: h
		}, w = te(e);
		return w.voices.push(C), _.onended = () => {
			w.voices = w.voices.filter((e) => e !== C), _.disconnect(), x.disconnect();
		}, C;
	}
	function I(e, t, n) {
		let r = l;
		if (!r) return;
		let i = r.currentTime;
		try {
			n > 0 ? (t.gain.gain.cancelScheduledValues(i), t.gain.gain.setValueAtTime(t.gain.gain.value, i), t.gain.gain.linearRampToValueAtTime(0, i + n / 1e3), t.source.stop(i + n / 1e3)) : t.source.stop(i);
		} catch (e) {
			T(e, "stop");
			try {
				t.source.stop(i);
			} catch (e) {
				T(e, "stop");
			}
		}
		let a = te(e);
		a.voices = a.voices.filter((e) => e !== t);
	}
	function L(e, n = {}) {
		let r = { ...n };
		if (!A()) return null;
		let o = il(e, c, t);
		if (!o || o.mapping.variations.length === 0) return null;
		let { mapping: s } = o, u = rl(t, e) ?? rl(t, o.id), d = !!(s.loop ?? u?.loop);
		if (g.has(e) || !d && p) return null;
		let f = !d && !j();
		if (f && !C) return null;
		let m = te(e), h = i(), _ = nl(s, m, h);
		if (!_.admit) return null;
		let v = tl(s.variations, s.select, m.pick, a), b = s.variations[v];
		if (!b) return null;
		let S = al(o, b), w = s.bus ?? u?.bus ?? "sfx", T = y.get(M(S));
		if (!T && !d && !f && u?.late === "drop") return P(S), null;
		if (_.steal !== void 0) {
			let t = m.voices.find((e) => e.id === _.steal);
			t && I(e, t, 0);
		}
		m.lastStartMs = h;
		let E = null, O = !1, k = (t, n) => {
			O || E || (E = D(`start ${e}`, null, () => F(e, s, w, b, S, t, d, r, n)));
		}, ee = l?.currentTime ?? 0, N = null, L = null, R = {
			stop: ({ fadeMs: t } = {}) => {
				O = !0, L && x.delete(L), E && I(e, E, t ?? s.fadeOutMs ?? 0);
			},
			setRate: (t) => D(`setRate ${e}`, void 0, () => {
				E && (E.source.playbackRate.value = t), r.rate = t;
			}),
			setLevel: (t, n = 0) => D(`setLevel ${e}`, void 0, () => {
				let i = ml(t);
				if (i === null) throw Error(`setLevel ${e}: ${t} is not a level`);
				t = i, r.level = t, !E && t > 0 && N?.();
				let a = l;
				if (!E || !a) return;
				let o = E.gain.gain, s = E.baseLevel * t, c = a.currentTime;
				o.cancelScheduledValues(c), n > 0 ? (o.setValueAtTime(o.value, c), o.linearRampToValueAtTime(s, c + n / 1e3)) : o.value = s;
			}),
			cancelIfNotStarted: () => {
				if (!E) {
					O = !0;
					return;
				}
				l && E.startAt > l.currentTime && I(e, E, 0);
			}
		};
		if (f) {
			let e = () => {
				x.delete(e), !(i() - h > ol) && P(S).then((e) => {
					e && j() && k(e, ee);
				});
			};
			return x.add(e), L = e, P(S), R;
		}
		if (T && (j() || !d)) return k(T, ee), R;
		if (d) {
			let e = () => {
				let t = y.get(M(S));
				!t || !j() || (x.delete(e), k(t, l?.currentTime ?? 0));
			};
			return x.add(e), L = e, N = () => void P(S, !0).then(e), N(), R;
		}
		return P(S).then((e) => {
			!e || !j() || k(e, ee);
		}), R;
	}
	return {
		get state() {
			return u ? "unsupported" : j() ? "running" : "locked";
		},
		setLayers(e) {
			D("setLayers", void 0, () => {
				c = e.map(k);
			});
		},
		play: (e, t) => D(`play ${e}`, null, () => L(e, t)),
		schedule(e, { signal: t } = {}) {
			D("schedule", void 0, () => {
				if (t?.aborted) return;
				let n = e.map((e) => D(`play ${e.id}`, null, () => L(e.id, {
					atMs: e.atMs,
					gainDb: e.gainDb
				}))).filter((e) => e !== null);
				if (!t || n.length === 0) return;
				let r = () => {
					for (let e of n) D("cancel", void 0, e.cancelIfNotStarted);
				};
				t.addEventListener("abort", r, { once: !0 });
				let i = Math.max(0, ...e.map((e) => e.atMs).filter(Number.isFinite));
				setTimeout(() => t.removeEventListener("abort", r), i + ol + 5e3);
			});
		},
		resolve: (e) => D(`resolve ${e}`, null, () => il(e, c, t)),
		activeVoiceCount(e) {
			return b.get(e)?.voices.length ?? 0;
		},
		sourcesFor: (e) => D(`sourcesFor ${e}`, null, () => {
			let n = il(e, c, t), r = n?.mapping.variations[0];
			return !n || !r ? null : [...N(al(n, r))];
		}),
		preload(e) {
			for (let n of e) D(`preload ${n}`, void 0, () => {
				let e = il(n, c, t);
				if (e) for (let t of e.mapping.variations) P(al(e, t));
			});
		},
		unlock() {
			D("unlock", void 0, () => {
				let e = A();
				!e || e.state === "running" || (C = !0, e.resume().catch(E("resume")).finally(() => {
					C = !1;
				}));
			});
		},
		setHidden(e) {
			D("setHidden", void 0, () => {
				l && (e ? w = l.state === "running" : w && l.state !== "running" && (w = !1, l.resume().catch(E("resume"))));
			});
		},
		setMuted(e) {
			D("setMuted", void 0, () => {
				p = e, d && ee(d, p ? 0 : m);
			});
		},
		setMasterVolume(e) {
			D("setMasterVolume", void 0, () => {
				let t = ml(e);
				if (t === null) throw Error(`setMasterVolume: ${e} is not a volume`);
				m = t, d && !p && ee(d, t);
			});
		},
		setBusVolume(e, t) {
			D(`setBusVolume ${e}`, void 0, () => {
				let n = ml(t);
				if (n === null) throw Error(`setBusVolume ${e}: ${t} is not a volume`);
				h.set(e, n);
				let r = f.get(e);
				r && ee(r, n);
			});
		},
		setEventMuted(e, t) {
			t ? g.add(e) : g.delete(e);
		},
		debugMaster() {
			return A(), d;
		},
		debugBus(e) {
			return A(), f.get(e);
		}
	};
}
//#endregion
//#region src/sounds/openerSoundEngine.ts
var _l = Object.fromEntries(Ho.map((e) => [e.key, {
	description: e.description,
	category: e.group,
	bus: "sfx",
	group: e.key.startsWith("battle.") ? "battle" : "opener",
	...e.fallback ? { fallback: e.fallback } : {},
	...e.key.endsWith(".spinner.tick") ? { late: "drop" } : {}
}])), vl = null, yl = {}, bl = [], xl = {
	muted: !1,
	gain: 1
}, Sl = [], Cl = /* @__PURE__ */ new Set(), wl = xl;
function Tl() {
	return wl;
}
function El(e) {
	return Cl.add(e), () => {
		Cl.delete(e);
	};
}
function Dl() {
	let e = Sl.filter((e) => e.level !== null), t = (e.findLast((e) => e.source === "opener") ?? e[e.length - 1])?.level ?? xl, n = t.muted !== wl.muted || t.gain !== wl.gain;
	if (wl = t, vl?.setMuted(t.muted), vl?.setMasterVolume(t.gain), n) for (let e of [...Cl]) e();
}
function Ol(e) {
	let t = Number.isFinite(e.volume) ? e.volume : 50;
	return {
		muted: e.muted === !0 || t === 0,
		gain: e.volume === void 0 ? 1 : Wo(t)
	};
}
function kl(e) {
	let t = {
		source: e,
		level: null
	};
	return Sl.push(t), {
		set: (e) => {
			t.level = e ? Ol(e) : null, Dl();
		},
		remove: () => {
			let e = Sl.indexOf(t);
			e !== -1 && (Sl.splice(e, 1), Dl());
		}
	};
}
var Al = null;
function jl(e) {
	let t = () => {
		Al?.(), e.unlock(), e.preload(Object.keys(_l));
	};
	document.addEventListener("pointerdown", t, !0), document.addEventListener("keydown", t, !0), Al = () => {
		document.removeEventListener("pointerdown", t, !0), document.removeEventListener("keydown", t, !0), Al = null;
	};
}
function Ml() {
	vl?.setLayers([...bl].reverse().map((e, t) => ({
		name: `host-${t}`,
		manifest: e.manifest
	})));
}
function Nl() {
	if (vl) return vl;
	let e = gl({
		catalog: _l,
		...yl
	});
	return vl = e, Ml(), e.setMuted(wl.muted), e.setMasterVolume(wl.gain), typeof document < "u" && (jl(e), document.addEventListener("visibilitychange", () => e.setHidden(document.hidden))), e;
}
function Pl(e) {
	let t = Symbol("host sounds");
	return bl.push({
		key: t,
		manifest: e
	}), Ml(), () => {
		let e = bl.findIndex((e) => e.key === t);
		e !== -1 && (bl.splice(e, 1), Ml());
	};
}
//#endregion
//#region src/sounds/useOpenerSounds.ts
var Fl = {
	tick: "tick.mp3",
	badPrize: "bad-prize.mp3",
	rarePrize: "rare-prize.mp3",
	megaPrize: "mega-prize.mp3"
}, Il = {
	tick: "opener.spinner.tick",
	badPrize: "opener.reveal.bad",
	rarePrize: "opener.reveal.rare",
	megaPrize: "opener.reveal.mega"
};
function Ll(e, t) {
	if (e === !1) return null;
	let n = t?.replace(/\/$/, ""), r = {
		...n ? {
			tick: `${n}/${Fl.tick}`,
			badPrize: `${n}/${Fl.badPrize}`,
			rarePrize: `${n}/${Fl.rarePrize}`,
			megaPrize: `${n}/${Fl.megaPrize}`
		} : {},
		...e
	};
	return Object.values(r).some(Boolean) ? r : null;
}
var Rl = {
	mp3: "audio/mpeg",
	m4a: "audio/mp4",
	mp4: "audio/mp4",
	aac: "audio/aac",
	webm: "audio/webm",
	ogg: "audio/ogg",
	opus: "audio/ogg",
	wav: "audio/wav"
};
function zl(e) {
	return Rl[/\.([a-z0-9]+)(?:[?#]|$)/i.exec(e)?.[1]?.toLowerCase() ?? ""] ?? "";
}
function Bl(e) {
	let t = {
		schema: 1,
		assets: {},
		events: {}
	};
	for (let [n, r] of Object.entries(Il)) {
		let i = e[n];
		i && (t.assets[n] = { sources: [{
			url: i,
			type: zl(i)
		}] }, t.events[r] = { variations: [{ asset: n }] });
	}
	return t;
}
function Vl(e) {
	let t = {
		schema: 1,
		assets: {},
		events: {}
	};
	for (let [n, r] of Object.entries(e)) {
		if (typeof r == "object" && "off" in r) {
			r.off === !0 && (t.events[n] = { variations: [] });
			continue;
		}
		let e = typeof r == "string" ? r : r?.url;
		if (!e) continue;
		let i = typeof r == "object" ? r.gainDb : void 0;
		t.assets[n] = { sources: [{
			url: e,
			type: zl(e)
		}] }, t.events[n] = {
			variations: [{ asset: n }],
			...typeof i == "number" && Number.isFinite(i) ? { gainDb: Math.min(6, Math.max(-24, i)) } : {}
		};
	}
	return t;
}
function Hl(e, t) {
	let n = R(null), r = e !== null, i = e?.muted, a = e?.volume;
	P(() => {
		let e = kl(t);
		return n.current = e, () => {
			e.remove(), n.current = null;
		};
	}, [t]), P(() => {
		n.current?.set(r ? {
			muted: i,
			volume: a
		} : null);
	}, [
		r,
		i,
		a,
		t
	]);
}
function Ul(e, t) {
	return t === 2 || t === 3 ? `${e}.reveal.rare` : t >= 4 ? `${e}.reveal.mega` : `${e}.reveal.bad`;
}
function Wl(e) {
	return Object.values(e ?? {}).some((e) => typeof e == "string" || e !== void 0 && "url" in e);
}
function Gl({ sounds: e, soundBaseUrl: t, soundEvents: n, scope: r = "opener" }) {
	let i = Ll(e, t), a = i ? JSON.stringify(i) : null, o = e !== !1 && n && Object.keys(n).length > 0 ? JSON.stringify(n) : null, s = i !== null || o !== null && Wl(n), c = R(s);
	c.current = s;
	let l = R(e === !1);
	l.current = e === !1;
	let u = R(r);
	u.current = r;
	let d = s;
	return P(() => {
		d && Nl();
	}, [d]), P(() => {
		let e = [];
		return a && e.push(Pl(Bl(JSON.parse(a)))), o && e.push(Pl(Vl(JSON.parse(o)))), () => {
			for (let t of e.reverse()) t();
		};
	}, [a, o]), L(() => ({
		get enabled() {
			return !l.current;
		},
		get configured() {
			return c.current;
		},
		get muted() {
			return Tl().muted;
		},
		get gain() {
			return Tl().gain;
		},
		subscribe: El,
		playTickSound: () => {
			c.current && Nl().play(`${u.current}.spinner.tick`);
		},
		playRaritySound: (e) => {
			c.current && Nl().play(Ul(u.current, e));
		},
		unlock: () => {
			if (!c.current) return;
			let e = Nl();
			e.unlock();
			let t = u.current;
			e.preload([
				`${t}.spinner.tick`,
				`${t}.reveal.bad`,
				`${t}.reveal.rare`,
				`${t}.reveal.mega`
			]);
		}
	}), []);
}
//#endregion
//#region src/battle/battleLayout.ts
var Kl = 768, ql = 480, Jl = {
	itemWidth: 128,
	itemHeight: 176
}, Yl = {
	itemWidth: 138,
	itemHeight: 190
}, Xl = {
	itemWidth: 81,
	itemHeight: 112
}, Zl = {
	itemWidth: 94,
	itemHeight: 130
}, Ql = {
	itemWidth: 58,
	itemHeight: 80
}, $l = {
	itemWidth: 71,
	itemHeight: 98
}, eu = { verticalInset: 24 }, tu = {
	horizontalInset: 56,
	horizontalEndInset: 12
}, nu = {
	horizontalInset: 12,
	horizontalEndInset: 12
}, ru = {
	compactEdgePointers: !0,
	compactEdgeInset: 42,
	compactEdgeEndInset: 6
}, iu = {
	...ru,
	compactEdgeInset: 6
}, au = {
	renderBufferSlots: 0,
	renderBufferEndSlots: 2,
	renderWindowStepSlots: 2
}, ou = {
	renderBufferSlots: 2,
	renderBufferEndSlots: 2,
	renderWindowStepSlots: 1
}, su = {
	width: "100%",
	height: 124,
	position: "absolute-top",
	top: 54
};
function cu(e) {
	return !e || e < 2 ? 2 : e >= 5 ? 6 : e;
}
function lu(e) {
	let t = cu(e.playerCount), n = `ffa-${t}`;
	return e.viewport === "mobile" ? fu(n, t) : du(n, t);
}
function uu(e) {
	let t = {
		key: "solo",
		viewport: e.viewport,
		playerCount: 1,
		columns: 1,
		rows: 1,
		gap: 0,
		padding: 0,
		dividerMode: "none",
		headerAlign: "none",
		showHeaderTotal: !1,
		results: { cardsPerRow: 1 }
	};
	return e.viewport === "mobile" ? {
		...t,
		height: 196,
		columnVariant: "mobile-2p",
		spinner: {
			orientation: "horizontal",
			viewport: {
				width: "100%",
				height: 152,
				position: "flow",
				marginTop: 16,
				marginX: -7
			},
			item: Zl,
			pointers: {},
			chrome: "mobile-2p",
			...ou
		}
	} : {
		...t,
		height: 334,
		columnVariant: "default",
		spinner: {
			orientation: "horizontal",
			viewport: {
				width: "100%",
				height: 188,
				position: "flow",
				marginTop: 44
			},
			item: Jl,
			pointers: {
				horizontalInset: 10,
				horizontalEndInset: 12
			},
			chrome: "default",
			...au
		}
	};
}
function du(e, t) {
	let n = {
		key: e,
		viewport: "desktop",
		playerCount: t,
		gap: 0,
		padding: 0
	};
	switch (e) {
		case "solo": return uu({ viewport: "desktop" });
		case "ffa-2": return {
			...n,
			columns: 2,
			rows: 1,
			height: 380,
			dividerMode: "adjacent",
			columnVariant: "default",
			headerAlign: "center",
			showHeaderTotal: !1,
			spinner: {
				orientation: "horizontal",
				viewport: {
					width: 552,
					height: 188,
					position: "flow",
					marginTop: 38
				},
				item: Jl,
				pointers: tu,
				chrome: "default",
				...au
			},
			results: { cardsPerRow: 4 }
		};
		case "ffa-3": return {
			...n,
			columns: 3,
			rows: 1,
			height: 440,
			dividerMode: "adjacent",
			columnVariant: "default",
			headerAlign: "center",
			showHeaderTotal: !1,
			spinner: {
				orientation: "vertical",
				viewport: {
					width: 402.67,
					height: 364,
					position: "flow"
				},
				item: Yl,
				pointers: eu,
				chrome: "default",
				...au
			},
			results: { cardsPerRow: 3 }
		};
		case "ffa-4": return {
			...n,
			columns: 4,
			rows: 1,
			height: 440,
			dividerMode: "adjacent",
			columnVariant: "default",
			headerAlign: "center",
			showHeaderTotal: !1,
			spinner: {
				orientation: "vertical",
				viewport: {
					width: 293,
					height: 364,
					position: "flow"
				},
				item: Yl,
				pointers: eu,
				chrome: "default",
				...au
			},
			results: { cardsPerRow: 2 }
		};
		case "ffa-6": return {
			...n,
			columns: 2,
			rows: 3,
			height: 726,
			dividerMode: "two-column-rows",
			columnVariant: "default",
			headerAlign: "right",
			showHeaderTotal: !1,
			spinner: {
				orientation: "horizontal",
				viewport: {
					width: 449,
					height: 137,
					position: "absolute-center"
				},
				item: Xl,
				pointers: nu,
				chrome: "desktop-compact",
				...au
			},
			results: { cardsPerRow: 1 }
		};
	}
}
function fu(e, t) {
	let n = {
		key: e,
		viewport: "mobile",
		playerCount: t,
		headerAlign: "compact",
		showHeaderTotal: !0,
		results: { cardsPerRow: 2 }
	};
	switch (e) {
		case "solo": return uu({ viewport: "mobile" });
		case "ffa-2": return {
			...n,
			columns: 1,
			rows: 2,
			height: 439,
			gap: 0,
			padding: 0,
			dividerMode: "none",
			columnVariant: "mobile-2p",
			spinner: {
				orientation: "horizontal",
				viewport: {
					width: "100%",
					height: 152,
					position: "flow",
					marginTop: -5,
					marginX: -7
				},
				item: Zl,
				pointers: {},
				chrome: "mobile-2p",
				...ou
			}
		};
		case "ffa-3": return {
			...n,
			columns: 1,
			rows: 3,
			height: 440,
			gap: 0,
			padding: 0,
			dividerMode: "none",
			columnVariant: "mobile-3p",
			spinner: {
				orientation: "horizontal",
				viewport: {
					width: 336,
					height: 104,
					position: "flow",
					marginTop: -14
				},
				item: Ql,
				pointers: iu,
				chrome: "mobile-3p",
				...ou
			}
		};
		case "ffa-4": return {
			...n,
			columns: 2,
			rows: 2,
			height: 420,
			gap: 6,
			padding: 6,
			dividerMode: "center",
			columnVariant: "mobile-grid",
			spinner: {
				orientation: "horizontal",
				viewport: su,
				item: $l,
				pointers: ru,
				chrome: "mobile-grid",
				...ou
			}
		};
		case "ffa-6": return {
			...n,
			columns: 2,
			rows: 3,
			height: 610,
			gap: 6,
			padding: 6,
			dividerMode: "two-column-rows",
			columnVariant: "mobile-grid",
			spinner: {
				orientation: "horizontal",
				viewport: su,
				item: $l,
				pointers: ru,
				chrome: "mobile-grid",
				...ou
			}
		};
	}
}
//#endregion
//#region src/battle/battleTimings.ts
var pu = 3e3, mu = [
	2,
	3,
	4,
	6
], hu = 250, gu = 300, _u = {
	spinMs: Qs,
	quickSpinMs: $s,
	staggerMs: 250,
	quickStaggerMs: 150,
	spinLeadMs: 250 + gu,
	showMs: 1e3,
	holdMs: ic.normal,
	quickHoldMs: ic.quick
};
function vu(e) {
	let t = _u, n = e.fastSpin ? t.quickSpinMs : t.spinMs, r = e.fastSpin ? t.quickStaggerMs : t.staggerMs, i = e.fastSpin ? t.quickHoldMs : t.holdMs;
	return t.spinLeadMs + n + r * Math.max(0, e.playerCount - 1) + t.showMs + i;
}
function yu(e) {
	let t = _u, n = e.fastSpin ? t.quickSpinMs : t.spinMs, r = e.fastSpin ? t.quickStaggerMs : t.staggerMs;
	return t.spinLeadMs + n + r * Math.max(0, e.laneCount - 1) + t.showMs;
}
function bu(e) {
	let t = _u, n = e.fastSpin ? t.quickSpinMs : t.spinMs, r = e.fastSpin ? t.quickStaggerMs : t.staggerMs;
	return 250 + n + r * Math.max(0, e.laneIndex ?? 0) + gu;
}
function xu(e) {
	return e.compact ? e.fastSpin ? 10 : 14 : 24;
}
//#endregion
//#region src/battle/BattleRound.tsx
function Su(t) {
	let n = Rc(), i = t.theme ?? n.theme, a = t.currency ?? n.currency ?? e, o = t.locale ?? n.locale, s = L(() => r(o), [o]), c = L(() => h(i), [i]), l = Gl({
		sounds: n.sounds,
		soundBaseUrl: n.soundBaseUrl,
		soundEvents: n.soundEvents,
		scope: "battle"
	}), u = t.sounds ?? l, d = t.quick ?? !1, f = t.compact ?? !1, m = t.solo ?? !1, g = t.startOffsetMs ?? 0, _ = L(() => m ? t.laneItems.slice(0, 1) : t.laneItems, [m, t.laneItems]), v = _.length, y = L(() => {
		let e = f ? "mobile" : "desktop";
		return m ? uu({ viewport: e }) : lu({
			playerCount: v,
			viewport: e
		});
	}, [
		m,
		v,
		f
	]), b = L(() => {
		let e = _u;
		return {
			spinDelayMs: 250,
			spinMs: d ? e.quickSpinMs : e.spinMs,
			showMs: e.showMs,
			spinItems: xu({
				fastSpin: d,
				compact: f
			}),
			staggerMs: d ? e.quickStaggerMs : e.staggerMs
		};
	}, [d, f]), x = t.seed, C = t.roundKey ?? x, w = L(() => Array.from({ length: v }, (e, t) => p(x, t)), [
		x,
		v,
		C
	]), [T, E] = ne(() => ({
		key: C,
		lanes: /* @__PURE__ */ new Map()
	})), D = L(() => T.key === C ? T.lanes : /* @__PURE__ */ new Map(), [T, C]), O = t.onLaneSettled, k = M((e, t) => {
		E((n) => {
			let r = n.key === C ? n.lanes : /* @__PURE__ */ new Map();
			if (r.has(e)) return n;
			let i = new Map(r);
			return i.set(e, t), {
				key: C,
				lanes: i
			};
		}), O?.(e, t);
	}, [O, C]), A = v > 0 && D.size >= v, j = R(t.onRevealComplete);
	j.current = t.onRevealComplete;
	let ee = R(null);
	P(() => {
		if (!A || ee.current === C) return;
		let e = setTimeout(() => {
			ee.current = C, j.current?.();
		}, gu + b.showMs);
		return () => clearTimeout(e);
	}, [
		A,
		b.showMs,
		C
	]);
	let te = L(() => ({
		strings: s,
		theme: c,
		sounds: u,
		currency: a
	}), [
		s,
		c,
		u,
		a
	]), N = L(() => ({
		box: t.box,
		laneItems: _,
		generators: w,
		seed: x,
		roundKey: C,
		running: t.running,
		invertSound: t.invertSound ?? !1,
		compact: f,
		startOffsetMs: g,
		layout: y,
		timings: b,
		landed: D,
		laneLanded: k
	}), [
		t.box,
		_,
		w,
		x,
		C,
		t.running,
		t.invertSound,
		f,
		g,
		y,
		b,
		D,
		k
	]);
	return /* @__PURE__ */ B(S.Provider, {
		value: te,
		children: /* @__PURE__ */ B(Ac.Provider, {
			value: N,
			children: t.children
		})
	});
}
//#endregion
//#region src/battle/BattleRarityFrame.tsx
function Cu({ orientation: e, variant: t, color: n, inset: r = 0, endInset: i, side: a = "both", className: o }) {
	let s = i ?? r;
	if (e === "vertical") return /* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: J(Y.frame, o),
		children: [a === "end" ? null : /* @__PURE__ */ B(Eu, {
			className: J(Y.rail, Y.railStartVertical),
			color: n,
			style: { left: r }
		}), a === "start" ? null : /* @__PURE__ */ B(Eu, {
			className: J(Y.rail, Y.railEndVertical),
			color: n,
			style: { right: s }
		})]
	});
	let c = t === "desktop" ? Tu : wu, l = t === "desktop";
	return /* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: J(Y.frame, o),
		children: [a === "end" ? null : /* @__PURE__ */ B(c, {
			className: J(Y.rail, l ? Y.railStartHorizontalFlipped : Y.railStartHorizontal),
			color: n,
			style: { top: r }
		}), a === "start" ? null : /* @__PURE__ */ B(c, {
			className: J(Y.rail, l ? Y.railEndHorizontal : Y.railEndHorizontalFlipped),
			color: n,
			style: { bottom: s }
		})]
	});
}
function wu({ className: e, color: t, style: n }) {
	let r = Ou();
	return /* @__PURE__ */ V("svg", {
		"aria-hidden": "true",
		className: e,
		width: "62",
		height: "9",
		viewBox: "0 0 62 9",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ B("path", {
			d: "M62 0.611684L36.1139 0.501953L31.0527 7.50195L25.929 0.503092M0 0.611395L12.6531 0.611684L25.929 0.503092L31.0527 4.75195L36.1139 0.503092",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ B(Du, {
			id: r,
			color: t,
			length: "62"
		})]
	});
}
function Tu({ className: e, color: t, style: n }) {
	let r = Ou();
	return /* @__PURE__ */ V("svg", {
		"aria-hidden": "true",
		className: e,
		width: "74",
		height: "14",
		viewBox: "0 0 74 14",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ B("path", {
			d: "M0.00390625 13.3119L30.6914 13.5L36.6914 1.49988L42.7655 13.498M73.5039 13.3124L58.5039 13.3119L42.7655 13.498L36.6914 4.49988L30.6914 13.498",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ B(Du, {
			id: r,
			color: t,
			length: "74"
		})]
	});
}
function Eu({ className: e, color: t, style: n }) {
	let r = Ou();
	return /* @__PURE__ */ V("svg", {
		"aria-hidden": "true",
		className: e,
		width: "14",
		height: "74",
		viewBox: "0 0 14 74",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ B("path", {
			d: "M0.688111 0.00390625L0.5 30.6914L12.5001 36.6914L0.501953 42.7655M0.687616 73.5039L0.688111 58.5039L0.501953 42.7655L9.50012 36.6914L0.501953 30.6914",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ B("defs", { children: /* @__PURE__ */ V("linearGradient", {
			id: r,
			x1: "6.75",
			y1: "0",
			x2: "6.75",
			y2: "74",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ B("stop", {
					stopColor: t,
					stopOpacity: "0"
				}),
				/* @__PURE__ */ B("stop", {
					offset: "0.5",
					stopColor: t
				}),
				/* @__PURE__ */ B("stop", {
					offset: "1",
					stopColor: t,
					stopOpacity: "0"
				})
			]
		}) })]
	});
}
function Du({ id: e, color: t, length: n }) {
	return /* @__PURE__ */ B("defs", { children: /* @__PURE__ */ V("linearGradient", {
		id: e,
		x1: n,
		y1: "4.15",
		x2: "0",
		y2: "4.15",
		gradientUnits: "userSpaceOnUse",
		children: [
			/* @__PURE__ */ B("stop", {
				stopColor: t,
				stopOpacity: "0"
			}),
			/* @__PURE__ */ B("stop", {
				offset: "0.5",
				stopColor: t
			}),
			/* @__PURE__ */ B("stop", {
				offset: "1",
				stopColor: t,
				stopOpacity: "0"
			})
		]
	}) });
}
function Ou() {
	return `los-battle-frame-${F().replace(/:/g, "")}`;
}
//#endregion
//#region src/battle/BattleSpinnerPointers.tsx
function ku({ orientation: e, color: t, compact: n, config: r }) {
	return e === "horizontal" ? n ? r.compactEdgePointers ? /* @__PURE__ */ B(Cu, {
		orientation: "horizontal",
		variant: "mobile",
		color: t,
		inset: r.compactEdgeInset ?? 42,
		endInset: r.compactEdgeEndInset ?? 6
	}) : /* @__PURE__ */ B(Cu, {
		orientation: "horizontal",
		variant: "mobile",
		color: t,
		inset: 12
	}) : /* @__PURE__ */ B(Cu, {
		orientation: "horizontal",
		variant: "desktop",
		color: t,
		inset: r.horizontalInset ?? 56,
		endInset: r.horizontalEndInset ?? 12
	}) : /* @__PURE__ */ B(Cu, {
		orientation: "vertical",
		variant: "desktop",
		color: t,
		inset: r.verticalInset ?? 12
	});
}
//#endregion
//#region src/battle/BattleSeatColumn.tsx
function Au({ seatIndex: e, header: t, rowIndex: n, isLastInRow: r, isLastRow: i }) {
	let { theme: a } = l(), { layout: o, box: s, laneItems: u, landed: d } = jc(), f = u[e] ?? null, p = d.has(e) && s && f ? E(a.railHex, c(f.value, s.priceCents)) : a.colors.border, { spinner: m, columnVariant: h, headerAlign: g } = o, _ = h === "mobile-grid", v = h === "mobile-2p" || h === "mobile-3p", y = g === "right" || g === "none", b = g === "compact" || g === "none" && o.viewport === "mobile";
	return /* @__PURE__ */ B("div", {
		className: J(Y.column, r && Y.columnLastInRow, i && Y.columnLastRow, h !== "default" && Y.columnGrid),
		style: ju({
			columnVariant: h,
			rowIndex: n,
			isLastRow: i
		}),
		"data-los-battle-seat": e,
		children: /* @__PURE__ */ V("div", {
			className: J(Y.columnInner, _ && Y.columnInnerGrid, v && Y.columnInnerCompact, y && Y.columnInnerBare),
			children: [
				g === "none" ? null : /* @__PURE__ */ B("div", {
					className: J(Y.header, g === "right" && Y.headerRight, g === "compact" && Y.headerCompact),
					children: t
				}),
				/* @__PURE__ */ B(ku, {
					orientation: m.orientation,
					color: p,
					compact: b,
					config: m.pointers
				}),
				/* @__PURE__ */ B(Nc, {
					lane: e,
					className: J(m.viewport.position === "absolute-top" && Y.viewportAbsoluteTop, m.viewport.position === "absolute-center" && Y.viewportAbsoluteCenter),
					style: Mu(m.viewport)
				})
			]
		})
	});
}
function ju({ columnVariant: e, rowIndex: t, isLastRow: n }) {
	switch (e) {
		case "default": return { padding: 6 };
		case "mobile-2p": return { padding: `${t === 0 ? 6 : 3}px 6px ${n ? 6 : 3}px` };
		case "mobile-3p": return { padding: `${t === 0 ? 5 : 3}px 5px ${n ? 6 : 3}px` };
		case "mobile-grid": return { padding: 0 };
	}
}
function Mu(e) {
	let t = e.marginX ?? 0, n = {
		width: t < 0 && e.width === "100%" ? `calc(100% + ${-2 * t}px)` : e.width,
		height: e.height,
		maxWidth: t < 0 ? "none" : void 0
	};
	return e.position === "flow" && (n.marginTop = e.marginTop, n.marginLeft = t || void 0, n.marginRight = t || void 0), e.position === "absolute-top" && (n.top = e.top), n;
}
//#endregion
//#region src/battle/BattleOpener.tsx
function Nu(e) {
	let t = R(null), [n, r] = ne(null);
	I(() => {
		let e = t.current;
		if (!e) return;
		let n = () => r(e.offsetWidth);
		if (n(), typeof ResizeObserver > "u") return;
		let i = new ResizeObserver(n);
		return i.observe(e), () => i.disconnect();
	}, []);
	let i = e.compact ?? "auto", a = e.solo ? 480 : 768, o = i === "auto" ? n !== null && n < a : i;
	return /* @__PURE__ */ B(Su, {
		box: e.box,
		laneItems: e.laneItems,
		seed: e.seed,
		running: e.running,
		quick: e.quick,
		invertSound: e.invertSound,
		compact: o,
		solo: e.solo,
		startOffsetMs: e.startOffsetMs,
		sounds: e.sounds,
		theme: e.theme,
		currency: e.currency,
		locale: e.locale,
		onLaneSettled: e.onLaneSettled,
		onRevealComplete: e.onRevealComplete,
		children: /* @__PURE__ */ B(Pu, {
			rootRef: t,
			measured: n !== null || i !== "auto",
			renderSeatHeader: e.renderSeatHeader,
			overlay: e.overlay,
			className: e.className,
			style: e.style
		})
	});
}
function Pu({ rootRef: e, measured: t, renderSeatHeader: n, overlay: r, className: i, style: a }) {
	let { theme: o } = l(), { layout: s, laneItems: c, landed: u, compact: d } = jc(), f = c.length, p = {
		gridTemplateColumns: `repeat(${s.columns}, minmax(0, 1fr))`,
		height: s.height,
		gap: s.gap,
		padding: s.padding
	};
	return /* @__PURE__ */ V("div", {
		ref: e,
		className: J(Y.root, i),
		style: {
			...o.cssVars,
			...a
		},
		"data-los-battle-opener": !0,
		"data-los-battle-layout": s.key,
		"data-los-battle-viewport": s.viewport,
		children: [t ? /* @__PURE__ */ V("div", {
			className: Y.grid,
			style: p,
			children: [c.map((e, t) => {
				let r = Math.floor(t / s.columns), i = u.has(t);
				return /* @__PURE__ */ B(Au, {
					seatIndex: t,
					header: n?.(t, {
						compact: d,
						settled: i,
						layout: s
					}),
					rowIndex: r,
					isLastInRow: (t + 1) % s.columns === 0 || t === f - 1,
					isLastRow: r === s.rows - 1
				}, t);
			}), /* @__PURE__ */ B(Fc, { layout: s })]
		}) : null, r]
	});
}
//#endregion
//#region src/battle/BattleResultsGrid.tsx
function Fu(t) {
	let i = Rc(), a = L(() => h(t.theme ?? i.theme), [t.theme, i.theme]), o = t.currency ?? i.currency ?? e, s = L(() => r(t.locale ?? i.locale), [t.locale, i.locale]), c = R(null), [l, u] = ne(null);
	I(() => {
		let e = c.current;
		if (!e) return;
		let t = () => u(e.offsetWidth);
		if (t(), typeof ResizeObserver > "u") return;
		let n = new ResizeObserver(t);
		return n.observe(e), () => n.disconnect();
	}, []);
	let d = t.compact ?? "auto", f = d === "auto" ? l !== null && l < 768 : d, p = lu({
		playerCount: t.lanes.length,
		viewport: f ? "mobile" : "desktop"
	}).results.cardsPerRow, m = L(() => Array.from({ length: t.roundCount }, (e, t) => t), [t.roundCount]), g = (e, n) => {
		let r = e.items[n] ?? null;
		return r ? /* @__PURE__ */ B(Iu, {
			item: r,
			priceCents: t.roundPriceCents[n] ?? 0,
			theme: a,
			currency: o
		}, n) : /* @__PURE__ */ V("div", {
			className: J(Y.resultCard, Y.resultPlaceholder),
			title: `${s.battleRound} ${n + 1}`,
			children: [/* @__PURE__ */ B("p", {
				className: Y.resultPlaceholderLabel,
				children: s.battleRound.toUpperCase()
			}), /* @__PURE__ */ B("p", {
				className: Y.resultPlaceholderNumber,
				children: String(n + 1).padStart(2, "0")
			})]
		}, n);
	};
	return /* @__PURE__ */ B("div", {
		ref: c,
		className: J(Y.root, t.className),
		style: {
			...a.cssVars,
			...t.style
		},
		"data-los-battle-results": !0,
		children: l === null && d === "auto" ? null : f ? /* @__PURE__ */ B("div", {
			className: Y.resultsMobile,
			children: t.lanes.map((e, r) => /* @__PURE__ */ V("div", {
				className: Y.resultsMobileSeat,
				children: [/* @__PURE__ */ V("div", {
					className: Y.resultsMobileHeader,
					children: [t.renderSeatHeader(r, { compact: !0 }), /* @__PURE__ */ B("span", {
						className: Y.resultsMobileTotal,
						children: e.totalCents > 0 ? n(e.totalCents, o) : "-"
					})]
				}), /* @__PURE__ */ B("div", {
					className: Y.resultsMobileStrip,
					children: m.map((t) => g(e, t))
				})]
			}, r))
		}) : /* @__PURE__ */ B("div", {
			className: Y.results,
			style: { gridTemplateColumns: `repeat(${t.lanes.length}, minmax(0, 1fr))` },
			children: t.lanes.map((e, r) => /* @__PURE__ */ V("div", {
				className: Y.resultsSeat,
				children: [/* @__PURE__ */ V("div", {
					className: Y.resultsHeader,
					children: [t.renderSeatHeader(r, { compact: !1 }), /* @__PURE__ */ B("div", {
						className: Y.resultsTotal,
						children: e.totalCents > 0 ? n(e.totalCents, o) : "-"
					})]
				}), /* @__PURE__ */ B("div", {
					className: Y.resultsCards,
					style: { gridTemplateColumns: `repeat(${p}, minmax(0, 1fr))` },
					children: m.map((t) => g(e, t))
				})]
			}, r))
		})
	});
}
function Iu({ item: e, priceCents: t, theme: r, currency: i }) {
	let a = E(r.railHex, c(e.value, t));
	return /* @__PURE__ */ V(ae.div, {
		className: Y.resultCard,
		style: { borderColor: a },
		initial: {
			opacity: 0,
			scale: .92
		},
		animate: {
			opacity: 1,
			scale: 1
		},
		transition: {
			type: "tween",
			duration: .35,
			ease: "easeOut"
		},
		title: e.name,
		children: [
			e.imageUrl ? /* @__PURE__ */ B("img", {
				className: Y.resultCardImage,
				src: e.imageUrl,
				alt: e.name,
				loading: "eager",
				decoding: "async"
			}) : /* @__PURE__ */ B("span", {
				"aria-hidden": !0,
				className: J(Y.resultCardImage, Y.resultCardImageMissing)
			}),
			/* @__PURE__ */ B("p", {
				className: Y.resultCardName,
				children: e.name
			}),
			/* @__PURE__ */ B("span", {
				className: Y.resultCardValue,
				style: { color: a },
				children: n(e.value, i, { compact: !0 })
			})
		]
	});
}
//#endregion
//#region src/battle/BattleStartingOverlay.tsx
var Lu = 240;
function Ru({ endsAtMs: e, now: t = Date.now, onFinished: n, children: r, className: i }) {
	let { strings: a } = l(), [o, s] = ne(() => Math.max(0, e - t())), c = R(!1);
	P(() => {
		c.current = !1;
		let r = () => {
			let r = Math.max(0, e - t());
			s(r), r <= 0 && !c.current && (c.current = !0, n());
		};
		r();
		let i = setInterval(r, 50);
		return () => clearInterval(i);
	}, [
		e,
		t,
		n
	]);
	let u = Math.ceil(o / 1e3), d = u > 0 ? String(u) : a.battleGo, f = o <= Lu;
	return /* @__PURE__ */ V(ae.div, {
		className: J(Y.starting, i),
		"data-los-battle-starting": !0,
		initial: !1,
		animate: {
			filter: f ? "blur(18px)" : "blur(0px)",
			opacity: +!f,
			scale: f ? 1.015 : 1
		},
		transition: {
			duration: f ? Lu / 1e3 : 0,
			ease: "easeInOut"
		},
		children: [
			/* @__PURE__ */ B("span", {
				className: Y.startingLabel,
				children: a.battleStartsIn
			}),
			/* @__PURE__ */ B("div", {
				className: Y.startingCount,
				"aria-live": "polite",
				children: /* @__PURE__ */ B(ae.span, {
					className: J(Y.startingDigit, u <= 0 && Y.startingGo),
					initial: {
						scale: 1.6,
						opacity: 0
					},
					animate: {
						scale: 1,
						opacity: 1
					},
					transition: {
						type: "tween",
						duration: .25,
						ease: "easeOut"
					},
					children: d
				}, d)
			}),
			/* @__PURE__ */ B("span", {
				className: J(Y.startingLabel, Y.startingLuck),
				children: a.battleGoodLuck
			}),
			r ? /* @__PURE__ */ B("div", {
				className: Y.startingSeats,
				children: r
			}) : null
		]
	});
}
//#endregion
//#region src/core/machine.ts
var zu = 700;
function Bu(e) {
	let { openBox: t, onBeforeOpen: n, revealStartDelayMs: r = 700, minQuantity: i = 1, maxQuantity: a = 5, onEvent: o } = e, s = (e) => Math.max(i, Math.min(a, Math.floor(e) || i)), c = {
		phase: "idle",
		quantity: s(e.defaultQuantity ?? i),
		isQuickReveal: e.defaultQuickReveal ?? !1,
		entries: [],
		lastResponse: null,
		claimStatus: "none",
		pendingClaim: null,
		claim: null,
		claimError: null,
		sale: null,
		sellError: null,
		error: null,
		openCount: 0
	}, l = /* @__PURE__ */ new Set(), u = null, d = 0, f = !1, p = (e) => o?.(e), m = (e) => {
		c = {
			...c,
			...e
		};
		for (let e of l) e();
	}, h = () => {
		u !== null && (clearTimeout(u), u = null);
	}, g = (e) => {
		c.phase === "revealing" && (m({
			phase: "results",
			openCount: c.openCount + 1
		}), e && p({ type: "skipped" }), p({
			type: "reveal_complete",
			response: c.lastResponse,
			skipped: e
		}));
	};
	return {
		getState: () => c,
		subscribe: (e) => (l.add(e), () => l.delete(e)),
		open: async (i = c.quantity) => {
			if (f || c.phase !== "idle") return;
			let a = s(i), o = ++d;
			if (n) {
				let e;
				try {
					e = await n(a);
				} catch {
					e = !1;
				}
				if (e === !1) {
					p({
						type: "open_vetoed",
						quantity: a
					});
					return;
				}
				if (o !== d || c.phase !== "idle") return;
			}
			m({
				phase: "requesting",
				quantity: a,
				entries: [],
				claimStatus: "none",
				pendingClaim: null,
				claim: null,
				claimError: null,
				sale: null,
				sellError: null,
				error: null
			}), p({
				type: "open_start",
				quantity: a
			});
			let l;
			try {
				l = await t(a);
			} catch (e) {
				if (o !== d) return;
				m({
					phase: "idle",
					error: e
				}), p({
					type: "error",
					error: e
				});
				return;
			}
			if (o !== d) return;
			p({
				type: "opened",
				response: l
			});
			let h = () => {
				u = null;
				let t = l.status !== "claimed" && !!e.claimReveal && !e.settlesOnReveal?.(l);
				m({
					phase: "revealing",
					entries: l.entries,
					lastResponse: l,
					claimStatus: l.status === "claimed" ? "claimed" : t ? "unclaimed" : "none",
					pendingClaim: t ? {
						openGroupId: l.openGroupId,
						costCents: l.costCents
					} : null,
					claim: l.claim
				}), p({
					type: "reveal_start",
					response: l
				});
			};
			r > 0 ? u = setTimeout(h, r) : h();
		},
		skip: () => g(!0),
		completeReveal: () => g(!1),
		claim: async () => {
			if (f || !e.claimReveal || c.phase !== "results" || c.claimStatus !== "unclaimed") return;
			let t = c.pendingClaim;
			if (!t) return;
			let n = d;
			m({
				claimStatus: "claiming",
				claimError: null,
				sellError: null
			}), p({
				type: "claim_start",
				openGroupId: t.openGroupId
			});
			let r;
			try {
				r = await e.claimReveal(t);
			} catch (e) {
				if (n !== d) return;
				m({
					claimStatus: "unclaimed",
					claimError: e
				}), p({
					type: "claim_error",
					error: e
				});
				return;
			}
			n === d && (m({
				claimStatus: "claimed",
				pendingClaim: null,
				claim: r
			}), p({
				type: "claimed",
				claim: r
			}));
		},
		sellBack: async () => {
			if (f || !e.sellBackReveal || c.phase !== "results" || c.claimStatus !== "unclaimed") return;
			let t = c.pendingClaim;
			if (!t) return;
			let n = d;
			m({
				claimStatus: "selling",
				claimError: null,
				sellError: null
			}), p({
				type: "sell_back_start",
				openGroupId: t.openGroupId
			});
			let r;
			try {
				r = await e.sellBackReveal(t);
			} catch (e) {
				if (n !== d) return;
				m({
					claimStatus: "unclaimed",
					sellError: e
				}), p({
					type: "sell_back_error",
					error: e
				});
				return;
			}
			n === d && (m({
				claimStatus: "sold",
				pendingClaim: null,
				claim: r,
				sale: r
			}), p({
				type: "sold_back",
				sale: r
			}));
		},
		restore: (e) => {
			f || c.phase !== "idle" || c.pendingClaim || (m({
				phase: "results",
				entries: e.entries,
				claimStatus: "unclaimed",
				pendingClaim: {
					openGroupId: e.openGroupId,
					costCents: e.costCents
				},
				claim: null,
				claimError: null,
				sale: null,
				sellError: null,
				error: null
			}), p({
				type: "restored",
				reveal: e
			}));
		},
		reset: () => {
			c.claimStatus !== "unclaimed" && c.claimStatus !== "claiming" && c.claimStatus !== "selling" && (d++, h(), (c.phase !== "idle" || c.error !== null || c.entries.length !== 0) && (m({
				phase: "idle",
				entries: [],
				claimStatus: "none",
				pendingClaim: null,
				claim: null,
				claimError: null,
				sale: null,
				sellError: null,
				error: null
			}), p({ type: "reset" })));
		},
		setQuantity: (e) => {
			let t = s(e);
			t !== c.quantity && (c.phase === "idle" || c.phase === "results") && m({ quantity: t });
		},
		setQuickReveal: (e) => {
			e !== c.isQuickReveal && m({ isQuickReveal: e });
		},
		dispose: () => {
			f = !0, d++, h(), l.clear();
		},
		isDisposed: () => f
	};
}
//#endregion
//#region src/core/quantities.ts
var Vu = [
	1,
	2,
	3,
	4,
	5
];
function Hu(e) {
	let { descriptor: t } = e;
	if (!t.supportsBulk) return [1];
	let n = Math.min(e.maxQuantity ?? 36, t.bulkLimit ?? 5, 36), r = (e.quantities ?? Vu).filter((e) => Number.isInteger(e) && e >= 1 && e <= n).sort((e, t) => e - t), i = [...new Set(r)];
	return i.length > 0 ? i : [1];
}
function Uu(e, t) {
	if (t === void 0 || e.length <= t) return e;
	let n = e.reduce((e, t) => e === void 0 || t.item.value > e.item.value ? t : e, void 0);
	return n ? [n] : [];
}
//#endregion
//#region src/core/revealExit.ts
function Wu({ revealExit: e, isQuickReveal: t, actions: n }) {
	let r = null, i = () => {
		r &&= (clearTimeout(r), null);
	};
	return {
		completeReveal: () => {
			i();
			let a = t ? e.lingerMs.quick : e.lingerMs.normal;
			if (a === 0) {
				n.finishReveal();
				return;
			}
			r = setTimeout(() => {
				r = null, n.finishReveal();
			}, a);
		},
		skipReveal: (e) => {
			e?.(), i(), n.skipReveal();
		},
		cancel: i
	};
}
//#endregion
//#region src/core/types.ts
function Gu(e) {
	return e.demo === !0;
}
function Ku(e) {
	if (typeof e != "object" || !e) return !1;
	let t = e;
	return typeof t.code == "string" && typeof t.message == "string";
}
//#endregion
//#region src/react/lootQueryClient.ts
var qu;
function Ju() {
	return qu ??= new le({ defaultOptions: {
		queries: {
			retry: !1,
			refetchOnWindowFocus: !1,
			refetchOnReconnect: !1,
			staleTime: 3e4
		},
		mutations: { retry: !1 }
	} }), qu;
}
var Yu = /* @__PURE__ */ new WeakMap(), Xu = 0;
function Zu(e) {
	if (!e) return null;
	let t = Yu.get(e);
	return t === void 0 && (Xu += 1, t = Xu, Yu.set(e, t)), t;
}
function Qu() {
	return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID() : Math.random().toString(36).slice(2) + Date.now().toString(36);
}
var X = {
	panel: "_panel_1nqtp_1",
	toggle: "_toggle_1nqtp_11",
	chevron: "_chevron_1nqtp_30",
	chevronOpen: "_chevronOpen_1nqtp_35",
	body: "_body_1nqtp_39",
	row: "_row_1nqtp_46",
	label: "_label_1nqtp_52",
	value: "_value_1nqtp_57",
	seedInput: "_seedInput_1nqtp_63",
	entries: "_entries_1nqtp_78",
	entryRow: "_entryRow_1nqtp_87",
	muted: "_muted_1nqtp_94"
}, $u = "los:clientSeed", ed = 36;
function td() {
	return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? crypto.randomUUID().split("-")[0] ?? "seed" : Math.random().toString(36).slice(2, 10);
}
function nd(e) {
	return e.slice(0, 36);
}
function rd() {
	if (typeof window > "u") return null;
	try {
		let e = window.localStorage.getItem($u);
		return e ? nd(e) : null;
	} catch {
		return null;
	}
}
function id({ clientSeed: e, onClientSeedChange: t }) {
	let n = e !== void 0, [r, i] = ne(() => rd() ?? td());
	P(() => {
		if (!(n || typeof window > "u")) try {
			window.localStorage.setItem($u, r);
		} catch {}
	}, [n, r]);
	let a = M((e) => {
		let r = nd(e);
		t?.(r), n || i(r);
	}, [n, t]);
	return [n ? nd(e) : r, a];
}
//#endregion
//#region src/fairness/ProvablyFairPanel.tsx
function ad() {
	return (/* @__PURE__ */ new Date()).toISOString().slice(0, 10);
}
function od({ client: e, lastResponse: t, clientSeed: n, onClientSeedChange: r, locked: i = !1, defaultOpen: a = !1, className: o }) {
	let { strings: s } = l(), [c, u] = ne(a), d = F(), f = t?.fairness ?? null, p = de({
		queryKey: [
			"loot-os",
			"seed",
			Zu(e),
			ad()
		],
		queryFn: async () => await e?.getSeed?.(ad()) ?? null,
		enabled: c && !f && !!e?.getSeed,
		staleTime: Infinity
	}, Ju()), m = f?.serverSeedHash ?? p.data?.seedHash ?? null;
	return /* @__PURE__ */ V("div", {
		className: J(X.panel, o),
		children: [/* @__PURE__ */ V("button", {
			type: "button",
			className: X.toggle,
			"aria-expanded": c,
			"aria-controls": d,
			onClick: () => u((e) => !e),
			children: [
				/* @__PURE__ */ B("span", {
					"aria-hidden": !0,
					children: "ⓘ"
				}),
				s.provablyFair,
				/* @__PURE__ */ B("span", {
					"aria-hidden": !0,
					className: J(X.chevron, c && X.chevronOpen),
					children: "▾"
				})
			]
		}), c && /* @__PURE__ */ V("div", {
			className: X.body,
			id: d,
			children: [
				/* @__PURE__ */ V("div", {
					className: X.row,
					children: [/* @__PURE__ */ B("span", {
						className: X.label,
						children: s.serverSeedHash
					}), /* @__PURE__ */ B("span", {
						className: X.value,
						children: m ?? "…"
					})]
				}),
				/* @__PURE__ */ V("div", {
					className: X.row,
					children: [/* @__PURE__ */ B("label", {
						className: X.label,
						htmlFor: `${d}-seed`,
						children: s.clientSeed
					}), /* @__PURE__ */ B("input", {
						id: `${d}-seed`,
						className: X.seedInput,
						value: n,
						maxLength: 36,
						disabled: i,
						onChange: (e) => r(e.target.value)
					})]
				}),
				f ? /* @__PURE__ */ V(z, { children: [
					/* @__PURE__ */ V("div", {
						className: X.row,
						children: [/* @__PURE__ */ B("span", {
							className: X.label,
							children: s.salt
						}), /* @__PURE__ */ B("span", {
							className: X.value,
							children: f.salt
						})]
					}),
					/* @__PURE__ */ V("div", {
						className: X.row,
						children: [/* @__PURE__ */ B("span", {
							className: X.label,
							children: s.seedDate
						}), /* @__PURE__ */ B("span", {
							className: X.value,
							children: f.seedDate
						})]
					}),
					/* @__PURE__ */ V("div", {
						className: X.row,
						children: [/* @__PURE__ */ V("span", {
							className: X.label,
							children: [
								s.nonce,
								" / ",
								s.result
							]
						}), /* @__PURE__ */ B("ul", {
							className: X.entries,
							children: (t?.entries ?? []).map((e) => /* @__PURE__ */ V("li", {
								className: X.entryRow,
								children: [/* @__PURE__ */ V("span", { children: ["#", e.nonce] }), /* @__PURE__ */ B("span", { children: e.result })]
							}, e.openId))
						})]
					})
				] }) : /* @__PURE__ */ B("span", {
					className: X.muted,
					children: s.noOpensYet
				})
			]
		})]
	});
}
//#endregion
//#region src/demo/demoOpen.ts
function sd() {
	if (typeof crypto < "u" && typeof crypto.getRandomValues == "function") {
		let e = /* @__PURE__ */ new Uint32Array(1), t = Math.floor(4294967296 / _) * _, n = 0;
		do
			crypto.getRandomValues(e), n = e[0] ?? 0;
		while (n >= t);
		return n % _;
	}
	return Math.floor(Math.random() * _);
}
function cd(e) {
	return typeof crypto < "u" && typeof crypto.randomUUID == "function" ? `${e}_${crypto.randomUUID()}` : `${e}_${Math.random().toString(36).slice(2)}`;
}
function ld(e, t, n) {
	let r = [];
	for (let n = 0; n < t; n++) {
		let t = sd(), i = m(e.dropTable, t) ?? 0, a = e.dropTable[i];
		a && r.push({
			openId: cd("demo_open"),
			nonce: n,
			result: t,
			itemIndex: i,
			item: a
		});
	}
	return {
		demo: !0,
		openGroupId: cd("demo_group"),
		boxId: e.id,
		boxVersion: e.version,
		costCents: e.priceCents * t,
		dropTableHash: e.dropTableHash,
		status: "unclaimed",
		claim: null,
		entries: r,
		fairness: {
			seedDate: (/* @__PURE__ */ new Date()).toISOString().slice(0, 10),
			serverSeedHash: "demo",
			clientSeed: n,
			salt: "demo",
			nonces: r.map((e) => e.nonce)
		}
	};
}
function ud(e, t) {
	return {
		openGroupId: e.openGroupId,
		costCents: e.costCents,
		balanceAfterCents: 0,
		claimedAt: (/* @__PURE__ */ new Date()).toISOString(),
		items: t.map((e) => ({
			openId: e.openId,
			inventoryItemId: cd("demo_inv"),
			item: e.item,
			isLimited: e.item.isLimited ?? !1
		}))
	};
}
function dd(e, t) {
	let n = ud(e, t), r = t.reduce((e, t) => e + t.item.value, 0);
	return {
		...n,
		balanceAfterCents: n.balanceAfterCents + r,
		soldCents: r,
		soldAt: (/* @__PURE__ */ new Date()).toISOString()
	};
}
var Z = {
	opener: "_opener_pm16a_3",
	band: "_band_pm16a_11",
	bandDesktop: "_bandDesktop_pm16a_24",
	bandMobile: "_bandMobile_pm16a_28",
	stage: "_stage_pm16a_35",
	brandMark: "_brandMark_pm16a_46",
	brandName: "_brandName_pm16a_58",
	railLayer: "_railLayer_pm16a_78",
	wheelArea: "_wheelArea_pm16a_88",
	spinner: "_spinner_pm16a_102",
	spinnerRow: "_spinnerRow_pm16a_113",
	spinnerColumn: "_spinnerColumn_pm16a_118",
	laneRow2: "_laneRow2_pm16a_123",
	laneRowHorizontal: "_laneRowHorizontal_pm16a_130",
	laneRowVertical: "_laneRowVertical_pm16a_134",
	lane: "_lane_pm16a_123",
	laneHorizontal: "_laneHorizontal_pm16a_143",
	laneVertical: "_laneVertical_pm16a_147",
	laneItems: "_laneItems_pm16a_151",
	laneItemsHorizontal: "_laneItemsHorizontal_pm16a_157",
	laneItemsVertical: "_laneItemsVertical_pm16a_161",
	card: "_card_pm16a_166",
	cardImage: "_cardImage_pm16a_174",
	itemLabel: "_itemLabel_pm16a_182",
	itemLabelHidden: "_itemLabelHidden_pm16a_192",
	itemLabelInner: "_itemLabelInner_pm16a_196",
	itemLabelValue: "_itemLabelValue_pm16a_204",
	itemLabelName: "_itemLabelName_pm16a_210",
	fade: "_fade_pm16a_223",
	fadeLeft: "_fadeLeft_pm16a_230",
	fadeRight: "_fadeRight_pm16a_238",
	fadeTop: "_fadeTop_pm16a_246",
	fadeBottom: "_fadeBottom_pm16a_254",
	railRoot: "_railRoot_pm16a_263",
	railSvg: "_railSvg_pm16a_270",
	railTop: "_railTop_pm16a_274",
	railBottom: "_railBottom_pm16a_280",
	railLeft: "_railLeft_pm16a_286",
	railRight: "_railRight_pm16a_292"
};
//#endregion
//#region src/spinner/SpinnerWheel.tsx
function fd({ item: e }) {
	let { currency: t } = l();
	return /* @__PURE__ */ V("div", {
		className: Z.itemLabelInner,
		children: [/* @__PURE__ */ B("span", {
			className: Z.itemLabelValue,
			children: n(e.value, t, { compact: !0 })
		}), /* @__PURE__ */ B("p", {
			className: Z.itemLabelName,
			children: e.name
		})]
	});
}
function pd({ index: e, getBoxItemsByIndex: t, animationPhase: n, setAnimationPhase: r, isRowOpen: i, geometry: o, timing: s, sounds: c, selectedOpenQuantity: l, isMobile: u, rarityRgb: d, selectedItemIndexRef: f, onRevealComplete: p, onItemSettled: m, renderItemLabel: h }) {
	let { itemWidth: g, gap: _, containerWidth: v, containerHeight: y, startingOffset: b, endingOffset: x, spinSnapOffsets: S } = o, { animationDuration: w, spinStartDelaySec: T, staggerDelay: E, popupDuration: D } = s, { playTickSound: O, playRaritySound: k, lastTickTimeRef: A } = c, j = t(e), ee = () => {
		let t = j?.[35];
		t && (m?.(t.rarity, e), k(t.rarity));
	}, te = w + e * E, M = !u;
	return /* @__PURE__ */ B(ae.div, {
		className: J(Z.lane, i ? Z.laneHorizontal : Z.laneVertical),
		"data-los-lane": e,
		initial: {
			transform: i ? `translateX(${b}px)` : `translateY(${b}px)`,
			opacity: 0
		},
		animate: n === "initialSpin" ? {
			transform: i ? `translateX(${x + (S[e] ?? 0)}px)` : `translateY(${x + (S[e] ?? 0)}px)`,
			opacity: 1
		} : {
			transform: i ? `translateX(${x}px)` : `translateY(${x}px)`,
			opacity: 1
		},
		transition: n === "initialSpin" ? {
			type: "tween",
			duration: w,
			delay: T,
			ease: [
				.25,
				.8,
				.5,
				1
			],
			opacity: {
				duration: .3,
				ease: "easeOut",
				delay: T
			}
		} : {
			type: "tween",
			duration: 300 / 1e3,
			ease: "easeOut",
			delay: e * E
		},
		style: { willChange: "transform, opacity" },
		onUpdate: (t) => {
			if (n !== "initialSpin" || !j || e !== 0) return;
			let r = Date.now();
			if (r - A.current < 16) return;
			A.current = r;
			let i = (t.transform ?? "").match(/translate[XY]\((-?\d+\.?\d*)px\)/);
			if (!i?.[1]) return;
			let a = Number.parseFloat(i[1]), o = u ? v / 2 : (l === 1 ? v : y) / 2, s = Math.round((o - a - g / 2) / (g + _));
			f.current !== s && s >= 0 && s < j.length && (f.current = s, O());
		},
		onAnimationComplete: () => {
			n === "initialSpin" ? r("snap") : n === "snap" && ee();
		},
		children: /* @__PURE__ */ B("div", {
			className: J(Z.laneItems, i ? Z.laneItemsHorizontal : Z.laneItemsVertical),
			style: { gap: `${_}px` },
			children: j?.map((t, n) => /* @__PURE__ */ V(ae.div, {
				className: Z.card,
				style: {
					height: `${g}px`,
					width: `${g}px`,
					willChange: n === 35 ? "transform" : "transform, opacity"
				},
				animate: n === 35 ? { scale: [
					1,
					1.12,
					1.08
				] } : {
					scale: [1, .9],
					opacity: [1, .25]
				},
				transition: {
					type: "tween",
					duration: D,
					ease: "easeOut",
					delay: te
				},
				onAnimationComplete: () => {
					!M && n === 35 && e === l - 1 && p?.();
				},
				children: [/* @__PURE__ */ B(ae.img, {
					src: t.imageUrl ?? "",
					alt: `${t.name}`,
					loading: "eager",
					decoding: "async",
					width: g,
					height: g,
					sizes: `${g}px`,
					className: Z.cardImage,
					style: {
						borderRadius: g < 90 ? "4px" : "8px",
						zIndex: 1,
						willChange: n === 35 ? "filter" : "auto"
					},
					initial: n === 35 ? { filter: a(d, t.rarity, "0px", "0") } : void 0,
					animate: n === 35 ? { filter: C(d, t.rarity) } : void 0,
					transition: n === 35 ? {
						duration: 300 / 1e3,
						ease: "easeOut",
						delay: te
					} : void 0
				}), M && /* @__PURE__ */ B(ae.div, {
					className: J(Z.itemLabel, n !== 35 && Z.itemLabelHidden),
					initial: l > 1 ? {
						opacity: 0,
						y: -50
					} : void 0,
					animate: n === 35 ? {
						y: [-50, 0],
						opacity: [0, 1]
					} : {},
					transition: {
						type: "keyframes",
						duration: D,
						delay: te
					},
					onAnimationComplete: () => {
						e === l - 1 && n === 35 && p && p();
					},
					children: h ? h(t) : /* @__PURE__ */ B(fd, { item: t })
				})]
			}, `spinner-${e}-item-${n}-${t.itemId ?? t.name}`))
		})
	});
}
//#endregion
//#region src/spinner/useSpinnerWheelItems.ts
function md({ box: e, revealedItems: t, prandGenerator: n, itemWidth: r, gap: i, containerWidth: a, containerHeight: o, selectedOpenQuantity: s, isMobile: c }) {
	let l = L(() => t.slice(0, s).map((t) => oc(e, 35, t, n)), [
		e,
		n,
		t,
		s
	]), u = (e) => l[e] ?? null, d = (e) => {
		switch (e) {
			case 2: return c ? { gap: 56 } : {
				marginLeft: "22%",
				marginRight: "22%"
			};
			case 3: return c ? { gap: 32 } : {
				marginLeft: "15%",
				marginRight: "15%"
			};
			case 4: return c ? { gap: 24 } : {
				marginLeft: "10%",
				marginRight: "10%"
			};
			case 5: return c ? { gap: 20 } : {
				marginLeft: "5%",
				marginRight: "5%"
			};
			default: return {};
		}
	}, f = L(() => {
		let e = [];
		for (let t = 0; t < s; t++) {
			let n = Math.floor(Math.random() * 2) === 0;
			e[t] = r / 4 * Math.random() * (n ? -1 : 1) + r / 4 * (n ? -1 : 1);
		}
		return e;
	}, [r, s]), { startingOffset: p, endingOffset: m } = L(() => {
		let e = c ? a / 2 : (s === 1 ? a : o) / 2, t = r * 4 + i * 3 - r / 2, n = r * 36 + i * 35 - r / 2;
		return {
			startingOffset: e - t,
			endingOffset: e - n
		};
	}, [
		s,
		a,
		o,
		r,
		i,
		c
	]);
	return {
		getBoxItemsByIndex: u,
		getMultiOpenSpacing: d,
		spinSnapOffsets: f,
		startingOffset: p,
		endingOffset: m
	};
}
//#endregion
//#region src/spinner/MotionSpinner.tsx
function hd({ className: e, gap: t = 0, box: n, isQuickReveal: r = !1, revealedItems: i, prandGenerator: a, itemWidth: o, containerWidth: s, containerHeight: c, selectedOpenQuantity: l, isMobile: u, sounds: d, rarityRgb: f, onRevealComplete: p, onItemSettled: m, renderItemLabel: h }) {
	let [g, _] = ne("initialSpin"), v = l === 1 || u, y = R(null), b = R(0), x = L(() => r ? $s / 1e3 : Qs / 1e3, [r]), S = L(() => r ? 150 / 1e3 : 250 / 1e3, [r]), { getBoxItemsByIndex: C, getMultiOpenSpacing: w, spinSnapOffsets: T, startingOffset: E, endingOffset: D } = md({
		box: n,
		revealedItems: i,
		prandGenerator: a,
		itemWidth: o,
		gap: t,
		containerWidth: s,
		containerHeight: c,
		selectedOpenQuantity: l,
		isMobile: u
	}), O = L(() => ({
		itemWidth: o,
		gap: t,
		containerWidth: s,
		containerHeight: c,
		startingOffset: E,
		endingOffset: D,
		spinSnapOffsets: T
	}), [
		o,
		t,
		s,
		c,
		E,
		D,
		T
	]), k = L(() => ({
		animationDuration: x,
		spinStartDelaySec: .25,
		staggerDelay: S,
		popupDuration: 1
	}), [x, S]), A = L(() => ({
		playTickSound: d.playTickSound,
		playRaritySound: d.playRaritySound,
		lastTickTimeRef: b
	}), [d.playTickSound, d.playRaritySound]);
	return /* @__PURE__ */ V("div", {
		className: J(Z.spinner, v ? Z.spinnerRow : Z.spinnerColumn, e),
		children: [C(0) && /* @__PURE__ */ B("div", {
			className: J(Z.laneRow2, u ? Z.laneRowHorizontal : Z.laneRowVertical),
			style: w(l),
			children: Array.from({ length: l }, (e, t) => /* @__PURE__ */ B(pd, {
				index: t,
				getBoxItemsByIndex: C,
				animationPhase: g,
				setAnimationPhase: _,
				isRowOpen: v,
				geometry: O,
				timing: k,
				sounds: A,
				selectedOpenQuantity: l,
				isMobile: u,
				rarityRgb: f,
				selectedItemIndexRef: y,
				onRevealComplete: p,
				onItemSettled: m,
				renderItemLabel: h
			}, `spinner-${t}`))
		}), v ? /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B("div", { className: J(Z.fade, Z.fadeLeft) }), /* @__PURE__ */ B("div", { className: J(Z.fade, Z.fadeRight) })] }) : /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B("div", { className: J(Z.fade, Z.fadeTop) }), /* @__PURE__ */ B("div", { className: J(Z.fade, Z.fadeBottom) })] })]
	});
}
//#endregion
//#region src/spinner/SpinnerPointerRail.tsx
function gd({ orientation: e, color: t, inset: n = 10, className: r }) {
	return e === "vertical" ? /* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: J(Z.railRoot, r),
		children: [/* @__PURE__ */ B(vd, {
			className: J(Z.railSvg, Z.railLeft),
			color: t,
			style: { left: n }
		}), /* @__PURE__ */ B(vd, {
			className: J(Z.railSvg, Z.railRight),
			color: t,
			style: { right: n }
		})]
	}) : /* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: J(Z.railRoot, r),
		children: [/* @__PURE__ */ B(_d, {
			className: J(Z.railSvg, Z.railTop),
			color: t,
			style: { top: n }
		}), /* @__PURE__ */ B(_d, {
			className: J(Z.railSvg, Z.railBottom),
			color: t,
			style: { bottom: n }
		})]
	});
}
function _d({ className: e, color: t, style: n }) {
	let r = yd();
	return /* @__PURE__ */ V("svg", {
		"aria-hidden": "true",
		className: e,
		width: "74",
		height: "14",
		viewBox: "0 0 74 14",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ B("path", {
			d: "M0.00390625 13.3119L30.6914 13.5L36.6914 1.49988L42.7655 13.498M73.5039 13.3124L58.5039 13.3119L42.7655 13.498L36.6914 4.49988L30.6914 13.498",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ B("defs", { children: /* @__PURE__ */ V("linearGradient", {
			id: r,
			x1: "74",
			y1: "7",
			x2: "0",
			y2: "7",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ B("stop", {
					stopColor: t,
					stopOpacity: "0"
				}),
				/* @__PURE__ */ B("stop", {
					offset: "0.5",
					stopColor: t
				}),
				/* @__PURE__ */ B("stop", {
					offset: "1",
					stopColor: t,
					stopOpacity: "0"
				})
			]
		}) })]
	});
}
function vd({ className: e, color: t, style: n }) {
	let r = yd();
	return /* @__PURE__ */ V("svg", {
		"aria-hidden": "true",
		className: e,
		width: "14",
		height: "74",
		viewBox: "0 0 14 74",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		style: n,
		children: [/* @__PURE__ */ B("path", {
			d: "M0.688111 0.00390625L0.5 30.6914L12.5001 36.6914L0.501953 42.7655M0.687616 73.5039L0.688111 58.5039L0.501953 42.7655L9.50012 36.6914L0.501953 30.6914",
			stroke: `url(#${r})`
		}), /* @__PURE__ */ B("defs", { children: /* @__PURE__ */ V("linearGradient", {
			id: r,
			x1: "7",
			y1: "0",
			x2: "7",
			y2: "74",
			gradientUnits: "userSpaceOnUse",
			children: [
				/* @__PURE__ */ B("stop", {
					stopColor: t,
					stopOpacity: "0"
				}),
				/* @__PURE__ */ B("stop", {
					offset: "0.5",
					stopColor: t
				}),
				/* @__PURE__ */ B("stop", {
					offset: "1",
					stopColor: t,
					stopOpacity: "0"
				})
			]
		}) })]
	});
}
function yd() {
	return `los-spinner-rail-${F().replace(/:/g, "")}`;
}
//#endregion
//#region src/spinner/SpinnerOpener.tsx
var bd = 768;
function xd(e) {
	switch (e) {
		case 1: return 220;
		case 2: return 160;
		case 3: return 115;
		case 4: return 80;
		case 5: return 72;
		default: return 150;
	}
}
function Sd(e) {
	switch (e) {
		case 1: return 32;
		case 2: return 24;
		case 3: return 16;
		case 4: return 12;
		case 5: return 6;
		default: return 32;
	}
}
function Cd({ boxData: e, entries: t, quantity: n, isQuickReveal: r, prandGenerator: i, onRevealComplete: a }) {
	let { theme: o, sounds: u, renderItemLabel: d } = l(), f = R(null), p = R(null), [m, h] = ne(null), [g, _] = ne(0), [v, y] = ne(0);
	I(() => {
		let e = f.current;
		if (!e) return;
		let t = () => h(e.offsetWidth);
		if (t(), typeof ResizeObserver > "u") return;
		let n = new ResizeObserver(t);
		return n.observe(e), () => n.disconnect();
	}, []);
	let b = m === null ? null : m < bd;
	I(() => {
		let e = p.current;
		if (!e) return;
		let t = () => {
			_(e.offsetWidth), y(e.offsetHeight);
		};
		if (t(), typeof ResizeObserver > "u") return;
		let n = new ResizeObserver(t);
		return n.observe(e), () => n.disconnect();
	}, [b]);
	let x = L(() => t.map((e) => e.item), [t]), S = L(() => t.length ? Math.max(...t.map((t) => c(t.item.value, e.priceCents ?? 0))) : null, [t, e.priceCents]), [C, w] = ne(!1);
	P(() => {
		w(!1);
	}, [t]);
	let T = M((e) => {
		S !== null && e >= S && w(!0);
	}, [S]), D = C && S !== null ? E(o.railHex, S) : E(o.railHex, null), O = L(() => ({
		priceCents: e.priceCents,
		dropTable: e.dropTable
	}), [e.priceCents, e.dropTable]), k = e.opener?.logoSvg, A = e.opener?.brandName?.trim(), j = L(() => k ? /* @__PURE__ */ B("img", {
		className: Z.brandMark,
		src: s(k),
		alt: "",
		"aria-hidden": "true"
	}) : A ? /* @__PURE__ */ B("span", {
		className: Z.brandName,
		"aria-hidden": "true",
		children: A
	}) : null, [k, A]);
	return /* @__PURE__ */ B("div", {
		className: Z.opener,
		ref: f,
		children: b === null ? null : b ? /* @__PURE__ */ B("div", {
			className: J(Z.band, Z.bandMobile),
			children: /* @__PURE__ */ V("div", {
				className: Z.stage,
				children: [
					j,
					/* @__PURE__ */ B("div", {
						className: Z.railLayer,
						children: /* @__PURE__ */ B(gd, {
							orientation: "horizontal",
							color: D,
							inset: -4
						})
					}),
					/* @__PURE__ */ B("div", {
						className: Z.wheelArea,
						ref: p,
						children: /* @__PURE__ */ B(hd, {
							gap: Sd(n),
							box: O,
							revealedItems: x,
							isQuickReveal: r,
							prandGenerator: i,
							itemWidth: xd(n),
							containerWidth: g,
							containerHeight: v,
							selectedOpenQuantity: n,
							isMobile: !0,
							sounds: u,
							rarityRgb: o.rarityRgb,
							onRevealComplete: a,
							onItemSettled: T,
							renderItemLabel: d
						})
					})
				]
			})
		}) : /* @__PURE__ */ B("div", {
			className: J(Z.band, Z.bandDesktop),
			children: /* @__PURE__ */ V("div", {
				className: Z.stage,
				children: [
					j,
					/* @__PURE__ */ B("div", {
						className: Z.railLayer,
						children: /* @__PURE__ */ B(gd, {
							orientation: n === 1 ? "horizontal" : "vertical",
							color: D
						})
					}),
					/* @__PURE__ */ B("div", {
						className: Z.wheelArea,
						ref: p,
						children: /* @__PURE__ */ B(hd, {
							gap: n > 1 ? 56 : 32,
							box: O,
							revealedItems: x,
							isQuickReveal: r,
							prandGenerator: i,
							itemWidth: 190,
							containerWidth: g,
							containerHeight: v,
							selectedOpenQuantity: n,
							isMobile: !1,
							sounds: u,
							rarityRgb: o.rarityRgb,
							onRevealComplete: a,
							onItemSettled: T,
							renderItemLabel: d
						})
					})
				]
			})
		})
	});
}
//#endregion
//#region src/openers/SpinnerRevealOpener.tsx
function wd({ boxData: e, reveal: t, onRevealComplete: n }) {
	return /* @__PURE__ */ B(Cd, {
		boxData: e,
		entries: t.entries,
		quantity: t.quantity,
		isQuickReveal: t.isQuickReveal,
		prandGenerator: t.prandGenerator,
		onRevealComplete: n
	});
}
//#endregion
//#region src/openers/registry.ts
var Td = { spinner: O({
	Opener: wd,
	loopTarget: "loop",
	supportsBulk: !0,
	bulkLimit: 36,
	revealLimit: 5,
	revealExit: { lingerMs: ic }
}) }, Ed = "spinner";
function Dd(e) {
	if (e) {
		let t = k(e) ?? (Object.hasOwn(Td, e) ? Td[e] : void 0);
		if (t) return t;
	}
	return Td[Ed];
}
//#endregion
//#region src/react/hooks.ts
function Od({ client: e, boxId: t }) {
	let n = de({
		queryKey: [
			"loot-os",
			"box",
			Zu(e),
			t
		],
		queryFn: () => {
			if (!e) throw Error("[loot-os] no API client configured");
			return e.getBox(t);
		},
		enabled: !!e
	}, Ju()), { refetch: r } = n, i = M(() => void r(), [r]);
	return {
		box: n.data ?? null,
		loading: !!e && n.isFetching,
		error: n.isFetching ? null : n.error ?? null,
		reload: i
	};
}
function kd({ client: e, boxId: t, clientSeed: n, expectedVersion: r }) {
	let i = ue({
		mutationKey: [
			"loot-os",
			"open",
			Zu(e),
			t
		],
		mutationFn: (i) => {
			if (!e) throw Error("[loot-os] no API client configured");
			return e.openBox({
				boxId: t,
				clientSeed: n,
				amount: i.quantity,
				expectedVersion: r,
				idempotencyKey: i.idempotencyKey
			});
		}
	}, Ju()), { mutateAsync: a } = i;
	return {
		open: M(async (t = 1) => {
			if (!e) return null;
			try {
				return await a({
					quantity: t,
					idempotencyKey: Qu()
				});
			} catch {
				return null;
			}
		}, [e, a]),
		opening: i.isPending,
		response: i.data ?? null,
		error: i.error ?? null
	};
}
//#endregion
//#region src/react/useOpenerMachine.ts
function Ad(e) {
	return re(e.subscribe, e.getState, e.getState);
}
function jd(e) {
	let t = R(e);
	t.current = e;
	let n = R(null);
	n.current === null && (n.current = () => Bu({
		openBox: (e) => t.current.openBox(e),
		claimReveal: e.claimReveal ? (e) => {
			let n = t.current.claimReveal;
			if (!n) throw Error("[loot-os] claimReveal config removed mid-flight");
			return n(e);
		} : void 0,
		sellBackReveal: e.sellBackReveal ? (e) => {
			let n = t.current.sellBackReveal;
			if (!n) throw Error("[loot-os] sellBackReveal config removed mid-flight");
			return n(e);
		} : void 0,
		onBeforeOpen: (e) => t.current.onBeforeOpen?.(e),
		onEvent: (e) => t.current.onEvent?.(e),
		settlesOnReveal: (e) => t.current.settlesOnReveal?.(e) ?? !1,
		revealStartDelayMs: e.revealStartDelayMs,
		minQuantity: e.minQuantity,
		maxQuantity: e.maxQuantity,
		defaultQuantity: e.defaultQuantity,
		defaultQuickReveal: e.defaultQuickReveal
	}));
	let r = n.current, [i, a] = ne(r);
	return P(() => {
		if (i.isDisposed()) {
			a(r());
			return;
		}
		return () => i.dispose();
	}, [i, r]), {
		machine: i,
		state: Ad(i)
	};
}
//#endregion
//#region src/react/useResolvedClient.ts
var Md = async (e) => {
	let { LootClient: t } = await import("@loot-os/client");
	return new t(e);
};
function Nd({ client: e, createClient: t, publishableKey: n, baseUrl: r, sessionToken: i, onSessionExpired: a }) {
	let [o, s] = ne(null), [c, l] = ne(null), u = R(a), d = R(0);
	I(() => {
		d.current += 1;
	}, [
		e,
		t,
		n,
		r
	]), I(() => {
		u.current = a;
	}, [a]), P(() => {
		let i = d.current, a = () => i === d.current;
		if (s(null), l(null), e || !n) return;
		let o = t ?? Md;
		Promise.resolve(o({
			publishableKey: n,
			baseUrl: r,
			sessionToken: null,
			onSessionExpired: async () => {
				if (!a() || !u.current) return null;
				let e = await u.current();
				return a() ? e : null;
			}
		})).then((e) => {
			a() && s({
				instance: e,
				buildId: i,
				createClient: t,
				publishableKey: n,
				baseUrl: r
			});
		}).catch((e) => {
			a() && l(e);
		});
	}, [
		e,
		t,
		n,
		r
	]);
	let f = o && o.buildId === d.current && o.createClient === t && o.publishableKey === n && o.baseUrl === r ? o.instance : null, p = e ?? f;
	return P(() => {
		p?.setSessionToken?.(i ?? null);
	}, [p, i]), {
		client: p,
		error: c
	};
}
var Pd = {
	scroller: "_scroller_ujyfz_3",
	track: "_track_ujyfz_13",
	trackAnimated: "_trackAnimated_ujyfz_19",
	losIdleCardScroll: "_losIdleCardScroll_ujyfz_1",
	loop: "_loop_ujyfz_24",
	slot: "_slot_ujyfz_31",
	floatY: "_floatY_ujyfz_37",
	losFloatY: "_losFloatY_ujyfz_1",
	floatYDelay1: "_floatYDelay1_ujyfz_41",
	floatYSmall: "_floatYSmall_ujyfz_45",
	losFloatYSmall: "_losFloatYSmall_ujyfz_1",
	floatYSmallDelay1: "_floatYSmallDelay1_ujyfz_49",
	fadeLeft: "_fadeLeft_ujyfz_53",
	fadeRight: "_fadeRight_ujyfz_70"
}, Fd = 12;
function Id(e, t) {
	let n = e % 2 == 1;
	return t ? n ? Pd.floatYSmallDelay1 ?? "" : Pd.floatYSmall ?? "" : n ? Pd.floatYDelay1 ?? "" : Pd.floatY ?? "";
}
function Ld({ slots: e, itemWidth: t, gap: n = 0, isMobile: r = !1, direction: i = "left", className: a }) {
	let o = L(() => {
		if (e.length === 0) return 0;
		let t = Math.max(2, Math.ceil(Fd / e.length));
		return t % 2 == 0 ? t : t + 1;
	}, [e.length]), s = e.length * (t + n), c = Math.max(1.5, e.length * (r ? 2.5 : 8));
	return /* @__PURE__ */ V("div", {
		"aria-hidden": !0,
		className: J(Pd.scroller, a),
		children: [
			/* @__PURE__ */ B("div", {
				className: J(Pd.track, e.length > 0 && Pd.trackAnimated),
				style: {
					gap: `${n}px`,
					"--los-idle-scroll-distance": `-${s}px`,
					"--los-idle-scroll-duration": `${c}s`,
					animationDirection: i === "left" ? "normal" : "reverse"
				},
				children: Array.from({ length: o }, (i, a) => /* @__PURE__ */ B("div", {
					className: Pd.loop,
					style: { gap: `${n}px` },
					children: e.map((e, n) => /* @__PURE__ */ B("div", {
						className: J(Pd.slot, Id(n, r)),
						style: {
							width: `${t}px`,
							height: `${t}px`
						},
						children: e
					}, `loop-${a}-${n}`))
				}, a))
			}),
			/* @__PURE__ */ B("div", { className: Pd.fadeLeft }),
			/* @__PURE__ */ B("div", { className: Pd.fadeRight })
		]
	});
}
var Rd = te(Ld), Q = {
	root: "_root_dj4df_5",
	phase: "_phase_dj4df_46",
	losPhaseFadeIn: "_losPhaseFadeIn_dj4df_1",
	hostIdle: "_hostIdle_dj4df_73",
	hostControls: "_hostControls_dj4df_86",
	idleHero: "_idleHero_dj4df_93",
	brandLogo: "_brandLogo_dj4df_101",
	brandName: "_brandName_dj4df_107",
	boxImage: "_boxImage_dj4df_118",
	boxName: "_boxName_dj4df_125",
	boxPrice: "_boxPrice_dj4df_132",
	idleScrollerArea: "_idleScrollerArea_dj4df_138",
	idleCard: "_idleCard_dj4df_146",
	idleCardImage: "_idleCardImage_dj4df_155",
	controls: "_controls_dj4df_164",
	controlsRow: "_controlsRow_dj4df_173",
	quantityGroup: "_quantityGroup_dj4df_182",
	quantityButton: "_quantityButton_dj4df_194",
	quantityButtonActive: "_quantityButtonActive_dj4df_210",
	primaryButton: "_primaryButton_dj4df_215",
	secondaryButton: "_secondaryButton_dj4df_244",
	toggleLabel: "_toggleLabel_dj4df_265",
	priceTag: "_priceTag_dj4df_274",
	revealArea: "_revealArea_dj4df_281",
	revealStage: "_revealStage_dj4df_290",
	demoAnchor: "_demoAnchor_dj4df_300",
	demoBadge: "_demoBadge_dj4df_305",
	errorBanner: "_errorBanner_dj4df_327",
	loading: "_loading_dj4df_338",
	fairnessArea: "_fairnessArea_dj4df_347",
	openerLoading: "_openerLoading_dj4df_373",
	stageOwned: "_stageOwned_dj4df_386"
};
//#endregion
//#region src/shell/DemoTag.tsx
function zd({ demo: e, children: t }) {
	let { strings: n } = l();
	return e ? /* @__PURE__ */ V("span", {
		className: Q.demoAnchor,
		children: [t, /* @__PURE__ */ B("span", {
			className: Q.demoBadge,
			children: n.demoBadge
		})]
	}) : /* @__PURE__ */ B(z, { children: t });
}
//#endregion
//#region ../icons/src/icons/audio-off.ts
var Bd = {
	id: "audio-off",
	name: "Audio Off",
	category: "media",
	styles: {
		rounded: { svg: "<path d=\"M16.77 19.57Q16.49 19.74 16.22 19.9T15.65 20.18Q15.27 20.35 14.89 20.18T14.35 19.61Q14.2 19.23 14.39 18.87T14.95 18.33Q15.05 18.28 15.14 18.23T15.33 18.13L12 14.8V17.57Q12 18.25 11.39 18.51T10.3 18.3L7 15H4Q3.58 15 3.29 14.71T3 14V10Q3 9.58 3.29 9.29T4 9H6.2L2.1 4.9Q1.82 4.62 1.82 4.2T2.1 3.5 2.8 3.22 3.5 3.5L20.5 20.5Q20.78 20.78 20.78 21.2T20.5 21.9 19.8 22.18 19.1 21.9ZM19 11.97Q19 9.89 17.9 8.18T14.95 5.62Q14.57 5.45 14.4 5.08T14.35 4.34Q14.5 3.94 14.89 3.77T15.68 3.77Q18.1 4.85 19.55 7.05T21 11.97Q21 12.79 20.85 13.61T20.43 15.17Q20.23 15.72 19.82 15.86T19.06 15.87 18.5 15.42 18.49 14.67Q18.77 14.02 18.89 13.36T19 11.97M14.78 8.42Q15.6 8.95 16.05 10T16.5 12V12.25Q16.5 12.37 16.47 12.5 16.42 12.83 16.12 12.92T15.57 12.77L14.3 11.5Q14.15 11.35 14.07 11.16T14 10.78V8.85Q14 8.55 14.26 8.41T14.77 8.42M9.75 6.95Q9.6 6.8 9.6 6.6T9.75 6.25L10.3 5.7Q10.77 5.23 11.39 5.49T12 6.43V8Q12 8.35 11.7 8.47T11.15 8.35Z\"/>" },
		sharp: { svg: "<path d=\"M19.8 22.6L16.78 19.58Q16.16 19.98 15.46 20.27T14.01 20.73V18.68Q14.36 18.56 14.7 18.43T15.34 18.13L12 14.8V20L7 15H3V9H6.2L1.4 4.2 2.8 2.8 21.2 21.2ZM19.6 16.8L18.15 15.35Q18.57 14.57 18.79 13.73T19 11.98Q19 9.63 17.62 7.78T14 5.28V3.23Q17.1 3.93 19.05 6.37T21 11.97Q21 13.29 20.64 14.52T19.6 16.8M16.25 13.45L14 11.2V7.95Q15.18 8.5 15.84 9.6T16.5 12Q16.5 12.38 16.44 12.74T16.25 13.45M12 9.2L9.4 6.6 12 4Z\"/>" },
		outline: { svg: "<path d=\"M16.77 19.57Q16.49 19.74 16.22 19.9T15.65 20.18Q15.27 20.35 14.89 20.18T14.35 19.61Q14.2 19.23 14.39 18.87T14.95 18.33Q15.05 18.28 15.14 18.23T15.33 18.13L12 14.8V17.57Q12 18.25 11.39 18.51T10.3 18.3L7 15H4Q3.58 15 3.29 14.71T3 14V10Q3 9.58 3.29 9.29T4 9H6.2L2.1 4.9Q1.82 4.62 1.82 4.2T2.1 3.5 2.8 3.22 3.5 3.5L20.5 20.5Q20.78 20.78 20.78 21.2T20.5 21.9 19.8 22.18 19.1 21.9ZM19 11.97Q19 9.89 17.9 8.18T14.95 5.62Q14.57 5.45 14.4 5.08T14.35 4.34Q14.5 3.94 14.89 3.77T15.68 3.77Q18.1 4.85 19.55 7.05T21 11.97Q21 12.79 20.85 13.61T20.43 15.17Q20.23 15.72 19.82 15.86T19.06 15.87 18.5 15.42 18.49 14.67Q18.77 14.02 18.89 13.36T19 11.97M14.78 8.42Q15.6 8.95 16.05 10T16.5 12V12.25Q16.5 12.37 16.47 12.5 16.42 12.83 16.12 12.92T15.57 12.77L14.3 11.5Q14.15 11.35 14.07 11.16T14 10.78V8.85Q14 8.55 14.26 8.41T14.77 8.42M9.75 6.95Q9.6 6.8 9.6 6.6T9.75 6.25L10.3 5.7Q10.77 5.23 11.39 5.49T12 6.43V8Q12 8.35 11.7 8.47T11.15 8.35ZM10 15.15V12.8L8.2 11H5V13H7.85ZM9.1 11.9\"/>" },
		duotone: { svg: "<g opacity=\".32\"><path d=\"M16.77 19.57Q16.49 19.74 16.22 19.9T15.65 20.18Q15.27 20.35 14.89 20.18T14.35 19.61Q14.2 19.23 14.39 18.87T14.95 18.33Q15.05 18.28 15.14 18.23T15.33 18.13L12 14.8V17.57Q12 18.25 11.39 18.51T10.3 18.3L7 15H4Q3.58 15 3.29 14.71T3 14V10Q3 9.58 3.29 9.29T4 9H6.2L2.1 4.9Q1.82 4.62 1.82 4.2T2.1 3.5 2.8 3.22 3.5 3.5L20.5 20.5Q20.78 20.78 20.78 21.2T20.5 21.9 19.8 22.18 19.1 21.9ZM19 11.97Q19 9.89 17.9 8.18T14.95 5.62Q14.57 5.45 14.4 5.08T14.35 4.34Q14.5 3.94 14.89 3.77T15.68 3.77Q18.1 4.85 19.55 7.05T21 11.97Q21 12.79 20.85 13.61T20.43 15.17Q20.23 15.72 19.82 15.86T19.06 15.87 18.5 15.42 18.49 14.67Q18.77 14.02 18.89 13.36T19 11.97M14.78 8.42Q15.6 8.95 16.05 10T16.5 12V12.25Q16.5 12.37 16.47 12.5 16.42 12.83 16.12 12.92T15.57 12.77L14.3 11.5Q14.15 11.35 14.07 11.16T14 10.78V8.85Q14 8.55 14.26 8.41T14.77 8.42M9.75 6.95Q9.6 6.8 9.6 6.6T9.75 6.25L10.3 5.7Q10.77 5.23 11.39 5.49T12 6.43V8Q12 8.35 11.7 8.47T11.15 8.35Z\"/></g><path d=\"M16.77 19.57Q16.49 19.74 16.22 19.9T15.65 20.18Q15.27 20.35 14.89 20.18T14.35 19.61Q14.2 19.23 14.39 18.87T14.95 18.33Q15.05 18.28 15.14 18.23T15.33 18.13L12 14.8V17.57Q12 18.25 11.39 18.51T10.3 18.3L7 15H4Q3.58 15 3.29 14.71T3 14V10Q3 9.58 3.29 9.29T4 9H6.2L2.1 4.9Q1.82 4.62 1.82 4.2T2.1 3.5 2.8 3.22 3.5 3.5L20.5 20.5Q20.78 20.78 20.78 21.2T20.5 21.9 19.8 22.18 19.1 21.9ZM19 11.97Q19 9.89 17.9 8.18T14.95 5.62Q14.57 5.45 14.4 5.08T14.35 4.34Q14.5 3.94 14.89 3.77T15.68 3.77Q18.1 4.85 19.55 7.05T21 11.97Q21 12.79 20.85 13.61T20.43 15.17Q20.23 15.72 19.82 15.86T19.06 15.87 18.5 15.42 18.49 14.67Q18.77 14.02 18.89 13.36T19 11.97M14.78 8.42Q15.6 8.95 16.05 10T16.5 12V12.25Q16.5 12.37 16.47 12.5 16.42 12.83 16.12 12.92T15.57 12.77L14.3 11.5Q14.15 11.35 14.07 11.16T14 10.78V8.85Q14 8.55 14.26 8.41T14.77 8.42M9.75 6.95Q9.6 6.8 9.6 6.6T9.75 6.25L10.3 5.7Q10.77 5.23 11.39 5.49T12 6.43V8Q12 8.35 11.7 8.47T11.15 8.35ZM10 15.15V12.8L8.2 11H5V13H7.85ZM9.1 11.9\"/>" }
	},
	animation: () => Promise.reject(/* @__PURE__ */ Error("icon animations are not bundled"))
}, Vd = {
	id: "audio-on",
	name: "Audio On",
	category: "media",
	styles: {
		rounded: { svg: "<path d=\"M19 11.97Q19 9.89 17.9 8.18T14.95 5.62Q14.57 5.45 14.4 5.08T14.35 4.34Q14.5 3.94 14.89 3.77T15.68 3.77Q18.1 4.85 19.55 7.06T21 11.97 19.55 16.88 15.67 20.17Q15.27 20.34 14.88 20.17T14.34 19.6Q14.22 19.22 14.39 18.86T14.94 18.32Q16.79 17.47 17.89 15.76T18.99 11.97M7 15H4Q3.58 15 3.29 14.71T3 14V10Q3 9.58 3.29 9.29T4 9H7L10.3 5.7Q10.77 5.23 11.39 5.49T12 6.43V17.58Q12 18.26 11.39 18.52T10.3 18.3ZM16.5 12Q16.5 13.05 16.03 13.99T14.78 15.53Q14.53 15.68 14.27 15.54T14 15.1V8.85Q14 8.55 14.26 8.41T14.77 8.42Q15.55 9.04 16.02 9.99T16.49 11.99\"/>" },
		sharp: { svg: "<path d=\"M14 20.73V18.68Q16.25 18.03 17.62 16.18T19 11.98 17.62 7.78 14 5.28V3.23Q17.1 3.93 19.05 6.37T21 11.97 19.05 17.58 14 20.73M3 15V9H7L12 4V20L7 15ZM14 16V7.95Q15.18 8.5 15.84 9.6T16.5 12Q16.5 13.27 15.84 14.36T14 16\"/>" },
		outline: { svg: "<path d=\"M19 11.97Q19 9.89 17.9 8.18T14.95 5.62Q14.57 5.45 14.4 5.08T14.35 4.34Q14.5 3.94 14.89 3.77T15.68 3.77Q18.1 4.85 19.55 7.06T21 11.97 19.55 16.88 15.67 20.17Q15.27 20.34 14.88 20.17T14.34 19.6Q14.22 19.22 14.39 18.86T14.94 18.32Q16.79 17.47 17.89 15.76T18.99 11.97M7 15H4Q3.58 15 3.29 14.71T3 14V10Q3 9.58 3.29 9.29T4 9H7L10.3 5.7Q10.77 5.23 11.39 5.49T12 6.43V17.58Q12 18.26 11.39 18.52T10.3 18.3ZM16.5 12Q16.5 13.05 16.03 13.99T14.78 15.53Q14.53 15.68 14.27 15.54T14 15.1V8.85Q14 8.55 14.26 8.41T14.77 8.42Q15.55 9.04 16.02 9.99T16.49 11.99M10 8.85L7.85 11H5V13H7.85L10 15.15ZM7.5 12\"/>" },
		duotone: { svg: "<g opacity=\".32\"><path d=\"M15.68 3.77L16.83 4.38 17.86 5.13 18.76 6.03 19.55 7.06 20.18 8.2 20.64 9.39 20.91 10.65 21 11.97 20.91 13.29 20.64 14.55 20.18 15.74 19.55 16.88 18.76 17.91 17.86 18.81 16.82 19.56 15.67 20.17 15.27 20.25 14.88 20.17 14.55 19.94 14.34 19.6 14.29 19.23 14.39 18.86 14.61 18.55 15.82 17.84 16.6 17.25 17.29 16.56 17.89 15.76 18.37 14.88 18.71 13.96 18.92 12.99 19 11.97 18.93 10.95 18.73 9.98 18.38 9.06 17.9 8.18 17.3 7.38 16.61 6.68 15.83 6.1 14.62 5.4 14.4 5.08 14.3 4.71 14.35 4.34 14.56 4 14.89 3.77 15.28 3.69ZM11.39 5.49L11.85 5.86 12 6.43V17.58L11.85 18.16 11.39 18.52 10.81 18.59 10.3 18.3 7 15H4L3.61 14.93 3.29 14.71 3.07 14.39 3 14V10L3.07 9.61 3.29 9.29 3.61 9.07 4 9H7L10.3 5.7 10.81 5.41ZM14.77 8.42L15.47 9.12 16.02 9.99 16.37 10.96 16.5 12 16.38 13.02 16.03 13.99 15.48 14.85 14.78 15.53 14.53 15.61 14.27 15.54 14.07 15.36 14 15.1V8.85L14.06 8.59 14.26 8.41 14.52 8.34Z\"/></g><path d=\"M19 11.97Q19 9.89 17.9 8.18T14.95 5.62Q14.57 5.45 14.4 5.08T14.35 4.34Q14.5 3.94 14.89 3.77T15.68 3.77Q18.1 4.85 19.55 7.06T21 11.97 19.55 16.88 15.67 20.17Q15.27 20.34 14.88 20.17T14.34 19.6Q14.22 19.22 14.39 18.86T14.94 18.32Q16.79 17.47 17.89 15.76T18.99 11.97M7 15H4Q3.58 15 3.29 14.71T3 14V10Q3 9.58 3.29 9.29T4 9H7L10.3 5.7Q10.77 5.23 11.39 5.49T12 6.43V17.58Q12 18.26 11.39 18.52T10.3 18.3ZM16.5 12Q16.5 13.05 16.03 13.99T14.78 15.53Q14.53 15.68 14.27 15.54T14 15.1V8.85Q14 8.55 14.26 8.41T14.77 8.42Q15.55 9.04 16.02 9.99T16.49 11.99M10 8.85L7.85 11H5V13H7.85L10 15.15ZM7.5 12\"/>" }
	},
	animation: () => Promise.reject(/* @__PURE__ */ Error("icon animations are not bundled"))
}, Hd = { toggle: "_toggle_bio0t_1" };
//#endregion
//#region src/shell/useSoundToggle.ts
function Ud() {
	let { sounds: e, strings: t, onSoundMutedChange: n } = l(), { muted: r } = y(e);
	return !n || !e.configured ? null : {
		label: t.muteSounds,
		muted: r,
		setMuted: n
	};
}
//#endregion
//#region src/shell/SoundToggle.tsx
function Wd({ muted: e }) {
	let t = (e ? Bd : Vd).styles.rounded.svg;
	return /* @__PURE__ */ B("svg", {
		"aria-hidden": "true",
		width: "20",
		height: "20",
		viewBox: "0 0 24 24",
		fill: "currentColor",
		xmlns: "http://www.w3.org/2000/svg",
		dangerouslySetInnerHTML: { __html: t }
	});
}
function Gd() {
	let e = Ud();
	return e ? /* @__PURE__ */ B("button", {
		type: "button",
		className: Hd.toggle,
		"aria-pressed": e.muted,
		"aria-label": e.label,
		onClick: () => e.setMuted(!e.muted),
		children: /* @__PURE__ */ B(Wd, { muted: e.muted })
	}) : null;
}
var Kd = {
	results: "_results_1ypk9_1",
	grid: "_grid_1ypk9_10",
	item: "_item_1ypk9_19",
	itemImage: "_itemImage_1ypk9_32",
	itemName: "_itemName_1ypk9_39",
	itemValue: "_itemValue_1ypk9_51",
	total: "_total_1ypk9_57",
	totalValue: "_totalValue_1ypk9_62",
	claimError: "_claimError_1ypk9_67",
	actions: "_actions_1ypk9_73",
	autoClaimLabel: "_autoClaimLabel_1ypk9_81",
	itemImageWrap: "_itemImageWrap_1ypk9_90",
	itemImageSubstitute: "_itemImageSubstitute_1ypk9_97",
	substituteBadge: "_substituteBadge_1ypk9_101",
	itemNotice: "_itemNotice_1ypk9_117",
	itemActions: "_itemActions_1ypk9_125",
	itemButton: "_itemButton_1ypk9_133",
	itemStatus: "_itemStatus_1ypk9_152"
};
//#endregion
//#region src/results/ResultsItemCard.tsx
function qd({ entry: e, claimed: t, action: n, onWithdraw: r, buttonClassName: i }) {
	let { strings: a } = l();
	return n?.status === "withdrawn" ? /* @__PURE__ */ B("p", {
		className: Kd.itemStatus,
		children: a.withdrawRequested
	}) : !r || e.item.isGemSubstitute === !0 ? null : /* @__PURE__ */ B("button", {
		type: "button",
		className: i,
		onClick: () => r(t),
		children: a.withdrawItem
	});
}
function Jd({ entry: e, claimed: t, action: n, onWithdraw: r }) {
	let { strings: i } = l();
	return n?.status === "withdrawn" ? null : e.item.isGemSubstitute !== !0 && t.isLimited && r ? /* @__PURE__ */ B("p", {
		className: Kd.itemNotice,
		children: i.limitedItemNotice
	}) : null;
}
function Yd(e) {
	let { strings: t } = l(), { entry: n, claimed: r, action: i, onWithdraw: a } = e;
	if (i?.status === "withdrawn") return /* @__PURE__ */ B(qd, { ...e });
	let o = n.item.isGemSubstitute === !0;
	return !a || o ? null : /* @__PURE__ */ V(z, { children: [r.isLimited ? /* @__PURE__ */ B("p", {
		className: Kd.itemNotice,
		children: t.limitedItemNotice
	}) : null, /* @__PURE__ */ B("div", {
		className: Kd.itemActions,
		children: /* @__PURE__ */ B(qd, {
			...e,
			buttonClassName: Kd.itemButton
		})
	})] });
}
function Xd({ entry: e, claimed: t, action: r, onWithdraw: i }) {
	let { strings: a, currency: o } = l(), s = e.item.isGemSubstitute === !0;
	return /* @__PURE__ */ V("div", {
		className: Kd.item,
		children: [
			/* @__PURE__ */ V("div", {
				className: Kd.itemImageWrap,
				children: [/* @__PURE__ */ B("img", {
					className: J(Kd.itemImage, s && Kd.itemImageSubstitute),
					src: e.item.imageUrl,
					alt: e.item.name,
					loading: "eager",
					decoding: "async"
				}), s ? /* @__PURE__ */ B("span", {
					className: Kd.substituteBadge,
					children: a.substituteBadge
				}) : null]
			}),
			/* @__PURE__ */ B("p", {
				className: Kd.itemName,
				children: e.item.name
			}),
			/* @__PURE__ */ B("span", {
				className: Kd.itemValue,
				children: n(e.item.value, o, { compact: !0 })
			}),
			t ? /* @__PURE__ */ B(Yd, {
				entry: e,
				claimed: t,
				action: r,
				onWithdraw: i
			}) : null
		]
	});
}
//#endregion
//#region src/results/ResultsView.tsx
function Zd({ entries: e, claimStatus: t = "none", claimCostCents: r, claimErrorMessage: i, sellErrorMessage: a, onClaim: o, onSellBack: s, onAutoClaimChange: c, onOpenAgain: u, settledAction: d, claimedItems: f, itemActions: p, onWithdrawItem: m, buttonClassName: h, secondaryButtonClassName: g, showItems: _ = !0, demo: v = !1, showActions: y = !0 }) {
	let { strings: b, currency: x } = l(), S = L(() => [...e].sort((e, t) => t.item.value - e.item.value), [e]), C = L(() => new Map((f ?? []).map((e) => [e.openId, e])), [f]), w = L(() => S.flatMap((e) => {
		let t = C.get(e.openId);
		return t ? [{
			entry: e,
			claimed: t,
			action: p?.[t.inventoryItemId]
		}] : [];
	}), [
		S,
		C,
		p
	]), T = L(() => e.reduce((e, t) => e + t.item.value, 0), [e]), E = t === "unclaimed" || t === "claiming" || t === "selling", D = t === "claiming" || t === "selling", O = !!s && T > 0, k = i ?? a ?? null;
	return /* @__PURE__ */ V("div", {
		className: Kd.results,
		children: [
			_ ? /* @__PURE__ */ B("div", {
				className: Kd.grid,
				children: S.map((e) => {
					let t = C.get(e.openId);
					return /* @__PURE__ */ B(Xd, {
						entry: e,
						claimed: t,
						action: t ? p?.[t.inventoryItemId] : void 0,
						onWithdraw: m
					}, e.openId);
				})
			}) : null,
			e.length > 1 && /* @__PURE__ */ V("div", {
				className: Kd.total,
				children: [
					b.totalValue,
					":",
					" ",
					/* @__PURE__ */ B("span", {
						className: Kd.totalValue,
						children: n(T, x)
					})
				]
			}),
			y && k ? /* @__PURE__ */ B("div", {
				className: Kd.claimError,
				children: k
			}) : null,
			y ? E ? /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ V("div", {
				className: Kd.actions,
				children: [
					/* @__PURE__ */ V("button", {
						type: "button",
						className: h,
						disabled: D,
						onClick: o,
						children: [t === "claiming" ? b.claiming : b.claim, r != null && t !== "claiming" ? /* @__PURE__ */ V(z, { children: [" ", n(r, x)] }) : null]
					}),
					O ? /* @__PURE__ */ V("button", {
						type: "button",
						className: g,
						disabled: D,
						onClick: s,
						children: [t === "selling" ? b.sellingBack : b.sellBack, t === "selling" ? null : /* @__PURE__ */ V(z, { children: [" ", n(T, x)] })]
					}) : null,
					/* @__PURE__ */ B(Gd, {})
				]
			}), c ? /* @__PURE__ */ V("label", {
				className: Kd.autoClaimLabel,
				children: [/* @__PURE__ */ B("input", {
					type: "checkbox",
					defaultChecked: !1,
					onChange: (e) => c(e.target.checked)
				}), b.autoClaimLabel]
			}) : null] }) : /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ V("div", {
				className: Kd.actions,
				children: [
					_ ? null : w.map(({ entry: e, claimed: t, action: n }) => /* @__PURE__ */ B(qd, {
						entry: e,
						claimed: t,
						action: n,
						onWithdraw: m,
						buttonClassName: g
					}, e.openId)),
					/* @__PURE__ */ B(zd, {
						demo: v,
						children: /* @__PURE__ */ B("button", {
							type: "button",
							className: h,
							onClick: d?.onClick ?? u,
							children: d?.label ?? b.openAgain
						})
					}),
					/* @__PURE__ */ B(Gd, {})
				]
			}), _ ? null : w.map(({ entry: e, claimed: t, action: n }) => /* @__PURE__ */ B(Jd, {
				entry: e,
				claimed: t,
				action: n,
				onWithdraw: m
			}, e.openId))] }) : null
		]
	});
}
//#endregion
//#region src/shell/OpenerShell.tsx
var Qd = {
	canSkip: !0,
	custom: null
};
function $d({ boxData: e, descriptor: t, loading: r, machine: i, state: o, exit: u, quantities: d, quickRevealMode: f, isDemoMode: p, errorMessage: m, claimErrorMessage: h, sellErrorMessage: g, prandGenerator: _, onOpenClick: v, onDemoOpenClick: y, onAutoClaimChange: b, onSellBack: x, itemActions: S, onWithdrawItem: C, renderIdle: w, renderResults: T, renderControls: E, settledAction: O, prepaid: k = !1, fairnessPanel: A, className: ee, style: te }) {
	let { strings: M, theme: N, currency: P } = l(), F = Ud(), I = D(o.phase), [re, ie] = ne(Qd), ae = L(() => e ? e.dropTable.filter((e) => e.weight > 0).map((t) => {
		let n = c(t.value, e.priceCents ?? 0);
		return /* @__PURE__ */ B("div", {
			className: Q.idleCard,
			children: /* @__PURE__ */ B("img", {
				className: Q.idleCardImage,
				style: { filter: a(N.rarityRgb, n, "10px", "0.4") },
				src: t.imageUrl,
				alt: t.name,
				loading: "lazy",
				decoding: "async"
			})
		}, t.itemId);
	}) : [], [e, N.rarityRgb]), oe = o.phase === "requesting", se = d.at(-1) ?? 1, ce = k || d.length <= 1 ? [] : d, le = () => e ? /* @__PURE__ */ V("div", {
		className: Q.controls,
		children: [m ? /* @__PURE__ */ B("div", {
			className: Q.errorBanner,
			children: m
		}) : null, /* @__PURE__ */ V("div", {
			className: Q.controlsRow,
			children: [
				k || se <= 1 ? null : /* @__PURE__ */ B("fieldset", {
					className: Q.quantityGroup,
					"aria-label": M.quantity,
					children: ce.map((e) => /* @__PURE__ */ B("button", {
						type: "button",
						className: J(Q.quantityButton, e === o.quantity && Q.quantityButtonActive),
						"aria-pressed": e === o.quantity,
						disabled: oe,
						onClick: () => i.setQuantity(e),
						children: e
					}, e))
				}),
				/* @__PURE__ */ B(zd, {
					demo: p,
					children: /* @__PURE__ */ V("button", {
						type: "button",
						className: Q.primaryButton,
						disabled: oe,
						onClick: v,
						children: [M.open, k ? null : /* @__PURE__ */ V(z, { children: ["\xA0", /* @__PURE__ */ B("span", {
							className: Q.priceTag,
							children: n(e.priceCents * o.quantity, P)
						})] })]
					})
				}),
				f === "toggle" ? /* @__PURE__ */ V("label", {
					className: Q.toggleLabel,
					children: [/* @__PURE__ */ B("input", {
						type: "checkbox",
						checked: o.isQuickReveal,
						onChange: (e) => i.setQuickReveal(e.target.checked)
					}), M.quickReveal]
				}) : null,
				/* @__PURE__ */ B(Gd, {})
			]
		})]
	}) : null, ue = (e) => ({
		boxData: e,
		open: v,
		quantity: o.quantity,
		setQuantity: i.setQuantity,
		quantities: ce,
		quickReveal: f === "toggle" ? {
			on: o.isQuickReveal,
			set: i.setQuickReveal
		} : void 0,
		demo: p,
		demoOpen: y,
		requesting: oe,
		errorMessage: m ?? null,
		prepaid: k,
		sound: F ?? void 0
	}), de = () => i.reset(), fe = p || o.lastResponse !== null && Gu(o.lastResponse), H = Uu(o.entries, t.revealLimit), pe = () => ({
		entries: o.entries,
		claimStatus: o.claimStatus,
		claimCostCents: k ? null : o.pendingClaim?.costCents ?? null,
		claim: () => void i.claim(),
		sellBack: x,
		setAutoClaim: b,
		claimErrorMessage: h ?? null,
		sellErrorMessage: g ?? null,
		claimedItems: o.claimStatus === "claimed" ? o.claim?.items ?? [] : [],
		openAgain: de,
		settledAction: O,
		demo: fe
	}), me = () => u.skipReveal(re.onBeforeSkip), he = (e) => {
		if (!E) return null;
		let t = I === "pre" ? {
			phase: I,
			idle: ue(e)
		} : I === "during" ? {
			phase: I,
			skip: re.canSkip ? me : null
		} : {
			phase: I,
			results: pe()
		};
		return /* @__PURE__ */ B("div", {
			className: Q.hostControls,
			children: E(t)
		});
	}, ge = () => r || !e ? /* @__PURE__ */ B("div", {
		className: Q.loading,
		children: M.loading
	}) : w ? /* @__PURE__ */ B("div", {
		className: Q.hostIdle,
		children: w(ue(e))
	}) : /* @__PURE__ */ V(z, { children: [
		/* @__PURE__ */ V("div", {
			className: Q.idleHero,
			children: [
				e.opener?.logoSvg ? /* @__PURE__ */ B("img", {
					className: Q.brandLogo,
					src: s(e.opener.logoSvg),
					alt: "",
					"aria-hidden": "true"
				}) : e.opener?.brandName?.trim() ? /* @__PURE__ */ B("span", {
					className: Q.brandName,
					children: e.opener.brandName.trim()
				}) : null,
				e.imageUrl ? /* @__PURE__ */ B("img", {
					className: Q.boxImage,
					src: e.imageUrl,
					alt: e.name,
					loading: "eager",
					decoding: "async"
				}) : null,
				/* @__PURE__ */ B("h2", {
					className: Q.boxName,
					children: e.name
				}),
				k ? null : /* @__PURE__ */ B("span", {
					className: Q.boxPrice,
					children: n(e.priceCents, P)
				})
			]
		}),
		/* @__PURE__ */ B("div", {
			className: Q.idleScrollerArea,
			children: /* @__PURE__ */ B(Rd, {
				slots: ae,
				itemWidth: 104,
				gap: 12
			})
		}),
		E ? null : le()
	] }), _e = () => t.ActionRow ? /* @__PURE__ */ B(t.ActionRow, {
		controls: re,
		onSkip: me
	}) : re.canSkip ? /* @__PURE__ */ B("button", {
		type: "button",
		className: Q.secondaryButton,
		onClick: me,
		children: M.skip
	}) : null, ve = (e, n) => /* @__PURE__ */ B(j, {
		fallback: /* @__PURE__ */ B("div", {
			className: Q.openerLoading,
			children: M.loading
		}),
		children: /* @__PURE__ */ B(t.Opener, {
			boxData: e,
			reveal: {
				entries: n?.phase === "pre" ? [] : H,
				quantity: Math.min(H.length || o.quantity, t.revealLimit ?? se),
				isQuickReveal: o.isQuickReveal,
				prandGenerator: _
			},
			onRevealComplete: u.completeReveal,
			onControlsStateChange: ie,
			phase: n?.phase,
			controls: n?.controls
		}, n?.run)
	}), U = () => e ? /* @__PURE__ */ V("div", {
		className: Q.revealArea,
		children: [/* @__PURE__ */ B("div", {
			className: Q.revealStage,
			children: ve(e)
		}), E ? null : /* @__PURE__ */ V("div", {
			className: Q.controlsRow,
			children: [/* @__PURE__ */ B(Gd, {}), _e()]
		})]
	}) : null, ye = (e) => /* @__PURE__ */ B(Zd, {
		showItems: e,
		showActions: !E,
		entries: o.entries,
		claimStatus: o.claimStatus,
		claimCostCents: k ? null : o.pendingClaim?.costCents ?? null,
		claimErrorMessage: h,
		sellErrorMessage: g,
		onClaim: () => void i.claim(),
		onSellBack: x,
		onAutoClaimChange: b,
		onOpenAgain: de,
		settledAction: O,
		claimedItems: o.claimStatus === "claimed" ? o.claim?.items : void 0,
		itemActions: S,
		onWithdrawItem: C,
		buttonClassName: Q.primaryButton,
		secondaryButtonClassName: Q.secondaryButton,
		demo: fe
	}), be = () => T ? /* @__PURE__ */ B(z, { children: T(pe()) }) : ye(!0), xe = R(0), Se = R(I);
	return Se.current === "post" && I === "pre" && (xe.current += 1), Se.current = I, /* @__PURE__ */ V("div", {
		className: J("los-root", Q.root, ee),
		style: te,
		"data-los-host-idle": w && t.stage !== "all" && I === "pre" && e && !r ? "" : void 0,
		"data-los-host-controls": E ? "" : void 0,
		children: [
			t.stage === "all" ? /* @__PURE__ */ B("div", {
				className: Q.phase,
				"data-los-phase": I,
				children: (() => {
					if (r || !e) return /* @__PURE__ */ B("div", {
						className: Q.loading,
						children: M.loading
					});
					let t = E ? null : I === "pre" ? le() : I === "during" ? /* @__PURE__ */ V(z, { children: [/* @__PURE__ */ B(Gd, {}), _e()] }) : T ? T(pe()) : ye(!1);
					return /* @__PURE__ */ B("div", {
						className: J(Q.revealStage, Q.stageOwned),
						children: ve(e, {
							run: xe.current,
							phase: I,
							controls: t
						})
					});
				})()
			}) : /* @__PURE__ */ V("div", {
				className: Q.phase,
				"data-los-phase": I,
				children: [
					I === "pre" && ge(),
					I === "during" && U(),
					I === "post" && be()
				]
			}, I),
			e && !r ? he(e) : null,
			A ? /* @__PURE__ */ B("div", {
				className: Q.fairnessArea,
				children: A
			}) : null
		]
	});
}
//#endregion
//#region src/LootBoxOpener.tsx
function ef(t) {
	let n = Rc(), i = t.publishableKey ?? n.publishableKey, a = t.baseUrl ?? n.baseUrl, o = t.sessionToken ?? n.sessionToken ?? null, s = t.sessionPending ?? n.sessionPending ?? !1, c = t.onSessionExpired ?? n.onSessionExpired, l = t.client ?? n.client, d = t.createClient ?? n.createClient, f = t.theme ?? n.theme, p = t.sounds ?? n.sounds, m = t.soundBaseUrl ?? n.soundBaseUrl, g = t.locale ?? n.locale, _ = t.currency ?? n.currency ?? e, v = L(() => r(g), [g]), y = t.soundEvents ?? n.soundEvents;
	Hl(t.soundMuted !== void 0 || t.soundVolume !== void 0 ? {
		muted: t.soundMuted ?? n.soundMuted,
		volume: t.soundVolume ?? n.soundVolume
	} : null, "opener");
	let b = Gl({
		sounds: p,
		soundBaseUrl: m,
		soundEvents: y
	}), { client: x, error: C } = Nd({
		client: l,
		createClient: d,
		publishableKey: i,
		baseUrl: a,
		sessionToken: o,
		onSessionExpired: c
	}), { box: w, loading: T, error: E } = Od({
		client: x,
		boxId: t.boxId
	}), D = t.opener, O = L(() => w && D ? {
		...w,
		opener: D
	} : w, [w, D]), k = O?.opener?.kind, A = O?.opener?.theme, j = L(() => Dd(k), [k]);
	P(() => j.preload?.(), [j]);
	let ee = L(() => h(u(f, A)), [f, A]), [te, N] = id({
		clientSeed: t.clientSeed,
		onClientSeedChange: t.onClientSeedChange
	}), F = !s && !o && !l, I = t.quantities, re = t.maxQuantity, z = L(() => Hu({
		quantities: I,
		maxQuantity: re,
		descriptor: j
	}), [
		I,
		re,
		j
	]), V = z.at(-1) ?? 1, ie = R({
		client: x,
		box: O,
		clientSeed: te,
		isDemoMode: F
	});
	ie.current = {
		client: x,
		box: O,
		clientSeed: te,
		isDemoMode: F
	};
	let { mutateAsync: ae } = ue({
		mutationKey: [
			"loot-os",
			"open",
			Zu(x)
		],
		mutationFn: (e) => {
			let t = ie.current;
			if (!t.box) throw Error("[loot-os] box not loaded yet");
			if (!t.client) throw Error("[loot-os] no API client configured");
			return t.client.openBox({
				boxId: t.box.id,
				clientSeed: t.clientSeed,
				amount: e.quantity,
				expectedVersion: t.box.version,
				idempotencyKey: e.idempotencyKey
			});
		}
	}, Ju()), oe = R(!1), se = M(async (e) => {
		let t = ie.current;
		if (!t.box) throw Error("[loot-os] box not loaded yet");
		let n = oe.current;
		return oe.current = !1, t.isDemoMode || n ? ld(t.box, e, t.clientSeed) : ae({
			quantity: e,
			idempotencyKey: Qu()
		});
	}, [ae]), ce = R(null), { mutateAsync: le } = ue({
		mutationKey: [
			"loot-os",
			"claim",
			Zu(x)
		],
		mutationFn: async (e) => {
			let t = ie.current;
			if (!t.client) throw Error("[loot-os] no API client configured");
			let { claim: n } = await t.client.claimReveal({
				openGroupId: e.openGroupId,
				expectedPurchaseAmount: e.costCents
			});
			return n;
		}
	}, Ju()), fe = M(async (e) => ie.current.isDemoMode ? ud(e, ce.current?.getState().entries ?? []) : le(e), [le]), { mutateAsync: H } = ue({
		mutationKey: [
			"loot-os",
			"sell-back",
			Zu(x)
		],
		mutationFn: async (e) => {
			let t = ie.current;
			if (!t.client?.sellBackReveal) throw Error("[loot-os] the API client cannot sell back");
			let { sale: n } = await t.client.sellBackReveal({
				openGroupId: e.openGroupId,
				expectedPurchaseAmount: e.costCents
			});
			return n;
		}
	}, Ju()), pe = M(async (e) => ie.current.isDemoMode ? dd(e, ce.current?.getState().entries ?? []) : H(e), [H]), me = t.sellBack !== !1 && (F || typeof x?.sellBackReveal == "function"), [he, ge] = ne({}), _e = R(t);
	_e.current = t;
	let { machine: ve, state: U } = jd({
		openBox: se,
		claimReveal: fe,
		sellBackReveal: pe,
		onBeforeOpen: M((e) => _e.current.onOpenStart?.(e, { demo: ie.current.isDemoMode || oe.current }), []),
		onEvent: M((e) => {
			let t = _e.current;
			switch (e.type) {
				case "open_start":
				case "restored":
				case "reset":
					ge({});
					break;
				case "opened":
					t.onOpened?.(e.response);
					break;
				case "reveal_complete":
					t.onRevealComplete?.(e.response);
					break;
				case "claimed":
					t.onClaimed?.(e.claim);
					break;
				case "sold_back":
					t.onSoldBack?.(e.sale);
					break;
				case "claim_error":
				case "sell_back_error":
				case "error": Ku(e.error) && e.error.code === "insufficient_balance" && t.onInsufficientBalance?.(e.error), t.onError?.(e.error);
			}
		}, []),
		settlesOnReveal: M((e) => Gu(e) && !ie.current.isDemoMode, []),
		maxQuantity: V,
		defaultQuantity: t.defaultQuantity,
		defaultQuickReveal: t.quickReveal === !0
	});
	ce.current = ve;
	let [ye, be] = ne(0);
	P(() => {
		s && be((e) => e + 1);
	}, [s]);
	let xe = de({
		queryKey: [
			"loot-os",
			"unclaimedReveal",
			Zu(x),
			ye
		],
		queryFn: async () => await x?.getUnclaimedReveal?.() ?? null,
		enabled: !s && !F && !!x?.getUnclaimedReveal,
		staleTime: 0,
		gcTime: 0
	}, Ju()), Se = R(!1);
	P(() => {
		let e = xe.data;
		Se.current || !e || (Se.current = !0, ve.restore(e));
	}, [xe.data, ve]);
	let W = s || xe.isLoading;
	P(() => {
		typeof t.quickReveal == "boolean" && ve.setQuickReveal(t.quickReveal);
	}, [ve, t.quickReveal]);
	let Ce = L(() => Wu({
		revealExit: j.revealExit,
		isQuickReveal: U.isQuickReveal,
		actions: {
			finishReveal: () => ve.completeReveal(),
			skipReveal: () => ve.skip()
		}
	}), [
		ve,
		U.isQuickReveal,
		j
	]);
	P(() => {
		U.phase !== "revealing" && Ce.cancel();
	}, [U.phase, Ce]), P(() => () => Ce.cancel(), [Ce]);
	let we = M(() => {
		b.unlock(), ve.open();
	}, [ve, b]), Te = M(() => {
		b.unlock(), oe.current = !0, ve.open().finally(() => {
			oe.current = !1;
		});
	}, [ve, b]), Ee = !F && !s && !t.prepaid, De = M(() => void ve.sellBack(), [ve]), Oe = M((e) => {
		ge((t) => ({
			...t,
			[e.inventoryItemId]: { status: "withdrawn" }
		})), _e.current.onWithdrawRequested?.(e);
	}, []), ke = U.error ?? E ?? C, Ae = ke ? Ku(ke) ? ke.code === "insufficient_balance" ? v.errorInsufficientBalance : ke.code === "account_locked" ? v.errorAccountLocked : ke.message || v.errorGeneric : v.errorGeneric : null, je = U.claimError ? Ku(U.claimError) && U.claimError.code === "insufficient_balance" ? v.errorInsufficientBalance : Ku(U.claimError) && U.claimError.code === "account_locked" ? v.errorAccountLocked : v.errorClaimFailed : null, Me = U.sellError ? Ku(U.sellError) && U.sellError.code === "insufficient_balance" ? v.errorInsufficientBalance : Ku(U.sellError) && U.sellError.code === "account_locked" ? v.errorAccountLocked : v.errorSellBackFailed : null, Ne = !F && typeof t.onWithdrawRequested == "function", Pe = !F && typeof x?.updateMySettings == "function", { mutate: G } = ue({
		mutationKey: [
			"loot-os",
			"settings",
			Zu(x)
		],
		mutationFn: async (e) => await ie.current.client?.updateMySettings?.(e) ?? null
	}, Ju()), Fe = M((e) => {
		G({ autoClaim: e });
	}, [G]), Ie = L(() => ({
		strings: v,
		theme: ee,
		sounds: b,
		onSoundMutedChange: n.onSoundMutedChange,
		currency: _,
		renderItemLabel: t.renderItemLabel
	}), [
		v,
		ee,
		b,
		n.onSoundMutedChange,
		_,
		t.renderItemLabel
	]), Le = t.showFairness ?? !0 ? /* @__PURE__ */ B(od, {
		client: x,
		lastResponse: U.lastResponse,
		clientSeed: te,
		onClientSeedChange: N,
		locked: U.phase === "revealing" || U.phase === "requesting"
	}) : null;
	return /* @__PURE__ */ B(S.Provider, {
		value: Ie,
		children: /* @__PURE__ */ B($d, {
			boxData: O,
			descriptor: j,
			loading: T || W,
			machine: ve,
			state: U,
			exit: Ce,
			quantities: z,
			quickRevealMode: t.quickReveal ?? !1,
			isDemoMode: F,
			errorMessage: Ae,
			claimErrorMessage: je,
			sellErrorMessage: Me,
			onOpenClick: we,
			onDemoOpenClick: Ee ? Te : void 0,
			onSellBack: me ? De : void 0,
			itemActions: he,
			onWithdrawItem: Ne ? Oe : void 0,
			onAutoClaimChange: Pe ? Fe : void 0,
			renderIdle: t.renderIdle,
			renderResults: t.renderResults,
			renderControls: t.renderControls,
			settledAction: t.settledAction,
			prepaid: t.prepaid,
			fairnessPanel: Le,
			className: t.className,
			style: {
				...ee.cssVars,
				...t.style
			}
		})
	});
}
//#endregion
//#region src/react/LootProvider.tsx
function tf({ children: e, ...t }) {
	Hl(t.soundMuted !== void 0 || t.soundVolume !== void 0 ? {
		muted: t.soundMuted,
		volume: t.soundVolume
	} : null, "provider");
	let n = L(() => t, [
		t.publishableKey,
		t.baseUrl,
		t.sessionToken,
		t.sessionPending,
		t.onSessionExpired,
		t.client,
		t.createClient,
		t.theme,
		t.sounds,
		t.soundBaseUrl,
		t.soundEvents,
		t.soundMuted,
		t.soundVolume,
		t.onSoundMutedChange,
		t.locale,
		t.currency
	]);
	return /* @__PURE__ */ B(Lc.Provider, {
		value: n,
		children: e
	});
}
//#endregion
//#region src/sounds/SoundPlayer.ts
var nf = class {
	context = null;
	gainNode = null;
	buffers = /* @__PURE__ */ new Map();
	volumeValue = 1;
	get volume() {
		return this.volumeValue;
	}
	setVolume(e) {
		this.volumeValue = Math.max(0, Math.min(1, e)), this.gainNode && (this.gainNode.gain.value = this.volumeValue);
	}
	ensureContext() {
		if (this.context) return this.context;
		if (typeof window > "u") return null;
		let e = window.AudioContext ?? window.webkitAudioContext;
		if (!e) return null;
		try {
			this.context = new e(), this.gainNode = this.context.createGain(), this.gainNode.gain.value = this.volumeValue, this.gainNode.connect(this.context.destination);
		} catch {
			this.context = null, this.gainNode = null;
		}
		return this.context;
	}
	unlock() {
		let e = this.ensureContext();
		e && e.state === "suspended" && e.resume().catch(() => {});
	}
	preload(e) {
		this.getBuffer(e);
	}
	getBuffer(e) {
		let t = this.buffers.get(e);
		if (t) return t;
		let n = this.ensureContext(), r = n ? fetch(e).then((e) => e.ok ? e.arrayBuffer() : null).then((e) => e ? n.decodeAudioData(e) : null).catch(() => null) : Promise.resolve(null);
		return this.buffers.set(e, r), r;
	}
	play(e, t) {
		if (!e) return;
		let n = this.ensureContext();
		!n || !this.gainNode || this.getBuffer(e).then((e) => {
			if (!(!e || !this.gainNode)) try {
				let r = n.createBufferSource();
				if (r.buffer = e, t?.volume !== void 0) {
					let e = n.createGain();
					e.gain.value = Math.max(0, Math.min(1, t.volume)), r.connect(e), e.connect(this.gainNode);
				} else r.connect(this.gainNode);
				r.start();
			} catch {}
		});
	}
	dispose() {
		this.buffers.clear(), this.context?.close().catch(() => {}), this.context = null, this.gainNode = null;
	}
}, rf = [
	"liveBreak.announcement.band",
	"liveBreak.announcement.text",
	"liveBreak.announcement.land",
	"liveBreak.card.bling",
	"liveBreak.card.chime",
	"liveBreak.card.coin",
	"liveBreak.host.bigHit"
], af = {
	"liveBreak.announcement.band": .5,
	"liveBreak.announcement.text": .5,
	"liveBreak.announcement.land": .5,
	"liveBreak.card.bling": .2,
	"liveBreak.card.chime": .15,
	"liveBreak.card.coin": .5,
	"liveBreak.host.bigHit": .5
}, of = 150, sf = 60;
function cf(e, t) {
	let n = t > 0 ? Math.max(0, e) / t : 0, r = Math.min(26, Math.max(6, Math.round(6 + 4 * Math.log2(1 + n))));
	return Math.min(3, 1 + Math.floor((r - 6) / 7));
}
var $ = x.bus({
	level: .9,
	compressor: {
		threshold: -14,
		knee: 6,
		ratio: 3,
		attack: .003,
		release: .2
	},
	reverb: {
		seconds: 1.6,
		level: .4
	}
}), lf = (e, t) => e + Math.random() * (t - e);
function uf(e, t, n, r = 0, i = .3) {
	for (let [a, o, s] of [
		[
			1,
			1,
			1
		],
		[
			2.76,
			.45,
			.6
		],
		[
			5.4,
			.22,
			.35
		],
		[
			8.93,
			.1,
			.2
		]
	]) $.tone({
		freq: e * a,
		decay: n * s,
		vol: t * o,
		when: r,
		wet: i
	});
}
var df = {
	"liveBreak.announcement.band": (e) => {
		$.noise({
			freq: 6200,
			to: 1800,
			glide: 1.1,
			q: .9,
			attack: .18,
			decay: 1.25,
			vol: e * .55,
			wet: .35
		}), $.noise({
			type: "highpass",
			freq: 7e3,
			attack: .12,
			decay: .35,
			vol: e * .18
		}), $.tone({
			type: "sawtooth",
			freq: 220,
			to: 660,
			glide: .25,
			attack: .15,
			decay: .5,
			vol: e * .05,
			wet: .3
		});
	},
	"liveBreak.announcement.text": (e) => {
		$.noise({
			freq: 1800,
			to: 6500,
			glide: .5,
			q: 1.4,
			attack: .45,
			decay: .55,
			vol: e * .4,
			wet: .25
		});
		for (let t = 0; t < 9; t++) $.noise({
			type: "highpass",
			freq: lf(4500, 8500),
			decay: lf(.012, .03),
			vol: e * lf(.12, .28) * (.5 + t / 12),
			when: .06 + t * .06 + lf(-.015, .015),
			pan: lf(-.6, .6)
		});
		for (let [t, n] of [
			[0, .38],
			[4, .46],
			[7, .55]
		]) $.tone({
			freq: g(88 + t),
			type: "triangle",
			decay: .28,
			vol: e * .08,
			when: n,
			wet: .4
		});
	},
	"liveBreak.announcement.land": (e) => {
		$.tone({
			freq: 150,
			to: 42,
			glide: .18,
			decay: .75,
			vol: e * .95,
			wet: .15
		}), $.noise({
			type: "lowpass",
			freq: 2200,
			to: 260,
			glide: .4,
			decay: .45,
			vol: e * .5,
			wet: .2
		}), $.noise({
			type: "highpass",
			freq: 2400,
			decay: .018,
			vol: e * .35
		}), $.tone({
			type: "triangle",
			freq: 320,
			to: 110,
			glide: .12,
			decay: .16,
			vol: e * .25
		});
	},
	"liveBreak.card.bling": (e) => {
		for (let [t, n] of [
			[6400, 0],
			[7900, .02],
			[9300, .045],
			[7100, .08]
		]) $.tone({
			freq: t * lf(.98, 1.02),
			decay: .42,
			vol: e * .35,
			when: n,
			pan: lf(-.4, .4),
			wet: .35
		});
		$.tone({
			freq: 2300,
			type: "triangle",
			decay: .8,
			vol: e * .4,
			wet: .3
		}), $.noise({
			type: "highpass",
			freq: 6e3,
			decay: .12,
			vol: e * .2
		});
	},
	"liveBreak.card.chime": (e) => {
		uf(2480, e * .9, 2.6, 0, .4);
	},
	"liveBreak.card.coin": (e) => {
		let t = lf(.96, 1.05);
		$.tone({
			freq: 4200 * t,
			decay: .16,
			vol: e * .45,
			wet: .2
		}), $.tone({
			freq: 6900 * t,
			decay: .11,
			vol: e * .3,
			when: .012,
			wet: .2
		}), $.noise({
			type: "highpass",
			freq: 7500,
			decay: .03,
			vol: e * .25
		});
	},
	"liveBreak.host.bigHit": (e) => {
		$.noise({
			type: "highpass",
			freq: 6e3,
			to: 9500,
			glide: 1,
			attack: .2,
			decay: .9,
			vol: e * .3,
			wet: .5
		}), $.tone({
			freq: 70,
			to: 38,
			glide: .5,
			decay: .9,
			vol: e * .5
		});
		let t = [
			0,
			4,
			7,
			12,
			16,
			19,
			24
		];
		t.forEach((t, n) => {
			$.tone({
				freq: g(76 + t),
				type: "triangle",
				decay: .7,
				vol: e * .12,
				when: .08 + n * .06,
				wet: .45
			});
		});
		for (let n = 0; n < 10; n++) $.tone({
			freq: g(96 + (t[n % t.length] ?? 0)),
			decay: .3,
			vol: e * .05,
			when: .2 + n * .07 + lf(0, .03),
			pan: lf(-.7, .7),
			wet: .5
		});
		$.noise({
			type: "highpass",
			freq: 8800,
			attack: .1,
			decay: .5,
			vol: e * .12,
			when: 1.7,
			wet: .6
		});
	}
}, ff = new class {
	recorded = {};
	player = null;
	timers = /* @__PURE__ */ new Set();
	get muted() {
		return x.isMuted;
	}
	setMuted(e) {
		x.setMuted(e);
	}
	setVolume(e) {
		x.setVolume(e);
	}
	unlock() {
		x.unlock(), Object.keys(this.recorded).length > 0 && this.recordedPlayer().unlock();
	}
	useRecorded(e) {
		this.recorded = { ...e };
		let t = this.recordedPlayer();
		for (let e of Object.values(this.recorded)) e && t.preload(e);
	}
	play(e, { delayMs: t = 0 } = {}) {
		if (t > 0) {
			this.later(t, () => this.play(e));
			return;
		}
		if (x.isMuted) return;
		let n = af[e], r = this.recorded[e];
		if (r) {
			this.recordedPlayer().play(r, { volume: n });
			return;
		}
		try {
			df[e](n);
		} catch {}
	}
	playCardImpact({ valueCents: e, priceCents: t, delayMs: n = 0 }) {
		if (n > 0) {
			this.later(n, () => this.playCardImpact({
				valueCents: e,
				priceCents: t
			}));
			return;
		}
		this.play("liveBreak.card.bling"), this.play("liveBreak.card.chime"), this.play("liveBreak.card.coin");
		let r = cf(e, t);
		for (let e = 1; e <= r; e++) {
			let t = (Math.random() * 2 - 1) * 60;
			this.play("liveBreak.card.coin", { delayMs: Math.max(1, e * 150 + t) });
		}
	}
	cancel() {
		for (let e of this.timers) clearTimeout(e);
		this.timers.clear();
	}
	later(e, t) {
		let n = setTimeout(() => {
			this.timers.delete(n), t();
		}, e);
		this.timers.add(n);
	}
	recordedPlayer() {
		return this.player ||= new nf(), this.player;
	}
}();
//#endregion
export { Kl as BATTLE_OPENER_COMPACT_BREAKPOINT_PX, mu as BATTLE_PLAYER_COUNTS, _u as BATTLE_REEL_TIMINGS, gu as BATTLE_SETTLE_MS, ql as BATTLE_SOLO_COMPACT_BREAKPOINT_PX, hu as BATTLE_SPIN_START_DELAY_MS, pu as BATTLE_START_COUNTDOWN_MS, Pc as BattleLaneReel, Nu as BattleOpener, Fu as BattleResultsGrid, Su as BattleRound, Ru as BattleStartingOverlay, $u as CLIENT_SEED_STORAGE_KEY, e as DEFAULT_CURRENCY, Ed as DEFAULT_OPENER_KIND, Vu as DEFAULT_QUANTITIES, f as DEFAULT_RARITY_RAIL_HEX, d as DEFAULT_RARITY_RGB, T as DEFAULT_STRINGS, sf as LIVE_BREAK_COIN_DROP_JITTER_MS, of as LIVE_BREAK_COIN_DROP_SPACING_MS, rf as LIVE_BREAK_SOUND_IDS, af as LIVE_BREAK_SOUND_LEVELS, ef as LootBoxOpener, tf as LootProvider, ed as MAX_CLIENT_SEED_LENGTH, Qs as MOTION_ANIMATION_DURATION, rc as MOTION_ENDING_ITEM_IDX, $s as MOTION_QUICK_ANIMATION_DURATION, tc as MOTION_QUICK_STAGGER_DELAY, ic as MOTION_REVEAL_LINGER_MS, Zs as MOTION_SECOND_PHASE_ANIMATION_DURATION, ec as MOTION_STAGGER_DELAY, nc as MOTION_STARTING_ITEM_IDX, Td as OPENER_DESCRIPTORS, od as ProvablyFairPanel, _ as RESULT_RANGE, zu as REVEAL_START_DELAY_MS, bu as battleLaneLandMs, lu as battleOpenerLayout, p as battleReelGenerator, vu as battleRevealIntervalMs, yu as battleRoundRevealMs, uu as battleSoloLayout, xu as battleSpinItems, Bu as createOpenerMachine, Wu as createOpenerRevealExit, w as currencyFractionDigits, i as currencyUnitName, O as defineOpenerDescriptor, n as formatAmount, t as formatAmountWithUnit, oc as generateItemWheel, ac as generateRandomItems, b as getItemChance, c as getItemRarity, D as getOpenerPhase, a as getRarityGlowFilter, C as getRarityGlowFilterByRarity, E as getSpinnerRailColor, o as hashSeed, Gu as isDemoOpenResponse, Ku as isLootApiErrorLike, cf as liveBreakExtraCoinDrops, ff as liveBreakSounds, u as mergeLootTheme, cu as normalizeBattlePlayerCount, A as registerOpener, v as resolveKindTokens, Dd as resolveOpenerDescriptor, Ll as resolveOpenerSoundUrls, r as resolveStrings, h as resolveTheme, m as selectFromDropTable, Mc as useBattleLane, id as useClientSeed, Od as useLootBox, Rc as useLootProviderConfig, kd as useOpenBox, jd as useOpenerMachine, Ad as useOpenerMachineState, Gl as useOpenerSounds };

//# sourceMappingURL=index.js.map